class AAHeadquartersClients {
 constructor(root) {
  this.root = root;
  this.clients = [];
  this.archivedClients = [];
 this.activeClientId = null;
this.editingClientId = null;
this.addingCatalogClientId = null;
this.editingCatalogId = null;
this.activeCatalogSection = 'history';
this.archivedCatalogs = [];
this.archivedCatalogsClientId = null;
this.showArchivedCatalogs = false;
this.catalogDeleteAdmin = false;
this.catalogDeleteMode = false;
this.catalogDeleteSelected = new Set();
this.catalogDeleteYear = 'all';
this.catalogDeletePreview = null;
this.clientCoopReports = [];
this.clientCoopReportsLoading = false;
this.coopReportPreviewId = null;
this.coopReportPreview = null;
this.coopReportPreview = null;

this.clientPlaybooks = [];
this.clientPlaybooksLoading = false;

this.clientPackageServices = [];
this.serviceCatalog = [];
this.clientPackageLoading = false;
this.editingPackageClientId = null;
this.packageLibraryOpen = false;

this.clientTaskAnchors = [];
this.sharedTaskAnchors = [];
this.clientProductionSettings = null;
this.clientTaskAnchorsLoading = false;
this.sharedTaskAnchorsLoading = false;
this.taskAnchorEditorOpen = false;
this.taskAnchorEditorScope = 'client';
this.editingTaskAnchorId = null;
this.editingSharedTaskAnchorId = null;
this.taskTypes = [];

this.clientAccessRequirements = [];
this.accessPlatformCatalog = [];
this.clientAccessLoading = false;
this.editingAccessClientId = null;

this.clientBrandAssets = [];
this.clientVendorBrands = [];
this.vendorLibrary = [];
this.clientBrandLoading = false;
this.editingBrandClientId = null;
this.editingBrandFocus = null;

this.clientContracts = [];
this.clientContractsLoading = false;
this.editingContractClientId = null;

this.waveBusinesses = [];
this.waveConnection = null;
this.waveConnectionLoading = false;
this.waveConnectionError = '';

this.waveCustomers = [];
this.waveCustomerLoading = false;
this.waveCustomerError = '';
this.waveClientMapping = null;
this.waveCustomerPickerOpen = false;

this.waveInvoices = [];
this.waveInvoiceLoading = false;
this.waveInvoiceError = '';
this.waveInvoiceTested = false;

this.clientAssignmentEnabled = false;
this.clientCodeEnabled = false;
this.internalTeamMembers = [];
this.clientPrimaryAssignments = {};

const initialParams =
  new URLSearchParams(
    window.location.search
  );

const requestedTab =
  initialParams.get('aa_tab');

this.activeClientTab =
  [
    'overview',
    'planning',
    'catalogs',
    'account'
  ].includes(requestedTab)
    ? requestedTab
    : 'overview';

const requestedSection =
  initialParams.get('aa_section') || '';

this.activePlanningSection =
  this.activeClientTab === 'planning' &&
  [
    'package',
    'rules',
    'anchors',
    'vendors',
    'playbooks',
    'identity'
  ].includes(requestedSection)
    ? requestedSection
    : 'package';

this.activeAccountSection =
  this.activeClientTab === 'account' &&
  [
    'agreements',
    'access',
    'team',
    'brand',
    'reminders'
  ].includes(requestedSection)
    ? requestedSection
    : 'agreements';

this.clientSearch = '';

this.init();
}

  async init() {
  await this.loadClients();
  await Promise.all([
    this.loadActiveClientPlaybooks(),
    this.loadActiveClientPackage(),
    this.loadActiveClientTaskAnchors(),
    this.loadActiveClientAccess(),
    this.loadActiveClientBrandWorkspace(),
    this.loadActiveClientContracts(),
    this.loadWaveConnection(),
    this.loadActiveClientWaveMapping(),
    this.loadCatalogDeletionPermissions()
  ]);

  this.bindClientActions();
  this.bindTaskAnchorActions();
  this.bindNewClientForm();
  this.render();
}

  async loadCatalogDeletionPermissions() {
    try {
      this.catalogDeleteAdmin = await window.AASupabaseClient
        ?.canPermanentlyDeleteCatalogs?.() === true;
    } catch (error) {
      console.warn('Catalog deletion permission check failed:', error);
      this.catalogDeleteAdmin = false;
    }
  }

  resetCatalogDeletion() {
    this.catalogDeleteMode = false;
    this.catalogDeleteSelected.clear();
    this.catalogDeletePreview = null;
    this.catalogDeleteYear = 'all';
  }

  escapeHtml(value = '') {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  async loadClientCodeFoundation() {
    this.clientCodeEnabled = false;

    if (
      !window.AASupabaseClient
        ?.supportsClientCodes
    ) {
      return;
    }

    try {
      this.clientCodeEnabled =
        await window.AASupabaseClient
          .supportsClientCodes();
    } catch (error) {
      console.warn(
        'Client code foundation is not available yet:',
        error
      );
    }
  }

  async loadAssignmentFoundation() {
    this.clientAssignmentEnabled = false;
    this.internalTeamMembers = [];
    this.clientPrimaryAssignments = {};

    if (
      !window.AASupabaseClient?.supportsClientAssignments ||
      !window.AASupabaseClient?.getInternalTeamMembers ||
      !window.AASupabaseClient?.getClientPrimaryAssignments
    ) {
      return;
    }

    try {
      const supported =
        await window.AASupabaseClient.supportsClientAssignments();

      if (!supported) {
        return;
      }

      const [teamMembers, assignments] =
        await Promise.all([
          window.AASupabaseClient.getInternalTeamMembers(),
          window.AASupabaseClient.getClientPrimaryAssignments()
        ]);

      this.internalTeamMembers =
        Array.isArray(teamMembers)
          ? teamMembers
          : [];

      this.clientPrimaryAssignments =
        (assignments || []).reduce(
          (map, assignment) => {
            map[String(assignment.id)] =
              assignment.primary_team_member_id || '';
            return map;
          },
          {}
        );

      this.clientAssignmentEnabled = true;
    } catch (error) {
      console.warn(
        'Client assignment foundation is not available yet:',
        error
      );
    }
  }

  getTeamMemberName(teamMemberId) {
    if (!teamMemberId) {
      return 'Unassigned';
    }

    const member =
      this.internalTeamMembers.find(
        (item) =>
          String(item.id) ===
          String(teamMemberId)
      );

    return (
      member?.display_name ||
      member?.aa_roles?.display_name ||
      'Team Member'
    );
  }

  showStatusMessage(message, type = 'success') {
  let status = this.root.querySelector('[data-aa-client-status]');

  if (!status) {
    status = document.createElement('div');
    status.setAttribute('data-aa-client-status', '');
    status.className = 'aa-client-status-message';

    const container = this.root.querySelector('[data-aa-clients-list]');
    if (container?.parentNode) {
      container.parentNode.insertBefore(status, container);
    }
  }

  status.textContent = message;
  status.dataset.statusType = type;

  window.clearTimeout(this.statusMessageTimer);

  this.statusMessageTimer = window.setTimeout(() => {
    if (status) {
      status.textContent = '';
    }
  }, 3000);
}

  getClientDefaults() {
    return {
      id: '',
      business_name: '',
      client_code: '',
      primary_contact: '',
      email: '',
      phone: '',
      mailing_address: '',
      client_type: 'Monthly Marketing',
      current_package: 'Monthly Marketing',
      active_status: 'Pending Setup',
      account_status: 'Pending Setup',
      invoice_status: 'Current',
      workspace_status: 'Not Created',
      contract_status: 'No Contract',
      monthly_due_day: '15',
      reminder_schedule: '5 & 2 days',
      reminder_email_template: 'Standard Playbook Reminder',
      reminder_status: 'Not Scheduled',
      next_scheduled_reminder: '—',
      notes: '',
      services: [],
      brands: [],
      access: [],
      assigned_templates: [],
      primary_team_member_id: ''
    };
  }

  normalizeClient(client = {}) {
return {
...this.getClientDefaults(),
...client,
id: client.id || '',
business_name: client.business_name || 'Unnamed Client'
};
}

 async loadClients() {
  const container = this.root.querySelector('[data-aa-clients-list]');
  const previousClientId = this.activeClientId;

  // Only show the loading placeholder on the first load. Keep existing content visible on refresh.
  if (container && !this.clients.length) {
    container.innerHTML = '<p class="aa-headquarters-loading">Loading clients...</p>';
  }

  try {
    if (!window.AASupabaseClient?.getClients) {
      throw new Error('AASupabaseClient.getClients() is not available.');
    }

    // These independent reads can run together. Assignments finish before
    // client records are normalized below, so the displayed data is unchanged.
    const [clientRows] = await Promise.all([
      window.AASupabaseClient.getClients(),
      this.loadClientCodeFoundation(),
      this.loadAssignmentFoundation()
    ]);

    this.archivedClients = (clientRows || []).filter(
      (client) =>
        String(client.active_status || '')
          .trim()
          .toLowerCase() === 'archived'
    );

    this.clients = await Promise.all(
      (clientRows || [])
        .filter(
          (client) =>
            String(client.active_status || '')
              .trim()
              .toLowerCase() !== 'archived'
        )
        .map(async (client) => {
          const [
            configurationResult,
            templatesResult,
            catalogsResult
          ] = await Promise.allSettled([
            window.AASupabaseClient
              .getClientConfiguration({
                clientId: client.id
              }),
            window.AASupabaseClient
              .getClientTemplateAssignments({
                clientId: client.id
              }),
            window.AASupabaseClient
              .getCatalogRecords({
                clientId: client.id
              })
          ]);

          const configuration =
            configurationResult.status === 'fulfilled'
              ? configurationResult.value
              : {};

          const assignedTemplates =
            templatesResult.status === 'fulfilled'
              ? templatesResult.value
              : [];

          const catalogRecords =
            catalogsResult.status === 'fulfilled'
              ? catalogsResult.value
              : [];

          if (configurationResult.status === 'rejected') {
            console.warn(
              'Client configuration could not be loaded:',
              client.business_name,
              configurationResult.reason
            );
          }

          if (templatesResult.status === 'rejected') {
            console.warn(
              'Client template assignments could not be loaded:',
              client.business_name,
              templatesResult.reason
            );
          }

          if (catalogsResult.status === 'rejected') {
            console.warn(
              'Client catalog records could not be loaded:',
              client.business_name,
              catalogsResult.reason
            );
          }

          return this.normalizeClient({
            ...client,
            ...(configuration || {}),
            id: client.id,
            business_name: client.business_name,
            active_status:
              client.active_status ||
              configuration?.active_status ||
              'Pending Setup',
            account_status:
              client.account_status ||
              configuration?.account_status ||
              'Pending Setup',
            invoice_status:
              client.invoice_status ||
              configuration?.invoice_status ||
              'Current',
            services:
              Array.isArray(configuration?.services)
                ? configuration.services
                : [],
            brands:
              Array.isArray(configuration?.brands)
                ? configuration.brands
                : [],
            access:
              Array.isArray(configuration?.access)
                ? configuration.access
                : [],
            notes:
              configuration?.internal_notes ||
              configuration?.notes ||
              '',
            primary_team_member_id:
              this.clientPrimaryAssignments[
                String(client.id)
              ] || '',
            assigned_templates:
              assignedTemplates || [],
            catalog_records:
              catalogRecords || []
          });
        })
    );

    const requestedClientId =
  new URLSearchParams(window.location.search)
    .get('aa_client');

const requestedClientExists =
  this.clients.some(
    (client) =>
      String(client.id) ===
      String(requestedClientId)
  );

const selectedClientStillExists =
  this.clients.some(
    (client) =>
      String(client.id) ===
      String(previousClientId)
  );

if (requestedClientExists) {
  this.activeClientId =
    requestedClientId;
} else if (selectedClientStillExists) {
  this.activeClientId =
    previousClientId;
} else {
  this.activeClientId = null;
}

this.rememberActiveClientInUrl();

    this.render();
  } catch (error) {
    console.error('Error loading Headquarters clients:', error);

    this.clients = [];
    this.activeClientId = null;

    if (container) {
      container.innerHTML = `
        <div class="aa-client-load-error">
          <p><strong>Supabase request failed.</strong></p>
          <p>${this.escapeHtml(error?.message || 'Unable to load clients.')}</p>
        </div>
      `;
    }
   }
}

getActiveClient() {
  return this.clients.find(
    (client) =>
      String(client.id) === String(this.activeClientId)
  );
}

rememberActiveClientInUrl() {
  const url =
    new URL(window.location.href);

  if (this.activeClientId) {
    url.searchParams.set(
      'aa_client',
      this.activeClientId
    );
  } else {
    url.searchParams.delete(
      'aa_client'
    );
  }

  if (
    this.activeClientTab &&
    this.activeClientTab !==
      'overview'
  ) {
    url.searchParams.set(
      'aa_tab',
      this.activeClientTab
    );
  } else {
    url.searchParams.delete(
      'aa_tab'
    );
  }

  let section = '';

  if (
    this.activeClientTab ===
      'planning'
  ) {
    section =
      this.activePlanningSection ||
      'package';
  }

  if (
    this.activeClientTab ===
      'account'
  ) {
    section =
      this.activeAccountSection ||
      'agreements';
  }

  if (section) {
    url.searchParams.set(
      'aa_section',
      section
    );
  } else {
    url.searchParams.delete(
      'aa_section'
    );
  }

  window.history.replaceState(
    {},
    '',
    `${url.pathname}${url.search}${url.hash}`
  );
}

async loadActiveClientPlaybooks() {
  const client = this.getActiveClient();

  this.clientPlaybooks = [];

  if (
    !client?.id ||
    !window.AAPlaybookService?.getPlaybooksByClient
  ) {
    return;
  }

  this.clientPlaybooksLoading = true;

  try {
    const playbooks =
      await window.AAPlaybookService.getPlaybooksByClient({
        clientId: client.id
      });

    this.clientPlaybooks =
      Array.isArray(playbooks)
        ? playbooks
        : [];
  } catch (error) {
    console.error(
      'Unable to load client Playbooks:',
      error
    );

    this.clientPlaybooks = [];
  } finally {
    this.clientPlaybooksLoading = false;
  }
}

async loadActiveClientCoopReports() {
  const client = this.getActiveClient();

  this.clientCoopReports = [];
  this.coopReportPreviewId = null;
this.coopReportPreview = null;

  if (
    !client?.id ||
    !window.AASupabaseClient
      ?.getCoopReports
  ) {
    return;
  }

  this.clientCoopReportsLoading = true;

  try {
    const reports =
      await window.AASupabaseClient
        .getCoopReports({
          clientId: client.id
        });

    this.clientCoopReports =
      Array.isArray(reports)
        ? reports
        : [];
  } catch (error) {
    console.error(
      'Unable to load Co-op reports:',
      error
    );

    this.clientCoopReports = [];
  } finally {
    this.clientCoopReportsLoading = false;
  }
}

async loadActiveClientPackage() {
  const client = this.getActiveClient();

  this.clientPackageServices = [];
  this.serviceCatalog = [];

  if (
    !client?.id ||
    !window.AAPlaybookService
      ?.getClientMarketingPackage ||
    !window.AAPlaybookService
      ?.getServiceCatalog
  ) {
    return;
  }

  this.clientPackageLoading = true;

  try {
    const [catalog, packageResult] =
      await Promise.all([
        window.AAPlaybookService
          .getServiceCatalog(),
        window.AAPlaybookService
          .getClientMarketingPackage({
            clientId: client.id
          })
      ]);

    this.serviceCatalog =
      Array.isArray(catalog)
        ? catalog
        : [];

    this.clientPackageServices =
      Array.isArray(
        packageResult?.services
      )
        ? packageResult.services
        : [];

    const activeServiceIds =
      new Set(
        this.serviceCatalog.map(
          (service) => String(service.id)
        )
      );

    const retiredSelected =
      this.clientPackageServices
        .filter(
          (service) =>
            service.serviceId &&
            !activeServiceIds.has(
              String(service.serviceId)
            )
        )
        .map((service, index) => ({
          id: service.serviceId,
          name: service.name,
          description:
            'This service has been removed from the active package library.',
          category:
            service.category || 'Retired',
          defaultUnitLabel:
            service.unit || 'per month',
          sortOrder: 10000 + index,
          billingType: 'included',
          retired: true
        }));

    this.serviceCatalog = [
      ...this.serviceCatalog,
      ...retiredSelected
    ];
  } catch (error) {
    console.error(
      'Unable to load client marketing package:',
      error
    );

    this.clientPackageServices = [];
    this.serviceCatalog = [];
  } finally {
    this.clientPackageLoading = false;
  }
}

async loadActiveClientTaskAnchors() {
  const client = this.getActiveClient();

  this.clientTaskAnchors = [];
  this.sharedTaskAnchors = [];
  this.clientProductionSettings = null;
  this.taskTypes = [];

  if (
    !client?.id ||
    !window.AASupabaseClient
      ?.getClientTaskAnchors ||
    !window.AASupabaseClient
      ?.getClientProductionSettings
  ) {
    return;
  }

  this.clientTaskAnchorsLoading = true;
  this.sharedTaskAnchorsLoading = true;

  try {
    const [
      anchors,
      sharedAnchors,
      settings,
      taskTypes
    ] = await Promise.all([
      window.AASupabaseClient
        .getClientTaskAnchors({
          clientId: client.id,
          includeInactive: true
        }),
      window.AASupabaseClient
        .getSharedTaskAnchors?.({
          includeInactive: true
        }) ||
        Promise.resolve([]),
      window.AASupabaseClient
        .getClientProductionSettings({
          clientId: client.id
        }),
      window.AASupabaseClient
        .getTaskTypes?.() ||
        Promise.resolve([])
    ]);

    this.clientTaskAnchors =
      Array.isArray(anchors)
        ? anchors
        : [];

    this.sharedTaskAnchors =
      Array.isArray(sharedAnchors)
        ? sharedAnchors
        : [];

    this.clientProductionSettings =
      settings || {
        clientId: client.id,
        preferredEmailWeekday: '',
        preferredEmailWeekdays: [],
        preferredEmailTime: '',
        doNotPromote: '',
        priorityPromotions: '',
        standingRules: ''
      };

    this.taskTypes =
      Array.isArray(taskTypes)
        ? taskTypes
        : [];
  } catch (error) {
    console.error(
      'Unable to load Task Anchors:',
      error
    );

    this.clientTaskAnchors = [];
    this.sharedTaskAnchors = [];
    this.clientProductionSettings = {
      clientId: client.id,
      preferredEmailWeekday: '',
      preferredEmailTime: '',
      standingRules: ''
    };
    this.taskTypes = [];
  } finally {
    this.clientTaskAnchorsLoading = false;
    this.sharedTaskAnchorsLoading = false;
  }
}

async loadActiveClientAccess() {
  const client = this.getActiveClient();

  this.clientAccessRequirements = [];
  this.accessPlatformCatalog = [];

  if (
    !client?.id ||
    !window.AAPlaybookService
      ?.getClientAccessRequirements ||
    !window.AAPlaybookService
      ?.getAccessPlatformCatalog
  ) {
    return;
  }

  this.clientAccessLoading = true;

  try {
    const [platforms, access] =
      await Promise.all([
        window.AAPlaybookService
          .getAccessPlatformCatalog(),
        window.AAPlaybookService
          .getClientAccessRequirements({
            clientId: client.id
          })
      ]);

    this.accessPlatformCatalog =
      Array.isArray(platforms)
        ? platforms
        : [];

    this.clientAccessRequirements =
      Array.isArray(access)
        ? access
        : [];
  } catch (error) {
    console.error(
      'Unable to load client account access:',
      error
    );

    this.clientAccessRequirements = [];
    this.accessPlatformCatalog = [];
  } finally {
    this.clientAccessLoading = false;
  }
}

getDefaultAccessEmail(client) {
  const code =
    String(client?.client_code || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');

  return code
    ? `tiffany${code}@myartisansavenue.com`
    : '';
}

formatAccessStatus(status) {
  const labels = {
    not_requested: 'Not Requested',
    requested: 'Requested',
    waiting_on_client: 'Waiting on Client',
    provided: 'Provided · Verify',
    verified: 'Verified',
    problem: 'Problem',
    not_required: 'Not Required'
  };

  return labels[status] || 'Not Requested';
}

async loadActiveClientBrandWorkspace() {
  const client = this.getActiveClient();

  this.clientBrandAssets = [];
  this.clientVendorBrands = [];

  if (
    !client?.id ||
    !window.AAPlaybookService
      ?.getClientBrandAssets ||
    !window.AAPlaybookService
      ?.getClientVendorBrands ||
    !window.AAPlaybookService
      ?.getVendorLibrary
  ) {
    return;
  }

  this.clientBrandLoading = true;

  try {
    const [
      assets,
      vendors,
      vendorLibrary
    ] =
      await Promise.all([
        window.AAPlaybookService
          .getClientBrandAssets({
            clientId: client.id
          }),
        window.AAPlaybookService
          .getClientVendorBrands({
            clientId: client.id,
            includeInternal: true
          }),
        window.AAPlaybookService
          .getVendorLibrary()
      ]);

    this.clientBrandAssets =
      Array.isArray(assets)
        ? assets
        : [];

    this.clientVendorBrands =
      Array.isArray(vendors)
        ? vendors
        : [];

    this.vendorLibrary =
      Array.isArray(vendorLibrary)
        ? vendorLibrary
        : [];
  } catch (error) {
    console.error(
      'Unable to load Brand Assets:',
      error
    );

    this.clientBrandAssets = [];
    this.clientVendorBrands = [];
    this.vendorLibrary = [];
  } finally {
    this.clientBrandLoading = false;
  }
}

async loadActiveClientContracts() {
  const client = this.getActiveClient();

  this.clientContracts = [];

  if (
    !client?.id ||
    !window.AAPlaybookService?.getClientContracts
  ) {
    return;
  }

  this.clientContractsLoading = true;

  try {
    const contracts =
      await window.AAPlaybookService.getClientContracts({
        clientId: client.id,
        includeInternal: true
      });

    this.clientContracts =
      Array.isArray(contracts)
        ? contracts
        : [];
  } catch (error) {
    console.error(
      'Unable to load client contracts:',
      error
    );

    this.clientContracts = [];
  } finally {
    this.clientContractsLoading = false;
  }
}

async loadActiveClientWaveMapping() {
  const client = this.getActiveClient();

  this.waveClientMapping = null;
  this.waveCustomerError = '';

  if (
    !client?.id ||
    !window.AAPlaybookService
      ?.getClientWaveCustomer
  ) {
    return;
  }

  try {
    const result =
      await window.AAPlaybookService
        .getClientWaveCustomer({
          clientId: client.id
        });

    if (!result?.success) {
      throw (
        result?.error ||
        new Error(
          'Unable to load Wave customer.'
        )
      );
    }

    this.waveClientMapping =
      result.mapping || null;
  } catch (error) {
    console.warn(
      'Unable to load client Wave customer:',
      error
    );

    this.waveCustomerError =
      error?.message ||
      'Unable to load Wave customer.';
  }
}

async loadWaveCustomers() {
  this.waveCustomerLoading = true;
  this.waveCustomerError = '';

  try {
    const result =
      await window.AAPlaybookService
        .listWaveCustomers();

    if (!result?.success) {
      throw (
        result?.error ||
        new Error(
          'Unable to retrieve Wave customers.'
        )
      );
    }

    this.waveCustomers =
      Array.isArray(result.customers)
        ? result.customers
        : [];
  } catch (error) {
    console.error(
      'Unable to retrieve Wave customers:',
      error
    );

    this.waveCustomers = [];
    this.waveCustomerError =
      error?.message ||
      'Unable to retrieve Wave customers.';
  } finally {
    this.waveCustomerLoading = false;
  }
}

async loadWaveConnection() {
  this.waveConnection = null;

  if (!window.AAPlaybookService?.getWaveConnection) {
    return;
  }

  try {
    const result =
      await window.AAPlaybookService
        .getWaveConnection();

    if (result?.success) {
      this.waveConnection =
        result.connection || null;
    }
  } catch (error) {
    console.warn(
      'Unable to load Wave connection:',
      error
    );
  }
}

resolveContractDisplayStatus(contract) {
  if (!contract) return 'draft';

  const status =
    contract.status || 'draft';

  if (status === 'archived') {
    return 'archived';
  }

  const today =
    new Date();

  today.setHours(0, 0, 0, 0);

  const expiration =
    contract.expirationDate
      ? new Date(
          String(contract.expirationDate)
            .slice(0, 10) +
          'T00:00:00'
        )
      : null;

  if (
    expiration &&
    expiration < today &&
    [
      'signed',
      'active',
      'renewal_due'
    ].includes(status)
  ) {
    return 'expired';
  }

  const effective =
    contract.effectiveDate
      ? new Date(
          String(contract.effectiveDate)
            .slice(0, 10) +
          'T00:00:00'
        )
      : null;

  if (
    status === 'signed' &&
    effective &&
    effective <= today
  ) {
    return 'active';
  }

  return status;
}

formatContractStatus(status) {
  const labels = {
    draft: 'Draft',
    sent: 'Sent for Signature',
    viewed: 'Viewed',
    pending_signature: 'Awaiting Signature',
    signed: 'Signed',
    active: 'Active',
    renewal_due: 'Renewal Due',
    expired: 'Expired',
    archived: 'Archived'
  };

  return labels[status] || 'Agreement';
}

formatContractDocumentType(type) {
  const labels = {
    agreement: 'Agreement',
    signed_agreement: 'Signed Agreement',
    amendment: 'Amendment',
    audit_certificate: 'Signature Certificate',
    other: 'Other'
  };

  return labels[type] || 'Document';
}

showContractFormMessage(form, message, type = 'error') {
  if (!form) return;

  let region =
    form.querySelector(
      '[data-aa-contract-form-message]'
    );

  if (!region) {
    region = document.createElement('div');
    region.setAttribute(
      'data-aa-contract-form-message',
      ''
    );
    region.className =
      'aa-client-contract-form-message';
    form.prepend(region);
  }

  region.textContent = message || '';
  region.dataset.messageType = type;
}

clearContractFormMessage(form) {
  const region =
    form?.querySelector(
      '[data-aa-contract-form-message]'
    );

  if (region) {
    region.textContent = '';
    region.removeAttribute(
      'data-message-type'
    );
  }
}

validateContractForm(form) {
  const status =
    form?.querySelector(
      '[data-aa-contract-status]'
    )?.value || 'draft';

  const effectiveDate =
    form?.querySelector(
      '[data-aa-contract-effective-date]'
    )?.value || '';

  const renewalDate =
    form?.querySelector(
      '[data-aa-contract-renewal-date]'
    )?.value || '';

  const expirationDate =
    form?.querySelector(
      '[data-aa-contract-expiration-date]'
    )?.value || '';

  if (
    status === 'active' &&
    !effectiveDate
  ) {
    return 'Active contracts need an effective date.';
  }

  if (
    status === 'renewal_due' &&
    !renewalDate
  ) {
    return 'Renewal Due contracts need a renewal date.';
  }

  if (
    status === 'expired' &&
    !expirationDate
  ) {
    return 'Expired contracts need an expiration date.';
  }

  return '';
}

formatContractDate(value) {
  if (!value) return 'Not set';

  const raw = String(value);

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month, day] =
      raw.split('-').map(Number);

    return new Date(
      year,
      month - 1,
      day
    ).toLocaleDateString();
  }

  return new Date(value).toLocaleDateString();
}

formatVendorAccessStatus(status) {
  const labels = {
    unknown: 'Needs Review',
    available: 'Available',
    needed: 'Access Needed',
    requested: 'Requested',
    problem: 'Problem'
  };

  return labels[status] || 'Needs Review';
}

formatBrandAssetType(type) {
  const labels = {
    logo: 'Logo',
    brand_color: 'Brand Color',
    font: 'Font',
    store_photo: 'Store Photo',
    team_photo: 'Owner / Team Photo'
  };

  return labels[type] || type || 'Asset';
}

  getAssignedTemplates(client) {
  return Array.isArray(client.assigned_templates) ? client.assigned_templates : [];
}

hasEmailAccess(access = []) {
  return Array.isArray(access) &&
    access.some(
      (item) => String(item).trim().toLowerCase() === 'email'
    );
}

setEmailAccess(access = [], enabled = false) {
  const existing = Array.isArray(access)
    ? access.filter(
        (item) => String(item).trim().toLowerCase() !== 'email'
      )
    : [];

  return enabled
    ? [...existing, 'email']
    : existing;
}

  getStatusOptions() {
    return ['Lead', 'Pending Setup', 'Active', 'Paused', 'Archived'];
  }

  getClientTypeOptions() {
    return ['Monthly Marketing', 'Catalog Only', 'Website Only', 'Email Marketing', 'Social Media', 'Custom'];
  }

  getPackageOptions() {
    return ['Monthly Marketing', 'Catalog Only', 'Website Only', 'Email Marketing', 'Social Media', 'Custom'];
  }

  getReminderOptions() {
    return ['5 & 2 days', '7 & 3 days', 'Weekly', 'None', 'Custom'];
  }

  getReminderTemplateOptions() {
    return ['Standard Playbook Reminder', 'Friendly Follow-Up', 'Final Reminder', 'Custom'];
  }

  ordinal(value) {
    const number = Number(value);

    if (!Number.isFinite(number)) {
      return String(value || '');
    }

    const mod100 = number % 100;

    if (mod100 >= 11 && mod100 <= 13) {
      return `${number}th`;
    }

    switch (number % 10) {
      case 1:
        return `${number}st`;
      case 2:
        return `${number}nd`;
      case 3:
        return `${number}rd`;
      default:
        return `${number}th`;
    }
  }

  getReminderScheduleDisplay(client) {
    const schedule =
      String(
        client?.reminder_schedule || ''
      ).trim();

    const dueDay =
      Number(
        client?.monthly_due_day || 15
      );

    const relative =
      schedule.match(
        /^(\d+)\s*&\s*(\d+)\s*days$/i
      );

    if (
      relative &&
      Number.isFinite(dueDay)
    ) {
      const first =
        Math.max(
          dueDay - Number(relative[1]),
          1
        );

      const second =
        Math.max(
          dueDay - Number(relative[2]),
          1
        );

      return {
        primary:
          `${this.ordinal(first)} + ${this.ordinal(second)}`,
        detail:
          `${relative[1]} and ${relative[2]} days before the Playbook due date`
      };
    }

    if (
      !schedule ||
      schedule.toLowerCase() === 'none'
    ) {
      return {
        primary: 'No reminders',
        detail: 'No reminder schedule configured'
      };
    }

    return {
      primary: schedule,
      detail: 'Configured reminder timing'
    };
  }

  render() {
    const container =
      this.root.querySelector(
        '[data-aa-clients-list]'
      );

    if (!container) return;

    const client =
      this.getActiveClient();

    container.innerHTML = `
      <div class="aa-client-hub">

        <aside class="aa-client-directory">
          <div class="aa-client-directory__header">
            <div>
              <p class="aa-card__label">Clients</p>
              <h2>Client Accounts</h2>
            </div>

            <button
              class="aa-button aa-button--primary aa-button--small"
              type="button"
              data-aa-new-client-toggle
            >
              + New
            </button>
          </div>

          <label class="aa-client-directory__search">
            <span class="aa-visually-hidden">
              Search clients
            </span>

            <input
              type="search"
              value="${this.escapeHtml(this.clientSearch)}"
              placeholder="Search clients..."
              data-aa-client-search
            >
          </label>

          <div
            class="aa-client-directory__list"
            data-aa-client-directory-list
          >
            ${this.clients.map((item) => {
              const isActive =
                String(item.id) ===
                String(this.activeClientId);

              const manager =
                this.clientAssignmentEnabled
                  ? this.getTeamMemberName(
                      item.primary_team_member_id
                    )
                  : '';

              return `
                <button
                  type="button"
                  class="aa-client-directory__item ${isActive ? 'is-active' : ''}"
                  data-aa-client-select="${this.escapeHtml(item.id)}"
                  data-aa-client-search-value="${this.escapeHtml(
                    `${item.client_code || ''} ${item.business_name || ''} ${item.client_type || item.current_package || ''} ${manager || ''}`
                      .toLowerCase()
                  )}"
                >
                  <span class="aa-client-directory__item-main">
                    <span class="aa-client-directory__identity">
                      <strong>
                        ${this.escapeHtml(item.business_name)}
                      </strong>
                    </span>

                    <small>
                      ${this.escapeHtml(
                        item.client_type ||
                        item.current_package ||
                        'Client'
                      )}
                    </small>
                  </span>

                  <span class="aa-client-directory__item-meta">
                    <span
                      class="aa-client-directory__status-dot"
                      aria-hidden="true"
                    ></span>

                    <small>
                      ${this.escapeHtml(
                        this.clientAssignmentEnabled
                          ? manager
                          : item.active_status
                      )}
                    </small>
                  </span>
                </button>
              `;
            }).join('')}
          </div>

          ${this.archivedClients.length ? `
            <details class="aa-client-directory__archived">
              <summary>
                Archived
                <span>${this.archivedClients.length}</span>
              </summary>

              <div class="aa-client-directory__archived-list">
                ${this.archivedClients.map((archivedClient) => `
                  <div class="aa-client-directory__archived-item">
                    <span>
                      ${this.escapeHtml(
                        archivedClient.business_name ||
                        'Unnamed Client'
                      )}
                    </span>

                    <button
                      type="button"
                      class="aa-client-template-action"
                      data-aa-restore-client="${this.escapeHtml(archivedClient.id)}"
                    >
                      Restore
                    </button>
                  </div>
                `).join('')}
              </div>
            </details>
          ` : ''}
        </aside>

        <section class="aa-client-detail-card">
          ${client
            ? this.renderClientDetails(client)
            : this.renderEmptyState()
          }
        </section>

      </div>
    `;

    this.filterClientDirectory();
    if (client?.id) {
      window.AAClientTeamAccess?.prefetch?.(String(client.id))?.catch?.(() => {});
    }
    window.AAClientTeamAccess?.mount?.(container, client);
  }

  filterClientDirectory() {
    const query =
      String(this.clientSearch || '')
        .trim()
        .toLowerCase();

    this.root
      .querySelectorAll(
        '[data-aa-client-search-value]'
      )
      .forEach((item) => {
        const value =
          item.dataset.aaClientSearchValue ||
          '';

        item.hidden =
          Boolean(query) &&
          !value.includes(query);
      });
  }

  renderEmptyState() {
    const assignedCount =
      this.clientAssignmentEnabled
        ? this.clients.filter(
            (client) =>
              Boolean(
                client.primary_team_member_id
              )
          ).length
        : 0;

    const unassignedCount =
      this.clientAssignmentEnabled
        ? Math.max(
            this.clients.length -
              assignedCount,
            0
          )
        : 0;

    const monthlyCount =
      this.clients.filter(
        (client) =>
          String(
            client.current_package ||
            client.client_type ||
            ''
          )
            .toLowerCase()
            .includes('monthly')
      ).length;

    return `
      <div class="aa-client-empty-state aa-client-empty-state--dashboard">
        <div class="aa-client-empty-state__intro">
          <p class="aa-card__label">
            Client Accounts
          </p>

          <h2>Select a client</h2>

          <p>
            Open a client from the directory to manage
            planning, catalogs, account details, and internal setup.
          </p>
        </div>

        <div class="aa-client-empty-state__stats">
          <div>
            <span>Active Clients</span>
            <strong>${this.clients.length}</strong>
          </div>

          <div>
            <span>Monthly Marketing</span>
            <strong>${monthlyCount}</strong>
          </div>

          ${this.clientAssignmentEnabled ? `
            <div>
              <span>Assigned</span>
              <strong>${assignedCount}</strong>
            </div>

            <div>
              <span>Unassigned</span>
              <strong>${unassignedCount}</strong>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }

  getClientPlanningCount(client) {
    const activeTemplates =
      this.getAssignedTemplates(client)
        .filter(
          (assignment) =>
            String(
              assignment.assignmentStatus ||
              ''
            )
              .trim()
              .toLowerCase() !== 'archived'
        ).length;

    const playbooks =
      Array.isArray(this.clientPlaybooks)
        ? this.clientPlaybooks.length
        : 0;

    return activeTemplates + playbooks;
  }

  renderClientDetails(client) {
    return `
      <div class="aa-client-overview">

        <div class="aa-client-profile-sticky">

        <header class="aa-client-profile-header">
          <div class="aa-client-profile-header__main">
            <div class="aa-client-profile-header__title-row">
              <h2>
                ${this.escapeHtml(client.business_name)}
              </h2>
              ${client.client_code ? `<span class="aa-client-code-pill" title="Client task and reporting code">${this.escapeHtml(client.client_code)}</span>` : ''}

              <span class="aa-client-status-pill">
                ${this.escapeHtml(client.active_status)}
              </span>
            </div>
          </div>

          <div class="aa-client-profile-header__actions">
            <button
              class="aa-button aa-button--primary"
              type="button"
              data-aa-view-client-workspace="${this.escapeHtml(client.id)}"
            >
              View Workspace
            </button>

            <a
              class="aa-button aa-button--secondary"
              href="/pages/artisans-avenue-playbook-builder?client=${encodeURIComponent(client.id)}"
            >
              Playbook Builder
            </a>

            <button
              class="aa-button aa-button--secondary"
              type="button"
              data-aa-edit-client="${this.escapeHtml(client.id)}"
            >
              Edit Client Info
            </button>

            <details class="aa-client-actions-menu">
              <summary aria-label="More client actions" title="More client actions">More ⋯</summary>
              <div class="aa-client-actions-menu__content">
                <button class="aa-client-profile-header__archive" type="button" data-aa-archive-client="${this.escapeHtml(client.id)}">Archive Client</button>
              </div>
            </details>
          </div>
        </header>

        <nav
          class="aa-client-tabs"
          aria-label="Client sections"
        >
          ${this.renderClientTab(
            'overview',
            'Overview'
          )}

          ${this.renderClientTab(
            'account',
            'Account'
          )}

          ${this.renderClientTab(
            'planning',
            'Planning'
          )}

          ${this.renderClientTab(
            'catalogs',
            'Catalogs & Co-op'
          )}
        </nav>

        </div>

        <div class="aa-client-tab-panel">
          ${this.renderClientTabContent(client)}
        </div>

        ${String(this.editingClientId) === String(client.id)
          ? this.renderEditClient(client)
          : ''
        }

      </div>
    `;
  }

  renderClientTab(
    value,
    label,
    count = null
  ) {
    const active =
      this.activeClientTab === value;

    return `
      <button
        type="button"
        class="aa-client-tab ${active ? 'is-active' : ''}"
        data-aa-client-tab="${this.escapeHtml(value)}"
        aria-selected="${active ? 'true' : 'false'}"
      >
        <span>
          ${this.escapeHtml(label)}
        </span>

        ${Number(count) > 0 ? `
          <small class="aa-client-tab__count">
            ${Number(count)}
          </small>
        ` : ''}
      </button>
    `;
  }

  renderMarketingIdentityPanel(client) {
    const identity = client.marketing_identity || {};
    const fields = [
      ['positioning', 'Marketing Identity', 'Describe the store, its audience, personality, and what sets it apart.'],
      ['email_style', 'Email Style', 'Email depth, subject lines, preheaders, content balance, and sales approach.'],
      ['social_voice', 'Social Media Voice', 'Caption tone, length, personality, and community language.'],
      ['priority_order', 'Marketing Priority Order', 'Rank community, store experience, fabric, classes, events, machines, manufacturers, and promotions.'],
      ['manufacturer_role', 'Manufacturer & Vendor Role', 'When manufacturers should lead, support, or receive dedicated coverage.'],
      ['writing_examples', 'Writing Examples & Rules', 'Sample captions, subject lines, preheaders, preferred words, and phrases to avoid.']
    ];
    return `
      <section class="aa-client-identity">
        <header class="aa-client-identity__header">
          <div>

            <h3>Marketing Identity &amp; Voice</h3>

          </div>
        </header>
        <form data-aa-marketing-identity-form="${this.escapeHtml(client.id)}">
          <div class="aa-client-identity__grid">
            ${fields.map(([key, label, hint]) => `
              <label class="aa-client-identity__field">
                <strong>${label}</strong>
                <textarea rows="5" data-aa-marketing-identity-field="${key}" title="${this.escapeHtml(hint)}" placeholder="Add client-specific guidance...">${this.escapeHtml(identity[key] || '')}</textarea>
              </label>
            `).join('')}
          </div>
          <div class="aa-client-identity__footer">
            <p>Saved to this client's profile. Leo integration will be connected separately.</p>
            <button class="aa-button aa-button--primary" type="submit">Save Marketing Identity</button>
          </div>
        </form>
      </section>
    `;
  }

  renderClientTabContent(client) {
    switch (this.activeClientTab) {
      case 'planning': {
        const section =
          this.activePlanningSection ||
          'package';

        const content = {
          package: `
            ${this.renderMarketingPackagePanel(client)}

            ${String(this.editingPackageClientId) === String(client.id)
              ? this.renderMarketingPackageEditor(client)
              : ''
            }
          `,
          rules:
            this.renderProductionRulesPanel(
              client
            ),
          anchors:
            this.renderTaskAnchorsPanel(
              client
            ),
          vendors:
            this.renderVendorBrandsPanel(client),
          playbooks: `
            <div class="aa-client-tab-stack">
              ${this.renderTemplatePanel(client)}
              ${this.renderPlaybooksPanel(client)}
            </div>
          `,
          identity: this.renderMarketingIdentityPanel(client)
        };

        return `
          <div
            class="aa-client-account-nav aa-client-section-nav"
            aria-label="Planning sections"
          >
            <button
              type="button"
              class="${section === 'package' ? 'is-active' : ''}"
              data-aa-planning-jump="package"
            >
              Marketing Package
            </button>

            <button type="button" class="${section === 'identity' ? 'is-active' : ''}" data-aa-planning-jump="identity">Marketing Identity &amp; Voice</button>

            <button
              type="button"
              class="${section === 'rules' ? 'is-active' : ''}"
              data-aa-planning-jump="rules"
            >
              Production Rules
            </button>

            <button
              type="button"
              class="${section === 'vendors' ? 'is-active' : ''}"
              data-aa-planning-jump="vendors"
            >
              Brands & Vendors
            </button>

            <button
              type="button"
              class="${section === 'anchors' ? 'is-active' : ''}"
              data-aa-planning-jump="anchors"
            >
              Task Anchors
            </button>

            <button
              type="button"
              class="${section === 'playbooks' ? 'is-active' : ''}"
              data-aa-planning-jump="playbooks"
            >
              Playbooks
            </button>

          </div>

          <div class="aa-client-section-panel">
            ${content[section] || content.package}
          </div>
        `;
      }

      case 'catalogs':
        return `
          <div class="aa-client-tab-stack">
            ${this.renderCatalogPanel(client)}
          </div>
        `;

      case 'account': {
        const section =
          this.activeAccountSection ||
          'agreements';

        const content = {
          agreements: `
            <div class="aa-client-tab-stack">
              ${this.renderContractPanel(client)}
              ${this.renderBillingSetupPanel(client)}

              ${String(this.editingContractClientId) === String(client.id)
                ? this.renderContractEditor(client)
                : ''
              }
            </div>
          `,
          access: `
            ${this.renderAccountAccessPanel(client)}

            ${String(this.editingAccessClientId) === String(client.id)
              ? this.renderAccountAccessEditor(client)
              : ''
            }
          `,
          team: `<div data-aa-client-team-access="${this.escapeHtml(client.id)}">
            <p>Loading this client's team...</p>
          </div>`,
          brand: `
            ${this.renderBrandAssetsPanel(client)}

            ${String(this.editingBrandClientId) === String(client.id) &&
              this.editingBrandFocus === 'kit'
              ? this.renderBrandAssetsEditor(client, 'kit')
              : ''
            }
          `,
          reminders: this.renderReminderPanel(client)
        };

        return `
          <div
            class="aa-client-account-nav aa-client-section-nav"
            aria-label="Account sections"
          >
            <button
              type="button"
              class="${section === 'agreements' ? 'is-active' : ''}"
              data-aa-account-jump="agreements"
            >
              Billing & Agreements
            </button>

            <button
              type="button"
              class="${section === 'access' ? 'is-active' : ''}"
              data-aa-account-jump="access"
            >
              Connected Accounts
            </button>

            <button
              type="button"
              class="${section === 'team' ? 'is-active' : ''}"
              data-aa-account-jump="team"
            >
              Client Access
            </button>

            <button
              type="button"
              class="${section === 'brand' ? 'is-active' : ''}"
              data-aa-account-jump="brand"
            >
              Brand Kit
            </button>
            <button type="button" class="${section === 'reminders' ? 'is-active' : ''}" data-aa-account-jump="reminders">
              Scheduled Emails
            </button>
          </div>

          <div class="aa-client-section-panel">
            ${content[section] || content.agreements}
          </div>
        `;
      }

      default:
        return `
          <div class="aa-client-overview__quick-grid">
            ${this.renderClientSummary(client)}
            ${this.renderMarketingSetup(client)}
          </div>

          <div class="aa-client-overview__notes">
            ${this.renderInternalNotesPanel(client)}
          </div>
        `;
    }
  }

  renderClientSummary(client) {
    return `
      <section class="aa-client-compact-panel">
        <p class="aa-card__label">Client Details</p>

        <div class="aa-client-detail-list">
          <div>
            <span>Primary Contact</span>
            <strong>${this.escapeHtml(client.primary_contact || 'Not added')}</strong>
          </div>

          <div>
            <span>Email</span>
            <strong>${this.escapeHtml(client.email || 'Not added')}</strong>
          </div>

          <div>
            <span>Phone</span>
            <strong>${this.escapeHtml(client.phone || 'Not added')}</strong>
          </div>

          <div class="aa-client-detail-list__address">
            <span>Business Address</span>
            <strong>${this.escapeHtml(client.mailing_address || 'Not added')}</strong>
          </div>

          <div>
            <span>Playbook Due</span>
            <strong>${this.escapeHtml(client.monthly_due_day || '15')}th</strong>
          </div>

          ${this.clientAssignmentEnabled ? `
            <div>
              <span>Account Manager</span>
              <strong>${this.escapeHtml(
                this.getTeamMemberName(
                  client.primary_team_member_id
                )
              )}</strong>
            </div>
          ` : ''}
        </div>
      </section>
    `;
  }

  renderMarketingSetup(client) {
    const services =
      Array.isArray(this.clientPackageServices)
        ? this.clientPackageServices
        : [];

    const requiredAccess =
      Array.isArray(this.clientAccessRequirements)
        ? this.clientAccessRequirements.filter(
            (item) => item.isRequired !== false
          )
        : [];

    const verifiedAccess =
      requiredAccess.filter(
        (item) => item.status === 'verified'
      ).length;

    const accessAttention =
      Math.max(
        requiredAccess.length - verifiedAccess,
        0
      );

    const vendors =
      Array.isArray(this.clientVendorBrands)
        ? this.clientVendorBrands
        : [];

    const vendorAttention =
      vendors.filter(
        (item) =>
          item.accessStatus !== 'available'
      ).length;

    const contracts =
      Array.isArray(this.clientContracts)
        ? this.clientContracts
        : [];

    const contractPriority = {
      renewal_due: 1,
      pending_signature: 2,
      sent: 3,
      viewed: 4,
      signed: 5,
      active: 6,
      draft: 7,
      expired: 8
    };

    const sortedContracts =
      [...contracts].sort((a, b) => {
        const statusDifference =
          (contractPriority[a.status] || 99) -
          (contractPriority[b.status] || 99);

        if (statusDifference !== 0) {
          return statusDifference;
        }

        return String(
          b.effectiveDate ||
          b.createdAt ||
          ''
        ).localeCompare(
          String(
            a.effectiveDate ||
            a.createdAt ||
            ''
          )
        );
      });

    const currentContract =
      sortedContracts.find(
        (contract) =>
          !['expired', 'archived']
            .includes(contract.status)
      ) || null;

    const expiredContracts =
      sortedContracts.filter(
        (contract) =>
          contract.status === 'expired'
      );

    const contractStatus =
      currentContract
        ? this.formatContractStatus(
            currentContract.status
          )
        : expiredContracts.length
          ? `No current agreement · ${expiredContracts.length} expired on file`
          : 'No contract';

    const contractNeedsAttention =
      currentContract
        ? [
            'renewal_due',
            'pending_signature',
            'sent',
            'viewed'
          ].includes(currentContract.status)
        : true;

    return `
      <section class="aa-client-compact-panel aa-client-overview-snapshot">
        <p class="aa-card__label">Account Snapshot</p>

        <div class="aa-client-snapshot-list">
          <div>
            <span>Marketing Voice</span>
            <strong>${Object.values(client.marketing_identity || {}).some(value => String(value || '').trim()) ? 'Profile started' : 'Not configured'}</strong>
          </div>
          <div>
            <span>Marketing Package</span>
            <strong>
              ${this.clientPackageLoading
                ? 'Loading...'
                : services.length
                  ? `${services.length} recurring service${services.length === 1 ? '' : 's'}`
                  : 'Not configured'
              }
            </strong>
          </div>

          <div class="${accessAttention ? 'needs-attention' : ''}">
            <span>Connected Accounts</span>
            <strong>
              ${this.clientAccessLoading
                ? 'Loading...'
                : requiredAccess.length
                  ? accessAttention
                    ? `${verifiedAccess} verified · ${accessAttention} need attention`
                    : `${verifiedAccess} verified`
                  : 'Not configured'
              }
            </strong>
          </div>

          <div class="${contractNeedsAttention ? 'needs-attention' : ''}">
            <span>Contract</span>
            <strong>
              ${this.clientContractsLoading
                ? 'Loading...'
                : this.escapeHtml(contractStatus)
              }
            </strong>
          </div>

          <div class="${vendorAttention ? 'needs-attention' : ''}">
            <span>Vendor Access</span>
            <strong>
              ${this.clientBrandLoading
                ? 'Loading...'
                : vendors.length
                  ? vendorAttention
                    ? `${vendors.length - vendorAttention} available · ${vendorAttention} need attention`
                    : `${vendors.length} available`
                  : 'No brands configured'
              }
            </strong>
          </div>
        </div>
      </section>
    `;
  }

  getCatalogRecords(client) {
  return Array.isArray(client.catalog_records)
    ? client.catalog_records
    : [];
}

formatCatalogMonth(value) {
  if (!value) return '—';

  const [year, month] = String(value).split('-');

  if (!year || !month) {
    return value;
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(
    new Date(Date.UTC(Number(year), Number(month) - 1, 1))
  );
}

formatCatalogDate(value) {
  if (!value) return '—';

  const [year, month, day] = String(value).split('-');

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(
    new Date(
      Date.UTC(
        Number(year),
        Number(month) - 1,
        Number(day)
      )
    )
  );
}

async createCatalogCoverFromPdf({
  clientId,
  file
} = {}) {
  const pdfjsLib =
    window['pdfjs-dist/build/pdf'];

  if (!pdfjsLib) {
    throw new Error(
      'PDF preview service is unavailable.'
    );
  }

  if (!file) {
    throw new Error(
      'Catalog PDF is required.'
    );
  }

  pdfjsLib.GlobalWorkerOptions.workerSrc =
    'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';

  const bytes =
    new Uint8Array(
      await file.arrayBuffer()
    );

  const pdf =
    await pdfjsLib
      .getDocument({
        data: bytes
      })
      .promise;

  const page =
    await pdf.getPage(1);

  const baseViewport =
    page.getViewport({
      scale: 1
    });

  const targetWidth = 900;

  const scale =
    Math.max(
      1,
      Math.min(
        2.25,
        targetWidth /
          baseViewport.width
      )
    );

  const viewport =
    page.getViewport({
      scale
    });

  const canvas =
    document.createElement(
      'canvas'
    );

  canvas.width =
    Math.ceil(
      viewport.width
    );

  canvas.height =
    Math.ceil(
      viewport.height
    );

  const context =
    canvas.getContext(
      '2d',
      {
        alpha: false
      }
    );

  context.fillStyle =
    '#ffffff';

  context.fillRect(
    0,
    0,
    canvas.width,
    canvas.height
  );

  await page.render({
    canvasContext: context,
    viewport
  }).promise;

  const blob =
    await new Promise(
      (resolve, reject) => {
        canvas.toBlob(
          (result) =>
            result
              ? resolve(result)
              : reject(
                  new Error(
                    'Unable to create catalog cover.'
                  )
                ),
          'image/webp',
          0.92
        );
      }
    );

  const coverFile =
    new File(
      [blob],
      'catalog-cover.webp',
      {
        type: 'image/webp'
      }
    );

  return window.AASupabaseClient
    .uploadCatalogCover({
      clientId,
      file: coverFile
    });
}

renderCatalogForm(client, catalog = null) {
  const isEditing = Boolean(catalog?.id);

  const vendorBrands = Array.isArray(this.clientVendorBrands)
    ? this.clientVendorBrands
        .map((item) => String(item?.vendorName || '').trim())
        .filter(Boolean)
    : [];

  const legacyBrands = Array.isArray(client.brands)
    ? client.brands
        .map((brand) => String(brand || '').trim())
        .filter(Boolean)
    : [];

  const clientBrands = [
    ...new Map(
      [...vendorBrands, ...legacyBrands].map((brand) => [
        brand.toLowerCase(),
        brand
      ])
    ).values()
  ];

  const catalogBrands = Array.isArray(catalog?.brands)
    ? catalog.brands
    : [];

  const additionalBrands = catalogBrands.filter(
    (brand) =>
      !clientBrands.some(
        (clientBrand) =>
          String(clientBrand).trim().toLowerCase() ===
          String(brand).trim().toLowerCase()
      )
  );

  const catalogMonth = catalog?.catalog_month
    ? String(catalog.catalog_month).slice(0, 7)
    : '';

  return `
    <form
      id="aa-catalog-form-${this.escapeHtml(client.id)}"
      class="aa-client-catalog-form"
      data-aa-catalog-form="${client.id}"
      ${isEditing
        ? `data-aa-catalog-edit-id="${catalog.id}"`
        : ''
      }
    >
      <div class="aa-client-catalog-form__grid">

        <label>
          Catalog Month
          <input
            type="month"
            data-aa-catalog-field="catalogMonth"
            value="${this.escapeHtml(catalogMonth)}"
            required
          >
          <small>
            This month is also used as the publication date.
          </small>
        </label>

        <label>
          Catalog Views
          <input
            type="number"
            min="0"
            step="1"
            data-aa-catalog-field="catalogViews"
            value="${catalog?.catalog_views ?? ''}"
          >
        </label>

        <label class="aa-client-catalog-form__wide">
          ${catalog?.catalog_pdf_storage_path
            ? 'Replace Catalog PDF'
            : 'Catalog PDF'
          }

          <input
            type="file"
            accept="application/pdf"
            data-aa-catalog-pdf
            ${!isEditing ? 'required' : ''}
          >

          <small>
            ${catalog?.catalog_pdf_storage_path
              ? `Stored: ${this.escapeHtml(
                  catalog.catalog_pdf_file_name ||
                  'Catalog PDF'
                )}. Upload a replacement only if needed.`
              : 'Upload once. Page 1 automatically becomes the catalog cover.'
            }
          </small>
        </label>

        ${catalog?.catalog_pdf_storage_path
          ? `
            <div class="aa-client-catalog-pdf-status aa-client-catalog-form__wide">
              <div>
                <span>Catalog PDF</span>
                <strong>
                  ${this.escapeHtml(
                    catalog.catalog_pdf_file_name ||
                    'Stored PDF'
                  )}
                </strong>
              </div>

              <button
                type="button"
                class="aa-client-template-action"
                data-aa-open-catalog-pdf="${this.escapeHtml(
                  catalog.catalog_pdf_storage_path
                )}"
              >
                Open Stored PDF
              </button>
            </div>
          `
          : ''
        }

        <fieldset class="aa-client-catalog-form__wide">
          <legend>Brands Represented</legend>

          ${clientBrands.length
            ? `
              <div class="aa-client-catalog-brand-options">
                ${clientBrands.map((brand) => {
                  const checked = catalogBrands.some(
                    (catalogBrand) =>
                      String(catalogBrand)
                        .trim()
                        .toLowerCase() ===
                      String(brand)
                        .trim()
                        .toLowerCase()
                  );

                  return `
                    <label class="aa-client-catalog-brand-option">
                      <input
                        type="checkbox"
                        value="${this.escapeHtml(brand)}"
                        data-aa-catalog-brand
                        ${checked ? 'checked' : ''}
                      >
                      <span>${this.escapeHtml(brand)}</span>
                    </label>
                  `;
                }).join('')}
              </div>
            `
            : `
              <p class="aa-client-empty-value">
                No Brands Carried have been added to this client yet.
              </p>
            `
          }

          <label>
            Additional Brands
            <input
              type="text"
              data-aa-catalog-additional-brands
              value="${this.escapeHtml(
                additionalBrands.join(', ')
              )}"
              placeholder="Comma separated"
            >
          </label>
        </fieldset>

      </div>

      <div class="aa-client-card__actions">
        <button
          class="aa-button aa-button--primary"
          type="submit"
          data-aa-save-catalog
        >
          ${isEditing ? 'Save Changes' : 'Save Catalog'}
        </button>

        <button
          class="aa-button"
          type="button"
          data-aa-cancel-catalog
        >
          Cancel
        </button>
      </div>
    </form>
  `;
}

renderCatalogHistoryPanel(client) {
  const catalogs = this.getCatalogRecords(client);
  const now = new Date();
  const currentCatalogMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const archived = this.archivedCatalogsClientId === client.id
    ? this.archivedCatalogs
    : [];
  const shown = this.showArchivedCatalogs ? archived : catalogs;
  const years = [...new Set(shown.map(catalog =>
    String(catalog.catalog_month || '').slice(0,4)).filter(Boolean))].sort().reverse();

  const isAddingCatalog =
    String(this.addingCatalogClientId) ===
    String(client.id);

  const editingCatalog =
    this.editingCatalogId
      ? catalogs.find(
          (item) =>
            String(item.id) ===
            String(this.editingCatalogId)
        )
      : null;

  const catalogFormOpen =
    isAddingCatalog ||
    Boolean(editingCatalog);

  return `
    <section class="aa-client-catalog-history-panel">
      <div class="aa-client-catalog-history-panel__header">
        <div><h3>${this.showArchivedCatalogs ? 'Archived Catalogs' : 'Catalog History'}</h3></div>
        <div class="aa-client-catalog-history-panel__actions">
        ${catalogFormOpen
          ? `
            <button
              class="aa-button aa-button--primary"
              type="submit"
              form="aa-catalog-form-${this.escapeHtml(client.id)}"
              data-aa-catalog-header-save
            >
              ${editingCatalog ? 'Save Changes' : 'Save Catalog'}
            </button>
          `
          : `
            <button
              class="aa-button aa-button--primary"
              type="button"
              data-aa-add-catalog="${this.escapeHtml(client.id)}"
            >
              Add Catalog
            </button>
          `
        }
        <button type="button" class="aa-button aa-button--secondary" data-aa-toggle-archived-catalogs="${this.escapeHtml(client.id)}" aria-pressed="${this.showArchivedCatalogs ? 'true' : 'false'}">
          ${this.showArchivedCatalogs ? 'Active Catalogs' : 'Archived Catalogs'}
        </button>
        ${this.catalogDeleteAdmin ? `
          <button type="button" class="aa-button aa-button--secondary" data-aa-catalog-delete-mode>
            ${this.catalogDeleteMode ? 'Cancel Delete' : 'Delete Catalogs'}
          </button>
        ` : ''}
        </div>
      </div>

      ${this.catalogDeleteMode && this.catalogDeleteAdmin ? `
        <div class="aa-catalog-deletion-toolbar">
          <label>Year
            <select data-aa-catalog-delete-year>
              <option value="all">All Years</option>
              ${years.map(year => `<option value="${this.escapeHtml(year)}" ${this.catalogDeleteYear === year ? 'selected' : ''}>${this.escapeHtml(year)}</option>`).join('')}
            </select>
          </label>
          <button type="button" class="aa-button aa-button--secondary" data-aa-catalog-delete-select-year>
            Select ${this.catalogDeleteYear === 'all' ? 'All Shown' : this.escapeHtml(this.catalogDeleteYear)}
          </button>
          <button type="button" class="aa-button aa-button--secondary" data-aa-catalog-delete-review ${this.catalogDeleteSelected.size ? '' : 'disabled'}>
            Review Delete (${this.catalogDeleteSelected.size})
          </button>
        </div>
      ` : ''}
      ${!this.showArchivedCatalogs && isAddingCatalog
        ? this.renderCatalogForm(client)
        : editingCatalog
          ? this.renderCatalogForm(
              client,
              editingCatalog
            )
          : ''
      }

      ${this.showArchivedCatalogs ? `
        <section class="aa-client-archived-catalogs">
          ${archived.length ? archived.map(catalog => `
            <div class="aa-client-archived-catalog-row ${this.catalogDeleteMode ? 'is-selecting' : ''}">
              ${this.catalogDeleteMode && this.catalogDeleteAdmin ? `<input type="checkbox" data-aa-catalog-delete-select="${this.escapeHtml(catalog.id)}" aria-label="Select ${this.escapeHtml(this.formatCatalogMonth(catalog.catalog_month))}" ${this.catalogDeleteSelected.has(String(catalog.id)) ? 'checked' : ''}>` : ''}
              <strong>${this.escapeHtml(this.formatCatalogMonth(catalog.catalog_month))}</strong>
              <span>${this.escapeHtml(catalog.catalog_title || 'Catalog')}</span>
              <button type="button" class="aa-client-template-action" data-aa-restore-catalog="${this.escapeHtml(catalog.id)}">Restore</button>
            </div>
          `).join('') : '<p>No archived catalogs for this client.</p>'}
        </section>
      ` : ''}
      <div
        class="aa-task-generator-host"
        data-aa-task-generator-panel
        ${this.showArchivedCatalogs ? 'hidden' : ''}
      ></div>

      <div class="aa-client-catalog-list" ${this.showArchivedCatalogs ? 'hidden' : ''}>
        ${catalogs.length
          ? catalogs.map((catalog) => {
              const brands =
                Array.isArray(catalog.brands)
                  ? catalog.brands
                  : [];

              const catalogUrl =
                catalog.catalog_url || '';

              return `
                <div
                  class="aa-client-catalog-item ${this.catalogDeleteMode ? 'is-selecting' : ''}"
                  data-aa-catalog-record="${this.escapeHtml(catalog.id)}"
                >
                  ${this.catalogDeleteMode && this.catalogDeleteAdmin ? `
                    <input type="checkbox" data-aa-catalog-delete-select="${this.escapeHtml(catalog.id)}"
                      aria-label="Select ${this.escapeHtml(this.formatCatalogMonth(catalog.catalog_month))}"
                      ${this.catalogDeleteSelected.has(String(catalog.id)) ? 'checked' : ''}>
                  ` : ''}
                  <div class="aa-client-catalog-item__cover">
                    ${catalog.cover_image_url
                      ? `
                        <img
                          src="${this.escapeHtml(catalog.cover_image_url)}"
                          alt="${this.escapeHtml(
                            catalog.catalog_title || 'Catalog cover'
                          )}"
                          loading="lazy"
                        >
                      `
                      : `
                        <div class="aa-client-catalog-item__cover-placeholder">
                          No Cover
                        </div>
                      `
                    }
                  </div>

                  <div class="aa-client-catalog-item__details">
                    <strong>
                      ${this.escapeHtml(
                        this.formatCatalogMonth(
                          catalog.catalog_month
                        )
                      )}
                    </strong>
                  </div>

                  <div class="aa-client-catalog-item__meta">
                    <span>
                      Views:
                      <strong>
                        ${catalog.catalog_views ?? '—'}
                      </strong>
                    </span>

                    <div class="aa-client-chip-list">
                      ${brands.length
                        ? brands.map((brand) => `
                            <span class="aa-client-chip">
                              ${this.escapeHtml(brand)}
                            </span>
                          `).join('')
                        : `
                            <span class="aa-client-empty-value">
                              No brands added
                            </span>
                          `
                      }
                    </div>
                  </div>

                  <div class="aa-client-catalog-item__actions">
                    ${catalog.catalog_pdf_storage_path
                      ? `
                        <button
                          class="aa-client-template-action"
                          type="button"
                          data-aa-open-catalog-pdf="${this.escapeHtml(
                            catalog.catalog_pdf_storage_path
                          )}"
                        >
                          Open Catalog
                        </button>
                      `
                      : catalogUrl
                        ? `
                          <a
                            class="aa-client-template-action"
                            href="${this.escapeHtml(catalogUrl)}"
                            target="_blank"
                            rel="noopener"
                          >
                            Open Catalog
                          </a>
                        `
                        : ''
                    }

                    ${catalog.catalog_pdf_storage_path &&
                      /^\d{4}-\d{2}$/.test(String(catalog.catalog_month || '').slice(0, 7)) &&
                      String(catalog.catalog_month).slice(0, 7) >= currentCatalogMonth
                      ? `
                        <button
                          class="aa-client-template-action aa-client-template-action--generator"
                          type="button"
                          data-aa-generate-catalog-tasks="${this.escapeHtml(catalog.id)}"
                          data-aa-generator-client-id="${this.escapeHtml(client.id)}"
                          data-aa-generator-client-name="${this.escapeHtml(client.business_name)}"
                          data-aa-generator-catalog-month="${this.escapeHtml(String(catalog.catalog_month || '').slice(0, 7))}"
                          data-aa-generator-catalog-title="${this.escapeHtml(catalog.catalog_title || 'Catalog')}"
                        >
                          Generate Tasks
                        </button>

                        <span
                          class="aa-task-generation-status"
                          data-aa-task-generation-status="${this.escapeHtml(catalog.id)}"
                        ></span>
                      `
                      : ''
                    }

                    <button
                      class="aa-client-template-action"
                      type="button"
                      data-aa-edit-catalog="${this.escapeHtml(catalog.id)}"
                    >
                      Edit
                    </button>

                    <button
                      class="aa-client-template-action"
                      type="button"
                      data-aa-archive-catalog="${this.escapeHtml(catalog.id)}"
                    >
                      Archive
                    </button>
                  </div>
                </div>
              `;
            }).join('')
          : `
            <div class="aa-client-empty-row">
              No catalog history yet.
            </div>
          `
        }
      </div>
      ${this.catalogDeletePreview ? this.renderCatalogDeleteConfirmation() : ''}
    </section>
  `;
}

  updateCatalogDeleteSelectionDisplay() {
    this.root.querySelectorAll('[data-aa-catalog-delete-select]').forEach(input => {
      input.checked = this.catalogDeleteSelected.has(String(input.dataset.aaCatalogDeleteSelect));
    });
    const review = this.root.querySelector('[data-aa-catalog-delete-review]');
    if (review) {
      review.textContent = 'Review Delete (' + this.catalogDeleteSelected.size + ')';
      review.disabled = !this.catalogDeleteSelected.size;
    }
  }

  renderCatalogDeleteConfirmation() {
    const preview = this.catalogDeletePreview;
    if (!preview) return '';
    return `
      <div class="aa-catalog-delete-overlay">
        <section class="aa-catalog-delete-confirm" role="dialog" aria-modal="true" aria-label="Confirm permanent catalog deletion">
          <h3>Delete ${Number(preview.count)} ${Number(preview.count) === 1 ? 'Catalog' : 'Catalogs'} Permanently?</h3>
          <p>This cannot be undone. Only selected catalogs are targeted. Related generation history is removed as described below.</p>
          <ul class="aa-catalog-delete-confirm__items">
            ${(preview.catalogs || []).map(catalog => `<li>${this.escapeHtml(this.formatCatalogMonth(catalog.month))} · ${this.escapeHtml(catalog.title || 'Catalog')}</li>`).join('')}
          </ul>
          <div class="aa-catalog-delete-confirm__impact">
            <strong>${Number(preview.coOpReports || 0)} related Co-op reports</strong>
            <span>Historical report snapshots are retained; deleted catalog links are removed.</span>
            <strong>${Number(preview.generationBatches || 0)} task-generation batches</strong>
            <span>Generation batches and their proposals will be removed. ${Number(preview.linkedTasks || 0)} linked tasks will remain but lose batch association.</span>
            <strong>${Number(preview.pdfFiles || 0)} stored PDFs · ${Number(preview.coverFiles || 0)} stored covers</strong>
            <span>Associated Supabase files will be cleaned up after records are deleted. Existing reports referencing images may lose those images.</span>
          </div>
          <label>Type DELETE to permanently remove ${Number(preview.count)} ${Number(preview.count) === 1 ? 'catalog' : 'catalogs'}.
            <input type="text" autocomplete="off" data-aa-catalog-delete-phrase placeholder="DELETE">
          </label>
          <div class="aa-catalog-delete-confirm__actions">
            <button type="button" class="aa-button aa-button--secondary" data-aa-catalog-delete-cancel>Cancel</button>
            <button type="button" class="aa-button aa-button--danger" data-aa-catalog-delete-confirm disabled>Permanently Delete</button>
          </div>
        </section>
      </div>
    `;
  }


getCoopBrandLogo() {
  return window.AACOOPLogoUrl || '';
}

renderCoopReportDocument(
  report,
  client
) {
  const catalogs =
    Array.isArray(
      report?.catalogSnapshot
    )
      ? [...report.catalogSnapshot]
      : [];

  catalogs.sort((a, b) =>
    String(a.catalog_month || '')
      .localeCompare(
        String(b.catalog_month || '')
      )
  );

  const manufacturer =
    String(
      report?.manufacturer || ''
    ).trim();

  const periodStart =
    this.formatCatalogMonth(
      report?.dateStart || ''
    );

  const periodEnd =
    this.formatCatalogMonth(
      report?.dateEnd || ''
    );

  const periodLabel =
    periodStart && periodEnd
      ? periodStart === periodEnd
        ? periodStart
        : `${periodStart} – ${periodEnd}`
      : '';

  const gridCount =
    Math.min(
      Math.max(catalogs.length, 1),
      4
    );

  const isFullYear =
    catalogs.length >= 9;

  return `
    <div class="aa-coop-document ${isFullYear ? 'is-annual' : ''}">
      <div class="aa-coop-document__topbar"></div>

      <header class="aa-coop-document__masthead">
        <img
          class="aa-coop-document__logo"
          src="${this.escapeHtml(
            this.getCoopBrandLogo()
          )}"
          alt="Artisan's Avenue to Marketing"
        >

        <span>
          CO-OP MARKETING SUMMARY
        </span>
      </header>

      <section class="aa-coop-document__heading">
        <h2>
          ${this.escapeHtml(
            report?.reportTitle ||
            'Co-op Marketing Catalog Summary'
          )}
        </h2>

        <p>
          ${this.escapeHtml(
            client?.business_name ||
            'Client'
          )}
          ${periodLabel
            ? ` · ${this.escapeHtml(periodLabel)}`
            : ''
          }
          ${manufacturer
            ? ` · ${this.escapeHtml(manufacturer)}`
            : ''
          }
        </p>
      </section>

      <div class="aa-coop-document__rule"></div>

      <section
        class="aa-coop-document__catalogs aa-coop-document__catalogs--${gridCount}"
      >
        ${catalogs.map((catalog) => {
          const month =
            this.formatCatalogMonth(
              catalog.catalog_month
            );

          const storedPdfUrl =
            catalog.catalog_pdf_storage_path &&
            window.AASupabaseClient
              ?.getCatalogPdfPublicUrl
              ? window.AASupabaseClient
                  .getCatalogPdfPublicUrl({
                    path:
                      catalog
                        .catalog_pdf_storage_path
                  })
              : '';

          const viewUrl =
            storedPdfUrl ||
            String(
              catalog.catalog_url ||
              ''
            ).trim();

          return `
            <article class="aa-coop-document__catalog">
              <div class="aa-coop-document__cover">
                ${catalog.cover_image_url
                  ? `
                    <img
                      src="${this.escapeHtml(
                        catalog.cover_image_url
                      )}"
                      alt="${this.escapeHtml(month)}"
                    >
                  `
                  : `
                    <div class="aa-coop-document__cover-empty">
                      Catalog
                    </div>
                  `
                }
              </div>

              <div class="aa-coop-document__catalog-line">
                <strong>
                  ${this.escapeHtml(month)}
                </strong>

                ${viewUrl
                  ? `
                    <a
                      href="${this.escapeHtml(
                        viewUrl
                      )}"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Catalog
                    </a>
                  `
                  : ''
                }
              </div>
            </article>
          `;
        }).join('')}
      </section>

      <footer class="aa-coop-document__footer">
        Artisan’s Avenue to Marketing
      </footer>

      <div class="aa-coop-document__bottombar"></div>
    </div>
  `;
}

renderCoopReportsPanel(client) {
  const catalogs =
    this.getCatalogRecords(client);

  const years =
    [...new Set(
      catalogs
        .map((catalog) =>
          String(
            catalog.catalog_month || ''
          ).slice(0, 4)
        )
        .filter(Boolean)
    )].sort(
      (a, b) => Number(b) - Number(a)
    );

  const manufacturers =
    [...new Set(
      catalogs.flatMap((catalog) =>
        Array.isArray(catalog.brands)
          ? catalog.brands
              .map((brand) =>
                String(brand).trim()
              )
              .filter(Boolean)
          : []
      )
    )].sort((a, b) =>
      a.localeCompare(
        b,
        undefined,
        { sensitivity: 'base' }
      )
    );

  const defaultYear =
    years[0] ||
    String(
      new Date().getFullYear()
    );

  const preview =
    this.coopReportPreview || null;

  return `
    <section class="aa-client-coop-panel">
      <div class="aa-client-coop-panel__header">
        <div>
          <p class="aa-card__label">
            Co-op Reports
          </p>

          <h3>
            Build a Co-op Marketing Summary
          </h3>

          <p>
            Reports are built from Catalog History. No duplicate
            catalog entry is required.
          </p>
        </div>
      </div>

      <form
        class="aa-client-coop-builder"
        data-aa-coop-report-form="${this.escapeHtml(client.id)}"
      >
        <div class="aa-client-coop-builder__grid">
          <label>
            <span>Reporting Period</span>
            <select data-aa-coop-field="period">
              ${years.map(
                (year) => `
                  <option
                    value="${this.escapeHtml(year)}"
                    ${year === defaultYear ? 'selected' : ''}
                  >
                    ${this.escapeHtml(year)}
                  </option>
                `
              ).join('')}

              ${years.length
                ? ''
                : `
                  <option
                    value="${this.escapeHtml(defaultYear)}"
                    selected
                  >
                    ${this.escapeHtml(defaultYear)}
                  </option>
                `
              }

              <option value="custom">
                Custom range
              </option>
            </select>
          </label>

          <label>
            <span>Manufacturer</span>
            <select data-aa-coop-field="manufacturer">
              <option value="">
                All manufacturers
              </option>

              ${manufacturers.map(
                (manufacturer) => `
                  <option
                    value="${this.escapeHtml(manufacturer)}"
                  >
                    ${this.escapeHtml(manufacturer)}
                  </option>
                `
              ).join('')}
            </select>
          </label>

          <div
            class="aa-client-coop-builder__custom-range"
            data-aa-coop-custom-range
            hidden
          >
            <label>
              <span>Start Month</span>
              <input
                type="month"
                data-aa-coop-field="start_month"
              >
            </label>

            <label>
              <span>End Month</span>
              <input
                type="month"
                data-aa-coop-field="end_month"
              >
            </label>
          </div>
        </div>

        <div class="aa-client-coop-builder__note">
          <strong>
            Reports are generated on demand.
          </strong>
          <span>
            Download or save the PDF if you need to keep a copy.
            The Workspace does not keep generated report history.
          </span>
        </div>

        <div class="aa-client-coop-builder__actions">
          <button
            type="submit"
            class="aa-button aa-button--primary"
          >
            Generate Co-op Report
          </button>
        </div>
      </form>

      ${preview
        ? `
          <section class="aa-client-coop-preview">
            <div class="aa-client-coop-preview__header">
              <div>
                <p class="aa-card__label">
                  Report Preview
                </p>
                <h4>
                  ${this.escapeHtml(
                    preview.reportTitle
                  )}
                </h4>
              </div>

              <button
                type="button"
                class="aa-button aa-button--primary"
                data-aa-print-coop-report="${this.escapeHtml(preview.id)}"
              >
                Print / Save PDF
              </button>
            </div>

            ${this.renderCoopReportDocument(
              preview,
              client
            )}
          </section>
        `
        : ''
      }

    </section>
  `;
}

renderCatalogPanel(client) {
  const section =
    this.activeCatalogSection ||
    'history';

  return `
    <section class="aa-client-catalog-shell">
      <nav
        class="aa-client-catalog-subnav"
        aria-label="Catalogs and Co-op sections"
      >
        <button
          type="button"
          class="${section === 'history' ? 'is-active' : ''}"
          data-aa-catalog-jump="history"
        >
          Catalog History
        </button>

        <button
          type="button"
          class="${section === 'coop' ? 'is-active' : ''}"
          data-aa-catalog-jump="coop"
        >
          Co-op Reports
        </button>
      </nav>

      <div class="aa-client-section-panel">
        ${section === 'coop'
          ? this.renderCoopReportsPanel(client)
          : this.renderCatalogHistoryPanel(client)
        }
      </div>
    </section>
  `;
}

renderTemplatePanel(client) {
  const assignments = this.getAssignedTemplates(client);

  const activeAssignments = assignments.filter(
    (template) =>
      String(template.assignmentStatus || '')
        .trim()
        .toLowerCase() !== 'archived'
  );

  const archivedAssignments = assignments.filter(
    (template) =>
      String(template.assignmentStatus || '')
        .trim()
        .toLowerCase() === 'archived'
  );

  return `
    <details class="aa-client-operation-panel aa-client-operation-panel--collapsible">
      <summary class="aa-client-operation-panel__summary">
        <div>
          <p class="aa-card__label">Assigned Templates</p>
          <p class="aa-client-operation-panel__description">
            Manage the Playbook templates assigned to this client.
          </p>
        </div>

        <span class="aa-client-operation-panel__toggle"></span>
      </summary>

      <div class="aa-client-operation-panel__body">

        <div class="aa-client-operation-panel__body-actions">
          <a
            class="aa-button aa-button--small"
            href="/pages/artisans-avenue-playbook-builder?client=${encodeURIComponent(client.id)}"
          >
            Manage Templates
          </a>
        </div>

      <div class="aa-client-template-table">

        ${activeAssignments.length
          ? activeAssignments.map((template) => {
              const status =
                String(template.assignmentStatus || 'assigned')
                  .trim()
                  .toLowerCase();

              const isGenerated = status === 'generated';

              return `
                <div class="aa-client-template-item">

                  <div class="aa-client-template-item__name">
                    <strong>
                      ${this.escapeHtml(
                        template.templateName || 'Unnamed Template'
                      )}
                    </strong>
                  </div>

                  <div class="aa-client-template-item__actions">

                    ${isGenerated
                      ? `
                        <span class="aa-client-template-status">
                          In Use
                        </span>
                      `
                      : `
                        <span class="aa-client-template-status">
                          Assigned
                        </span>

                        <button
  class="aa-client-template-action"
  type="button"
  data-aa-archive-template-assignment="${template.id}"
>
  Archive
</button>

<button
  class="aa-client-template-action aa-client-template-action--delete"
  type="button"
  data-aa-delete-template-assignment="${template.id}"
>
  Delete
</button>
                      `
                    }
                    

                  </div>

                </div>
              `;
            }).join('')
          : `
              <div class="aa-client-empty-row">
                No active templates assigned.
              </div>
            `
        }

      </div>

      ${archivedAssignments.length
        ? `
          <details class="aa-client-archived-templates">
            <summary>
              Archived Templates
              <span>${archivedAssignments.length}</span>
            </summary>

            <div class="aa-client-template-table">

              ${archivedAssignments.map((template) => `
                <div class="aa-client-template-item">

                  <div class="aa-client-template-item__name">
                    <strong>
                      ${this.escapeHtml(
                        template.templateName || 'Unnamed Template'
                      )}
                    </strong>
                  </div>

                  <div class="aa-client-template-item__actions">
                    <span class="aa-client-template-status">
                      Archived
                    </span>

                    <button
  class="aa-client-template-action"
  type="button"
  data-aa-restore-template-assignment="${template.id}"
>
  Restore
</button>

<button
  class="aa-client-template-action aa-client-template-action--delete"
  type="button"
  data-aa-delete-template-assignment="${template.id}"
>
  Delete
</button>
                  </div>

                </div>
              `).join('')}

            </div>
          </details>
        `
        : ''
      }

      </div>
    </details>
  `;
}

renderPlaybooksPanel(client) {
  const playbooks =
    Array.isArray(this.clientPlaybooks)
      ? [...this.clientPlaybooks]
      : [];

  playbooks.sort((a, b) => {
    const aValue =
      Number(
        `${a.year || 0}${String(a.month || 0).padStart(2, '0')}`
      );

    const bValue =
      Number(
        `${b.year || 0}${String(b.month || 0).padStart(2, '0')}`
      );

    return bValue - aValue;
  });

  const monthNames = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  return `
    <details class="aa-client-operation-panel aa-client-operation-panel--collapsible">
      <summary class="aa-client-operation-panel__summary">
        <div>
          <p class="aa-card__label">Monthly Playbooks</p>

          <p class="aa-client-operation-panel__description">
            Review this client's current and past monthly Playbooks.
          </p>
        </div>

        <span class="aa-client-operation-panel__toggle"></span>
      </summary>

      <div class="aa-client-operation-panel__body">
        <div class="aa-client-template-table">

        ${
          this.clientPlaybooksLoading
            ? `
              <div class="aa-client-empty-row">
                Loading Playbooks...
              </div>
            `
            : playbooks.length
              ? playbooks.map((playbook) => {
                  const monthName =
                    monthNames[Number(playbook.month)] ||
                    playbook.month ||
                    'Playbook';

                  const status =
                    String(playbook.status || 'draft')
                      .replaceAll('_', ' ')
                      .replace(/\b\w/g, (letter) =>
                        letter.toUpperCase()
                      );

                  return `
                    <div class="aa-client-template-item">

                      <div class="aa-client-template-item__name">
                        <strong>
                          ${this.escapeHtml(
                            `${monthName} ${playbook.year}`
                          )}
                        </strong>

                        <small>
                          ${this.escapeHtml(status)}
                        </small>
                      </div>

                      <div class="aa-client-template-item__actions">
                        <button
                          class="aa-client-template-action"
                          type="button"
                          data-aa-review-playbook="${playbook.id}"
                        >
                          Open Review
                        </button>
                      </div>

                    </div>
                  `;
                }).join('')
              : `
                <div class="aa-client-empty-row">
                  No Playbooks have been created for this client yet.
                </div>
              `
        }

        </div>
      </div>
    </details>
  `;
}

renderReminderPanel(client) {
    const reminder =
      this.getReminderScheduleDisplay(
        client
      );

    const automationActive =
      String(
        client.reminder_status || ''
      )
        .trim()
        .toLowerCase() === 'scheduled';

    return `
      <section class="aa-client-operation-panel aa-client-reminder-panel">
        <div class="aa-client-reminder-panel__copy">
          <p class="aa-card__label">
            Playbook Email Reminders
          </p>

          <div class="aa-client-reminder-summary aa-client-reminder-summary--clear">
            <span>
              Playbook due
              <strong>
                ${this.ordinal(
                  client.monthly_due_day || 15
                )}
              </strong>
            </span>

            <span>
              Email reminders
              <strong>
                ${this.escapeHtml(
                  reminder.primary
                )}
              </strong>
            </span>

            <span>
              Automation
              <strong>
                ${automationActive
                  ? 'Active'
                  : 'Not active yet'
                }
              </strong>
            </span>
          </div>

          <p class="aa-client-reminder-panel__note">
            ${this.escapeHtml(
              reminder.detail
            )}
          </p>
        </div>

        <form class="aa-client-reminder-settings" data-aa-client-reminder-form="${this.escapeHtml(client.id)}">
          <label>Playbook Due Date (day of month)
            <input data-aa-playbook-reminder-due type="number" min="1" max="31" name="monthly_due_day" value="${this.escapeHtml(client.monthly_due_day || '15')}" required>
          </label>
          <label>Reminder Timing
            <select name="reminder_schedule">${this.getReminderOptions().map(option => `<option value="${this.escapeHtml(option)}" ${client.reminder_schedule === option ? 'selected' : ''}>${this.escapeHtml(option)}</option>`).join('')}</select>
          </label>
          <label>Reminder Email Template
            <select name="reminder_email_template">${this.getReminderTemplateOptions().map(option => `<option value="${this.escapeHtml(option)}" ${client.reminder_email_template === option ? 'selected' : ''}>${this.escapeHtml(option)}</option>`).join('')}</select>
          </label>
          <button class="aa-button aa-button--primary" type="submit">Save Reminder Settings</button>
        </form>
      </section>
    `;
  }

  renderMarketingPackagePanel(client) {
    const services =
      Array.isArray(this.clientPackageServices)
        ? this.clientPackageServices
        : [];

    return `
      <section class="aa-client-package-panel" data-aa-account-section="package">
        <div class="aa-client-package-panel__header">
          <div>
            <h3>Monthly Marketing Package</h3>


          </div>

          <button
            class="aa-button aa-button--primary"
            type="button"
            data-aa-manage-package="${this.escapeHtml(client.id)}"
          >
            ${services.length ? 'Edit Package' : 'Set Up Package'}
          </button>
        </div>

        ${this.clientPackageLoading ? `
          <div class="aa-client-package-empty">
            Loading package...
          </div>
        ` : services.length ? `
          <div class="aa-client-package-grid">
            ${services.map((service) => `
              <article class="aa-client-package-card">
                <div>
                  <span class="aa-client-package-card__category">
                    ${this.escapeHtml(service.category || 'Service')}
                  </span>

                  <h4>
                    ${this.escapeHtml(service.name)}
                  </h4>
                </div>

                <div class="aa-client-package-card__allowance">
                  <strong>
                    ${this.escapeHtml(service.included)}
                  </strong>

                  <span>
                    ${this.escapeHtml(service.unit)}
                  </span>
                </div>

                ${service.notes ? `
                  <p>
                    ${this.escapeHtml(service.notes)}
                  </p>
                ` : ''}
              </article>
            `).join('')}
          </div>
        ` : `
          <div class="aa-client-package-empty">
            <strong>No recurring package configured yet.</strong>
            <span>
              Set the client's actual monthly deliverables here.
            </span>
          </div>
        `}
      </section>
    `;
  }

  formatPackageDate(date = new Date()) {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0')
    ].join('-');
  }

  getDefaultPackageEffectiveDate() {
    const date = new Date();
    date.setMonth(date.getMonth() + 1, 1);
    return this.formatPackageDate(date);
  }

  renderMarketingPackageEditor(client) {
    const hasCurrentPackage =
      Array.isArray(this.clientPackageServices) &&
      this.clientPackageServices.length > 0;
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const selectedByServiceId =
      new Map(
        (this.clientPackageServices || [])
          .map((service) => [
            String(service.serviceId),
            service
          ])
      );

    const unitOptions = [
      'per week',
      'per month',
      'per catalog',
      'per quarter',
      'per year',
      'included'
    ];

    return `
      <form
        class="aa-client-package-editor"
        data-aa-package-form="${this.escapeHtml(client.id)}"
      >
        <div class="aa-client-package-editor__header">
          <div>
            <h3>Package Builder</h3>


          </div>

          <div class="aa-client-package-editor__header-actions">
            <button
              type="button"
              class="aa-button aa-button--secondary"
              data-aa-manage-service-library
            >
              Manage Service Library
            </button>

            <button
              type="button"
              class="aa-button aa-button--secondary"
              data-aa-cancel-package
            >
              Close
            </button>
          </div>
        </div>

        ${this.packageLibraryOpen ? `
          <section class="aa-client-service-library">
            <div class="aa-client-service-library__header">
              <div>
                <p class="aa-card__label">Reusable Services</p>
                <h4>Package Service Library</h4>
                <p>
                  Add a service once and reuse it for any client. Removing a service hides it from future package builders but keeps existing client history intact.
                </p>
              </div>

              <button
                type="button"
                class="aa-client-service-library__close"
                data-aa-close-service-library
              >
                Done
              </button>
            </div>

            <div class="aa-client-service-library__add">
              <div class="aa-client-service-library__add-heading">
                <span>Add a Reusable Service</span>
                <strong>Create it once, then use it for any client.</strong>
              </div>

              <div
                class="aa-client-service-library__form"
                data-aa-service-library-panel
              >
                <label>
                  <span>Service Name</span>
                  <input
                    type="text"
                    placeholder="e.g. Webinar Promotion"
                    data-aa-service-library-name
                  >
                </label>

                <label>
                  <span>Category</span>
                  <input
                    type="text"
                    placeholder="e.g. Marketing"
                    data-aa-service-library-category
                  >
                </label>

                <label>
                  <span>Default Frequency</span>
                  <select data-aa-service-library-unit>
                    ${unitOptions.map((option) => `
                      <option value="${this.escapeHtml(option)}">
                        ${this.escapeHtml(option)}
                      </option>
                    `).join('')}
                  </select>
                </label>

                <label class="aa-client-service-library__wide">
                  <span>Description</span>
                  <input
                    type="text"
                    placeholder="Optional"
                    data-aa-service-library-description
                  >
                </label>

                <button
                  type="button"
                  class="aa-button aa-button--primary aa-button--small"
                  data-aa-add-service-library-item
                >
                  Add to Library
                </button>

                <div
                  class="aa-client-service-library__message"
                  data-aa-service-library-message
                  hidden
                ></div>
              </div>
            </div>

            <div class="aa-client-service-library__list">
              ${(this.serviceCatalog || [])
                .filter((service) => !service.retired)
                .map((service) => `
                  <div class="aa-client-service-library__item">
                    <div>
                      <strong>
                        ${this.escapeHtml(service.name)}
                      </strong>
                      <small>
                        ${this.escapeHtml(service.category || 'Service')}
                        ·
                        ${this.escapeHtml(service.defaultUnitLabel || 'per month')}
                      </small>
                    </div>

                    <button
                      type="button"
                      data-aa-remove-service-library-item="${this.escapeHtml(service.id)}"
                    >
                      Remove from Builder
                    </button>
                  </div>
                `).join('')}
            </div>
          </section>
        ` : ''}

        <fieldset class="aa-client-package-effective">
          <legend>When should this change take effect?</legend>
          <div class="aa-client-package-effective__options">
            <label>
              <input
                type="radio"
                name="aa-package-effective-mode"
                data-aa-package-effective-mode
                value="immediate"
                ${hasCurrentPackage ? '' : 'checked'}
              >
              <span>Effective Immediately</span>
            </label>
            <label>
              <input
                type="radio"
                name="aa-package-effective-mode"
                data-aa-package-effective-mode
                value="scheduled"
                ${hasCurrentPackage ? 'checked' : ''}
              >
              <span>Schedule for Later</span>
            </label>
          </div>
          <label
            class="aa-client-package-effective__schedule"
            data-aa-package-schedule
            ${hasCurrentPackage ? '' : 'hidden'}
          >
            <span>Start Date</span>
            <input
              type="date"
              data-aa-package-effective-date
              min="${this.escapeHtml(this.formatPackageDate(tomorrow))}"
              value="${this.escapeHtml(this.getDefaultPackageEffectiveDate())}"
              ${hasCurrentPackage ? 'required' : ''}
            >
          </label>
        </fieldset>

        <div class="aa-client-package-editor__rows">
          ${(this.serviceCatalog || []).map((catalogService, index) => {
            const selected =
              selectedByServiceId.get(
                String(catalogService.id)
              );

            const included =
              Boolean(selected);

            const quantity =
              selected?.included ??
              (
                catalogService.name === 'Catalog / Flipbook' ||
                catalogService.name === 'Co-op Reporting'
                  ? 1
                  : 0
              );

            const unit =
              selected?.unit ||
              catalogService.defaultUnitLabel ||
              'per month';

            return `
              <article
                class="aa-client-package-editor__row ${included ? 'is-included' : ''}"
                data-aa-package-service-row
              >
                <label class="aa-client-package-editor__include">
                  <input
                    type="checkbox"
                    data-aa-package-include
                    data-aa-package-service-id="${this.escapeHtml(catalogService.id)}"
                    ${included ? 'checked' : ''}
                  >
                  <span></span>
                </label>

                <div class="aa-client-package-editor__service">
                  ${catalogService.name === 'Custom Project' ? `
                    <label class="aa-client-package-editor__custom-name">
                      <span>Custom Deliverable Name</span>
                      <input
                        type="text"
                        value="${this.escapeHtml(selected?.customName || '')}"
                        placeholder="e.g. Monthly VIP Club Promotion"
                        data-aa-package-custom-name
                      >
                    </label>
                  ` : `
                    <strong>
                      ${this.escapeHtml(catalogService.name)}
                    </strong>
                  `}

                  <small>
                    ${this.escapeHtml(catalogService.description || '')}
                  </small>

                  ${catalogService.retired ? `
                    <span class="aa-client-package-editor__retired">
                      Retired from service library
                    </span>
                  ` : ''}
                </div>

                <label class="aa-client-package-editor__quantity">
                  <span>Quantity</span>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    value="${this.escapeHtml(quantity)}"
                    data-aa-package-quantity
                  >
                </label>

                <label class="aa-client-package-editor__unit">
                  <span>Frequency</span>
                  <select data-aa-package-unit>
                    ${unitOptions.map((option) => `
                      <option
                        value="${this.escapeHtml(option)}"
                        ${option === unit ? 'selected' : ''}
                      >
                        ${this.escapeHtml(option)}
                      </option>
                    `).join('')}
                  </select>
                </label>

                <label class="aa-client-package-editor__notes">
                  <span>Notes</span>
                  <input
                    type="text"
                    value="${this.escapeHtml(selected?.notes || '')}"
                    placeholder="Optional"
                    data-aa-package-notes
                  >
                </label>

                <input
                  type="hidden"
                  value="${index}"
                  data-aa-package-display-order
                >
              </article>
            `;
          }).join('')}
        </div>

        <div class="aa-client-package-editor__footer">
          <span>
            This defines the client's contracted recurring work.
          </span>

          <div>
            <button
              type="button"
              class="aa-button aa-button--secondary"
              data-aa-cancel-package
            >
              Cancel
            </button>

            <button
              type="submit"
              class="aa-button aa-button--primary"
              data-aa-save-package
            >
              Save Package
            </button>
          </div>
        </div>
      </form>
    `;
  }

  formatTaskAnchorWhen(anchor) {
    if (['yearly', 'yearly_flexible', 'quarterly', 'quarterly_flexible'].includes(anchor?.scheduleKind)) {
      const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
      const name = months[Number(anchor.monthOfYear || 1) - 1] || 'January';
      const quarterly = anchor.scheduleKind.startsWith('quarterly');
      const flexible = anchor.scheduleKind.endsWith('_flexible');
      const label = quarterly ? `Every 3 months starting ${name}` : `Once per year in ${name}`;
      return flexible ? `${label} · flexible date` : `${label} · day ${Number(anchor.dayOfMonth || 1)}`;
    }
    if (
      anchor?.scheduleKind ===
        'monthly_flexible'
    ) {
      return 'Once per month · flexible date';
    }

    if (
      anchor?.scheduleKind ===
        'weekly'
    ) {
      return `Every ${anchor.weekday || 'Monday'}`;
    }

    if (
      anchor?.scheduleKind ===
        'nth_weekday'
    ) {
      const weekLabels = {
        first: 'First',
        second: 'Second',
        third: 'Third',
        fourth: 'Fourth',
        last: 'Last'
      };

      return `${weekLabels[
        anchor.weekOfMonth
      ] || 'First'} ${anchor.weekday || 'Monday'}`;
    }

    const day =
      Number(
        anchor?.dayOfMonth || 1
      );

    const mod100 = day % 100;
    const suffix =
      mod100 >= 11 &&
      mod100 <= 13
        ? 'th'
        : day % 10 === 1
          ? 'st'
          : day % 10 === 2
            ? 'nd'
            : day % 10 === 3
              ? 'rd'
              : 'th';

    return `${day}${suffix} of each month`;
  }

  getTaskAnchorOwnerName(
    anchor,
    client
  ) {
    if (
      anchor?.useClientOwner !== false
    ) {
      return `Client Owner · ${this.getTeamMemberName(
        client?.primary_team_member_id
      )}`;
    }

    return this.getTeamMemberName(
      anchor?.assigneeTeamMemberId
    );
  }

  getSuggestedPackageServiceId(
    taskType = '',
    existingId = ''
  ) {
    if (existingId) {
      return existingId;
    }

    const normalize = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '');

    const typeKey =
      normalize(taskType);

    if (!typeKey) {
      return '';
    }

    const aliases = {
      email: ['email','emails','emailcampaign','emailcampaigns'],
      socialpost: ['socialpost','socialposts','socialmedia','social'],
      websitebanner: ['websitebanner','websitebanners','webbanner','webbanners'],
      catalogflipbook: ['catalog','catalogs','flipbook','flipbooks','catalogflipbook'],
      manufacturerpromotion: ['manufacturerpromotion','manufacturerpromotions'],
      salespage: ['salespage','salespages'],
      websiteupdate: ['websiteupdate','websiteupdates']
    };

    const aliasKeys =
      aliases[typeKey] ||
      [typeKey];

    const match =
      this.clientPackageServices.find(
        (service) => {
          const serviceKey =
            normalize(service.name);

          return aliasKeys.some(
            (key) =>
              serviceKey === key ||
              serviceKey.includes(key) ||
              key.includes(serviceKey)
          );
        }
      );

    return match?.id || '';
  }

  renderTaskAnchorPackageSummary() {
    const services =
      Array.isArray(
        this.clientPackageServices
      )
        ? this.clientPackageServices
        : [];

    if (!services.length) {
      return `
        <div class="aa-client-anchor-package-summary aa-client-anchor-package-summary--empty">
          <strong>No package is configured yet.</strong>
          <span>
            Task Anchors can still be added, but package counting cannot be connected until the Marketing Package is set.
          </span>
        </div>
      `;
    }

    return `
      <div class="aa-client-anchor-package-summary">
        <div class="aa-client-anchor-package-summary__heading">
          <strong>Package at a glance</strong>
          <span>
            Anchors use part of these existing allowances. They do not add extra contracted work.
          </span>
        </div>

        <div class="aa-client-anchor-package-summary__grid">
          ${services.map((service) => {
            const anchorCount =
              this.clientTaskAnchors
                .filter(
                  (item) =>
                    item.isActive &&
                    item.countsTowardPackage &&
                    !['yearly', 'yearly_flexible', 'quarterly', 'quarterly_flexible'].includes(item.scheduleKind) &&
                    String(
                      item.packageServiceId ||
                      ''
                    ) ===
                    String(service.id)
                )
                .reduce(
                  (total, item) =>
                    total +
                    Number(
                      item.packageUnits || 1
                    ),
                  0
                );

            const unit =
              service.unit ||
              'included';

            const remaining =
              unit === 'per month'
                ? Math.max(
                    Number(
                      service.included || 0
                    ) -
                    anchorCount,
                    0
                  )
                : null;

            return `
              <div class="aa-client-anchor-package-summary__item">
                <span>
                  ${this.escapeHtml(
                    service.name
                  )}
                </span>

                <strong>
                  ${this.escapeHtml(
                    service.included
                  )}
                  ${this.escapeHtml(unit)}
                </strong>

                <small>
                  ${anchorCount
                    ? `${anchorCount} monthly/weekly Task Anchor${anchorCount === 1 ? '' : 's'} already count toward this`
                    : 'No monthly/weekly Task Anchors count toward this yet'
                  }
                  ${remaining !== null && anchorCount
                    ? ` · ${remaining} remaining for monthly planning`
                    : ''
                  }
                </small>
              </div>
            `;
          }).join('')}
        </div>
      </div>
    `;
  }

  renderTaskAnchorEditor(client) {
    const anchor =
      this.editingTaskAnchorId
        ? this.clientTaskAnchors.find(
            (item) =>
              String(item.id) ===
              String(
                this.editingTaskAnchorId
              )
          ) || null
        : null;

    const scheduleKind =
      anchor?.scheduleKind ||
      'day_of_month';

    const ownerValue =
      anchor?.useClientOwner === false
        ? (
            anchor
              .assigneeTeamMemberId ||
            ''
          )
        : 'client_owner';

    const countsTowardPackage =
      anchor
        ? anchor
            .countsTowardPackage !==
          false
        : true;

    const currentTaskType =
      anchor?.taskType || '';

    const suggestedPackageServiceId =
      this.getSuggestedPackageServiceId(
        currentTaskType,
        anchor?.packageServiceId || ''
      );

    const taskTypeNames =
      [
        ...new Set([
          ...this.taskTypes.map(
            (item) => item.name
          ),
          ...(currentTaskType
            ? [currentTaskType]
            : [])
        ])
      ].filter(Boolean);

    return `
      <form
        class="aa-client-task-anchor-editor"
        data-aa-task-anchor-form="${this.escapeHtml(
          client.id
        )}"
        ${anchor?.id
          ? `data-aa-task-anchor-id="${this.escapeHtml(
              anchor.id
            )}"`
          : ''
        }
      >
        <div class="aa-client-task-anchor-editor__header">
          <div>
            <p class="aa-card__label">
              ${anchor
                ? 'Edit Task Anchor'
                : 'New Task Anchor'
              }
            </p>

            <h4>
              ${anchor
                ? this.escapeHtml(
                    anchor.taskName
                  )
                : 'Add recurring work'
              }
            </h4>

            <p>
              A standing rule for future monthly tasks.
            </p>
          </div>

          <button
            type="button"
            class="aa-button aa-button--secondary"
            data-aa-cancel-task-anchor
          >
            Close
          </button>
        </div>

        <div class="aa-client-task-anchor-editor__grid">
          <label class="aa-client-task-anchor-editor__wide">
            <span>Task Name</span>
            <input
              type="text"
              data-aa-task-anchor-field="task_name"
              value="${this.escapeHtml(
                anchor?.taskName || ''
              )}"
              placeholder="e.g. Publish monthly catalog"
              required
            >
          </label>

          <label>
            <span>Task Type</span>
            <select
              data-aa-task-anchor-field="task_type"
              required
            >
              <option value="">
                Select task type
              </option>

              ${taskTypeNames.map(
                (name) => `
                  <option
                    value="${this.escapeHtml(name)}"
                    ${name === currentTaskType
                      ? 'selected'
                      : ''
                    }
                  >
                    ${this.escapeHtml(name)}
                  </option>
                `
              ).join('')}
            </select>
          </label>

          <label>
            <span>When It Happens</span>
            <select
              data-aa-task-anchor-field="schedule_kind"
            >
              <option
                value="day_of_month"
                ${scheduleKind ===
                  'day_of_month'
                    ? 'selected'
                    : ''
                }
              >
                Fixed date each month
              </option>

              <option
                value="nth_weekday"
                ${scheduleKind ===
                  'nth_weekday'
                    ? 'selected'
                    : ''
                }
              >
                Weekday pattern
              </option>

              <option
                value="weekly"
                ${scheduleKind ===
                  'weekly'
                    ? 'selected'
                    : ''
                }
              >
                Every week
              </option>

              <option
                value="monthly_flexible"
                ${scheduleKind ===
                  'monthly_flexible'
                    ? 'selected'
                    : ''
                }
              >
                Once per month, flexible date
              </option>
                          <option value="yearly" ${scheduleKind === 'yearly' ? 'selected' : ''}>Once per year, fixed date</option>
              <option value="yearly_flexible" ${scheduleKind === 'yearly_flexible' ? 'selected' : ''}>Once per year, flexible date</option>
              <option value="quarterly" ${scheduleKind === 'quarterly' ? 'selected' : ''}>Once per quarter, fixed date</option>
              <option value="quarterly_flexible" ${scheduleKind === 'quarterly_flexible' ? 'selected' : ''}>Once per quarter, flexible date</option>
            </select>
          </label>

          <div class="aa-client-task-anchor-editor__schedule aa-client-task-anchor-editor__schedule--weekday"
            data-aa-anchor-periodic-fields
            ${!['yearly', 'yearly_flexible', 'quarterly', 'quarterly_flexible'].includes(scheduleKind) ? 'hidden' : ''}>
            <label>
              <span data-aa-anchor-periodic-month-label>${scheduleKind.startsWith('quarterly') ? 'First Month of Quarterly Cycle' : 'Month'}</span>
              <select data-aa-task-anchor-field="month_of_year">
                <option value="1" ${Number(anchor?.monthOfYear || 1) === 1 ? 'selected' : ''}>January</option>
                <option value="2" ${Number(anchor?.monthOfYear || 1) === 2 ? 'selected' : ''}>February</option>
                <option value="3" ${Number(anchor?.monthOfYear || 1) === 3 ? 'selected' : ''}>March</option>
                <option value="4" ${Number(anchor?.monthOfYear || 1) === 4 ? 'selected' : ''}>April</option>
                <option value="5" ${Number(anchor?.monthOfYear || 1) === 5 ? 'selected' : ''}>May</option>
                <option value="6" ${Number(anchor?.monthOfYear || 1) === 6 ? 'selected' : ''}>June</option>
                <option value="7" ${Number(anchor?.monthOfYear || 1) === 7 ? 'selected' : ''}>July</option>
                <option value="8" ${Number(anchor?.monthOfYear || 1) === 8 ? 'selected' : ''}>August</option>
                <option value="9" ${Number(anchor?.monthOfYear || 1) === 9 ? 'selected' : ''}>September</option>
                <option value="10" ${Number(anchor?.monthOfYear || 1) === 10 ? 'selected' : ''}>October</option>
                <option value="11" ${Number(anchor?.monthOfYear || 1) === 11 ? 'selected' : ''}>November</option>
                <option value="12" ${Number(anchor?.monthOfYear || 1) === 12 ? 'selected' : ''}>December</option>
              </select>
            </label>
            <label data-aa-anchor-periodic-day-fields ${scheduleKind.endsWith('_flexible') ? 'hidden' : ''}>
              <span>Day of Month</span>
              <input type="number" min="1" max="31"
                data-aa-task-anchor-field="periodic_day_of_month"
                value="${this.escapeHtml(anchor?.dayOfMonth || 1)}">
            </label>
            <div class="aa-client-task-anchor-flexible-note"
              data-aa-anchor-periodic-flex-note
              ${!scheduleKind.endsWith('_flexible') ? 'hidden' : ''}>
              ${scheduleKind.startsWith('quarterly') ? 'One task every three months. The generator chooses a date within each selected month.' : 'One task per year. The generator chooses a date within the selected month.'}
            </div>
          </div>

          <div
            class="aa-client-task-anchor-editor__schedule"
            data-aa-anchor-day-fields
            ${scheduleKind !==
              'day_of_month'
                ? 'hidden'
                : ''
            }
          >
            <label>
              <span>Day of Month</span>
              <input
                type="number"
                min="1"
                max="31"
                data-aa-task-anchor-field="day_of_month"
                value="${this.escapeHtml(
                  anchor?.dayOfMonth || 1
                )}"
              >
            </label>
          </div>

          <div
            class="aa-client-task-anchor-editor__schedule aa-client-task-anchor-editor__schedule--weekday"
            data-aa-anchor-weekday-fields
            ${scheduleKind !==
              'nth_weekday'
                ? 'hidden'
                : ''
            }
          >
            <label>
              <span>Week</span>
              <select
                data-aa-task-anchor-field="week_of_month"
              >
                ${[
                  ['first','First'],
                  ['second','Second'],
                  ['third','Third'],
                  ['fourth','Fourth'],
                  ['last','Last']
                ].map(
                  ([value,label]) => `
                    <option
                      value="${value}"
                      ${String(
                        anchor?.weekOfMonth ||
                        'first'
                      ) === value
                        ? 'selected'
                        : ''
                      }
                    >
                      ${label}
                    </option>
                  `
                ).join('')}
              </select>
            </label>

            <label>
              <span>Day</span>
              <select
                data-aa-task-anchor-field="weekday"
              >
                ${[
                  'Monday',
                  'Tuesday',
                  'Wednesday',
                  'Thursday',
                  'Friday',
                  'Saturday',
                  'Sunday'
                ].map(
                  (day) => `
                    <option
                      value="${day}"
                      ${String(
                        anchor?.weekday ||
                        'Monday'
                      ) === day
                        ? 'selected'
                        : ''
                      }
                    >
                      ${day}
                    </option>
                  `
                ).join('')}
              </select>
            </label>
          </div>

          <div
            class="aa-client-task-anchor-editor__schedule"
            data-aa-anchor-weekly-fields
            ${scheduleKind !==
              'weekly'
                ? 'hidden'
                : ''
            }
          >
            <label>
              <span>Day</span>
              <select
                data-aa-task-anchor-field="weekly_weekday"
              >
                ${[
                  'Monday',
                  'Tuesday',
                  'Wednesday',
                  'Thursday',
                  'Friday',
                  'Saturday',
                  'Sunday'
                ].map(
                  (day) => `
                    <option
                      value="${day}"
                      ${String(
                        anchor?.weekday ||
                        'Monday'
                      ) === day
                        ? 'selected'
                        : ''
                      }
                    >
                      ${day}
                    </option>
                  `
                ).join('')}
              </select>
            </label>
          </div>

          <div
            class="aa-client-task-anchor-flexible-note"
            data-aa-anchor-flexible-fields
            ${scheduleKind !==
              'monthly_flexible'
                ? 'hidden'
                : ''
            }
          >
            One task per month. The generator will choose the most appropriate date for that month.
          </div>

          <label>
            <span>Owner</span>
            <select
              data-aa-task-anchor-field="owner"
            >
              <option
                value="client_owner"
                ${ownerValue ===
                  'client_owner'
                    ? 'selected'
                    : ''
                }
              >
                Client Owner
              </option>

              ${this.internalTeamMembers
                .map(
                  (member) => `
                    <option
                      value="${this.escapeHtml(
                        member.id
                      )}"
                      ${String(
                        ownerValue
                      ) ===
                      String(member.id)
                        ? 'selected'
                        : ''
                      }
                    >
                      ${this.escapeHtml(
                        member.display_name ||
                        member.aa_roles
                          ?.display_name ||
                        'Team Member'
                      )}
                    </option>
                  `
                )
                .join('')}
            </select>
          </label>

          <label class="aa-client-task-anchor-check">
            <input
              type="checkbox"
              data-aa-task-anchor-field="counts_toward_package"
              ${countsTowardPackage
                ? 'checked'
                : ''
              }
            >
            <span>
              Counts toward the client's package
            </span>
            <small>
              Off = courtesy or internal work.
            </small>
          </label>

          <div
            class="aa-client-task-anchor-editor__package aa-client-task-anchor-editor__package--simple"
            data-aa-anchor-package-fields
            ${countsTowardPackage
              ? ''
              : 'hidden'
            }
          >
            <label>
              <span>Which package allowance does this use?</span>
              <select
                data-aa-task-anchor-field="package_service_id"
              >
                <option value="">
                  Select package service
                </option>

                ${this.clientPackageServices
                  .map(
                    (service) => `
                      <option
                        value="${this.escapeHtml(
                          service.id
                        )}"
                        ${String(
                          suggestedPackageServiceId
                        ) ===
                        String(service.id)
                          ? 'selected'
                          : ''
                        }
                      >
                        ${this.escapeHtml(
                          service.name
                        )}
                        ·
                        ${this.escapeHtml(
                          service.included
                        )}
                        ${this.escapeHtml(
                          service.unit
                        )}
                      </option>
                    `
                  )
                  .join('')}
              </select>

              <small class="aa-client-task-anchor-editor__helper">
                Each Task Anchor counts as one deliverable. The rest of the package is filled during monthly planning.
              </small>

              <input
                type="hidden"
                data-aa-task-anchor-field="package_units"
                value="1"
              >
            </label>
          </div>

          <label class="aa-client-task-anchor-editor__wide">
            <span>Notes / Instructions</span>
            <textarea
              rows="3"
              data-aa-task-anchor-field="notes"
              placeholder="Optional standing instructions for this task"
            >${this.escapeHtml(
              anchor?.notes || ''
            )}</textarea>
          </label>

          <label class="aa-client-task-anchor-check">
            <input
              type="checkbox"
              data-aa-task-anchor-field="is_active"
              ${anchor?.isActive === false
                ? ''
                : 'checked'
              }
            >
            <span>Generate future tasks</span><small>Uncheck to pause this rule without deleting it. Existing tasks remain.</small>
          </label>
        </div>

        <div class="aa-client-task-anchor-editor__actions">
          <button
            type="submit"
            class="aa-button aa-button--primary"
          >
            ${anchor
              ? 'Save Task Anchor'
              : 'Add Task Anchor'
            }
          </button>
        </div>
      </form>
    `;
  }

  renderProductionRulesPanel(client) {
    const settings =
      this.clientProductionSettings || {
        preferredEmailWeekday: '',
        preferredEmailWeekdays: [],
        preferredEmailTime: '',
        doNotPromote: '',
        priorityPromotions: '',
        standingRules: ''
      };

    return `
      <section class="aa-client-production-rules-panel">
        <div class="aa-client-task-anchors__header">
          <div>
            <h3>Production Rules</h3>


          </div>
        </div>

        <form
          class="aa-client-production-rules"
          data-aa-production-settings-form="${this.escapeHtml(
            client.id
          )}"
        >
          <div class="aa-client-production-rules__grid">
            <fieldset class="aa-production-email-days">
              <legend>Preferred Email Days</legend>
              <p>Select usual send days. The monthly package determines the email count.</p>
              <div class="aa-production-email-days__choices">
                ${['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'].map(day => `
                  <label class="aa-production-email-days__choice">
                    <input
                      type="checkbox"
                      value="${day}"
                      data-aa-production-email-day
                      ${(Array.isArray(settings.preferredEmailWeekdays) && settings.preferredEmailWeekdays.length
                        ? settings.preferredEmailWeekdays
                        : (settings.preferredEmailWeekday ? [settings.preferredEmailWeekday] : [])
                      ).includes(day) ? 'checked' : ''}
                    >
                    <span>${day}</span>
                  </label>
                `).join('')}
              </div>
              <small>None selected = flexible scheduling.</small>
            </fieldset>

            <label>
              <span>Preferred Send Time</span>
              <input
                type="time"
                data-aa-production-field="preferred_email_time"
                value="${this.escapeHtml(
                  settings
                    .preferredEmailTime ||
                  ''
                )}"
              >
            </label>

            <label>
              <span>Do Not Promote</span>
              <textarea
                rows="3"
                data-aa-production-field="do_not_promote"
                placeholder="Brands, product types, models, or topics this client does not want advertised."
              >${this.escapeHtml(
                settings.doNotPromote || ''
              )}</textarea>
            </label>

            <label>
              <span>Priority Brands / Products</span>
              <textarea
                rows="3"
                data-aa-production-field="priority_promotions"
                placeholder="Brands, machines, collections, or categories that should receive extra priority."
              >${this.escapeHtml(
                settings.priorityPromotions || ''
              )}</textarea>
            </label>

            <label class="aa-client-production-rules__wide">
              <span>Other Standing Rules</span>
              <textarea
                rows="4"
                data-aa-production-field="standing_rules"
                placeholder="Example: Catalog email always counts as one of the monthly emails. Do not repeat the same manufacturer every week."
              >${this.escapeHtml(
                settings.standingRules || ''
              )}</textarea>
            </label>
          </div>

          <div class="aa-client-production-rules__actions">
            <button
              type="submit"
              class="aa-button aa-button--primary"
            >
              Save Production Rules
            </button>
          </div>
        </form>
      </section>
    `;
  }

  renderTaskAnchorsPanel(client) {
    const activeClientAnchors =
      this.clientTaskAnchors.filter(
        (item) => item.isActive
      );

    const activeSharedAnchors =
      this.sharedTaskAnchors.filter(
        (item) => item.isActive
      );

    return `
      <section
        class="aa-client-task-anchors"
        data-aa-account-section="anchors"
      >
        <div class="aa-client-task-anchors__header">
          <div>
            <h3>Task Anchors</h3>


          </div>
        </div>

        <div class="aa-client-task-anchor-note">
          <strong>
            Task Anchors do not add to the package.
          </strong>
          <span>
            When an anchor counts toward contracted work, it
            reserves one of the client's existing package
            deliverables.
          </span>
        </div>

        <div class="aa-client-task-anchor-sections">
          <section class="aa-client-task-anchor-section">
            <div class="aa-client-task-anchor-section__header">
              <div>
                <span class="aa-card__label">
                  Shared Task Anchors
                </span>
                <h4>Create once. Assign where it belongs.</h4>
                <p>
                  Use these for recurring work shared by more
                  than one client.
                </p>
              </div>

              <button
                type="button"
                class="aa-button aa-button--primary"
                data-aa-add-shared-task-anchor
              >
                Add Shared Task Anchor
              </button>
            </div>

            ${
              this.taskAnchorEditorOpen &&
              this.taskAnchorEditorScope === 'shared'
                ? this.renderSharedTaskAnchorEditor(
                    client
                  )
                : ''
            }

            ${
              this.sharedTaskAnchorsLoading
                ? `
                  <div class="aa-client-task-anchors__empty">
                    Loading Shared Task Anchors...
                  </div>
                `
                : this.sharedTaskAnchors.length
                  ? `
                    <div class="aa-client-task-anchor-list">
                      <div class="aa-client-task-anchor-list__summary">
                        <strong>
                          ${activeSharedAnchors.length}
                          active shared anchor${activeSharedAnchors.length === 1 ? '' : 's'}
                        </strong>
                        <span>
                          One rule can cover several clients.
                        </span>
                      </div>

                      ${this.sharedTaskAnchors
                        .map((anchor) => {
                          const assignedClientIds =
                            Array.isArray(anchor.clientIds)
                              ? anchor.clientIds
                              : [];

                          const appliesToAll =
                            this.clients.length > 0 &&
                            this.clients.every(
                              (item) =>
                                assignedClientIds.some(
                                  (id) =>
                                    String(id) ===
                                    String(item.id)
                                )
                            );

                          const appliesHere =
                            assignedClientIds.some(
                              (id) =>
                                String(id) ===
                                String(client.id)
                            );

                          const packageName =
                            this.serviceCatalog.find(
                              (service) =>
                                String(service.id) ===
                                String(
                                  anchor.packageServiceCatalogId
                                )
                            )?.name ||
                            'package';

                          return `
                            <article
                              class="aa-client-task-anchor-row aa-client-task-anchor-row--shared
                                ${anchor.isActive ? '' : 'is-inactive'}"
                            >
                              <div class="aa-client-task-anchor-row__main">
                                <span>
                                  ${this.escapeHtml(anchor.taskType)}
                                </span>
                                <strong>
                                  ${this.escapeHtml(anchor.taskName)}
                                </strong>
                                ${!anchor.isActive ? '<small class="aa-anchor-paused">Paused · no future tasks</small>' : ''}
                                ${!appliesHere ? `<small>Not assigned to ${this.escapeHtml(client.business_name)}</small>` : ''}
                              </div>

                              <div>
                                <span>When</span>
                                <strong>
                                  ${this.escapeHtml(
                                    this.formatTaskAnchorWhen(anchor)
                                  )}
                                </strong>
                              </div>

                              <div>
                                <span>Owner</span>
                                <strong>
                                  ${anchor.useClientOwner !== false
                                    ? 'Each Client Owner'
                                    : this.escapeHtml(
                                        this.getTeamMemberName(
                                          anchor.assigneeTeamMemberId
                                        )
                                      )
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>Package</span>
                                <strong>
                                  ${anchor.countsTowardPackage
                                    ? `1 of ${this.escapeHtml(packageName)}`
                                    : 'Courtesy / Free'
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>Applies To</span>
                                <strong>
                                  ${appliesToAll
                                    ? 'All active clients'
                                    : `${assignedClientIds.length} client${assignedClientIds.length === 1 ? '' : 's'}`
                                  }
                                </strong>
                              </div>

                              <div class="aa-client-task-anchor-row__actions">
                                <button
                                  type="button"
                                  data-aa-edit-shared-task-anchor="${this.escapeHtml(anchor.id)}"
                                >
                                  Edit
                                </button>


                              </div>
                            </article>
                          `;
                        })
                        .join('')}
                    </div>
                  `
                  : `
                    <div class="aa-client-task-anchors__empty">
                      <strong>No Shared Task Anchors yet.</strong>
                      <span>
                        Create one once, then choose which clients
                        it applies to.
                      </span>
                    </div>
                  `
            }
          </section>

          <section class="aa-client-task-anchor-section">
            <div class="aa-client-task-anchor-section__header">
              <div>
                <span class="aa-card__label">
                  This Client Only
                </span>
                <h4>
                  ${this.escapeHtml(client.business_name)}
                </h4>
                <p>
                  Use this only for recurring work unique to
                  this client.
                </p>
              </div>

              <button
                type="button"
                class="aa-button aa-button--primary"
                data-aa-add-client-task-anchor
              >
                Add for This Client
              </button>
            </div>

            ${
              this.taskAnchorEditorOpen &&
              this.taskAnchorEditorScope === 'client'
                ? this.renderTaskAnchorEditor(
                    client
                  )
                : ''
            }

            ${
              this.clientTaskAnchorsLoading
                ? `
                  <div class="aa-client-task-anchors__empty">
                    Loading Task Anchors...
                  </div>
                `
                : this.clientTaskAnchors.length
                  ? `
                    <div class="aa-client-task-anchor-list">
                      <div class="aa-client-task-anchor-list__summary">
                        <strong>
                          ${activeClientAnchors.length}
                          active client-only anchor${activeClientAnchors.length === 1 ? '' : 's'}
                        </strong>
                        <span>
                          Unique to ${this.escapeHtml(client.business_name)}.
                        </span>
                      </div>

                      ${this.clientTaskAnchors
                        .map(
                          (anchor) => `
                            <article
                              class="aa-client-task-anchor-row
                                ${anchor.isActive ? '' : 'is-inactive'}"
                            >
                              <div class="aa-client-task-anchor-row__main">
                                <span>
                                  ${this.escapeHtml(anchor.taskType)}
                                </span>
                                <strong>
                                  ${this.escapeHtml(anchor.taskName)}
                                </strong>
                                ${!anchor.isActive ? '<small class="aa-anchor-paused">Paused · no future tasks</small>' : ''}
                                ${anchor.notes
                                  ? `
                                    <small>
                                      ${this.escapeHtml(anchor.notes)}
                                    </small>
                                  `
                                  : ''
                                }
                              </div>

                              <div>
                                <span>When</span>
                                <strong>
                                  ${this.escapeHtml(
                                    this.formatTaskAnchorWhen(anchor)
                                  )}
                                </strong>
                              </div>

                              <div>
                                <span>Owner</span>
                                <strong>
                                  ${this.escapeHtml(
                                    this.getTaskAnchorOwnerName(
                                      anchor,
                                      client
                                    )
                                  )}
                                </strong>
                              </div>

                              <div>
                                <span>Package</span>
                                <strong>
                                  ${anchor.countsTowardPackage
                                    ? `1 of ${this.escapeHtml(
                                        this.clientPackageServices.find(
                                          (service) =>
                                            String(service.id) ===
                                            String(anchor.packageServiceId)
                                        )?.name ||
                                        'package'
                                      )}`
                                    : 'Courtesy / Free'
                                  }
                                </strong>
                              </div>

                              <div class="aa-client-task-anchor-row__status">
                                <span>Status</span>
                                <strong>
                                  ${anchor.isActive ? 'Active' : 'Inactive'}
                                </strong>
                              </div>

                              <div class="aa-client-task-anchor-row__actions">
                                <button
                                  type="button"
                                  data-aa-edit-task-anchor="${this.escapeHtml(anchor.id)}"
                                >
                                  Edit
                                </button>


                              </div>
                            </article>
                          `
                        )
                        .join('')}
                    </div>
                  `
                  : `
                    <div class="aa-client-task-anchors__empty">
                      <strong>
                        No client-only Task Anchors.
                      </strong>
                      <span>
                        That's fine. Only add something here when
                        it is unique to this client.
                      </span>
                    </div>
                  `
            }
          </section>
        </div>
      </section>
    `;
  }

  renderSharedTaskAnchorEditor(client) {
    const anchor =
      this.editingSharedTaskAnchorId
        ? this.sharedTaskAnchors.find(
            (item) =>
              String(item.id) ===
              String(
                this.editingSharedTaskAnchorId
              )
          ) || null
        : null;

    const scheduleKind =
      anchor?.scheduleKind ||
      'day_of_month';

    const ownerValue =
      anchor?.useClientOwner === false
        ? (
            anchor
              .assigneeTeamMemberId ||
            ''
          )
        : 'client_owner';

    const countsTowardPackage =
      anchor
        ? anchor.countsTowardPackage !== false
        : true;

    const currentTaskType =
      anchor?.taskType || '';

    const taskTypeNames =
      [
        ...new Set([
          ...this.taskTypes.map(
            (item) => item.name
          ),
          ...(currentTaskType
            ? [currentTaskType]
            : [])
        ])
      ].filter(Boolean);

    const assignedIds =
      new Set(
        anchor?.clientIds?.map(String) ||
        [String(client.id)]
      );

    const allClientsSelected =
      Boolean(anchor) &&
      this.clients.length > 0 &&
      this.clients.every(
        (item) =>
          assignedIds.has(
            String(item.id)
          )
      );

    const assignmentMode =
      allClientsSelected
        ? 'all'
        : 'selected';

    return `
      <form
        class="aa-client-task-anchor-editor aa-client-task-anchor-editor--shared"
        data-aa-shared-task-anchor-form
        ${anchor?.id
          ? `data-aa-shared-task-anchor-id="${this.escapeHtml(anchor.id)}"`
          : ''
        }
      >
        <div class="aa-client-task-anchor-editor__header">
          <div>
            <p class="aa-card__label">
              ${anchor ? 'Edit Shared Task Anchor' : 'New Shared Task Anchor'}
            </p>

            <h4>
              ${anchor
                ? this.escapeHtml(anchor.taskName)
                : 'Create recurring work once'
              }
            </h4>

            <p>
              Use one recurring rule across selected clients.
            </p>
          </div>

          <button
            type="button"
            class="aa-button aa-button--secondary"
            data-aa-cancel-task-anchor
          >
            Close
          </button>
        </div>

        <div class="aa-client-task-anchor-assignment">
          <strong>Who does this apply to?</strong>

          <div class="aa-client-task-anchor-assignment__choices">
            <label>
              <input
                type="radio"
                name="shared-anchor-assignment"
                value="all"
                data-aa-shared-anchor-assignment-mode
                ${assignmentMode === 'all' ? 'checked' : ''}
              >
              <span>All active clients</span>
            </label>

            <label>
              <input
                type="radio"
                name="shared-anchor-assignment"
                value="selected"
                data-aa-shared-anchor-assignment-mode
                ${assignmentMode === 'selected' ? 'checked' : ''}
              >
              <span>Selected clients</span>
            </label>
          </div>

          <small>New clients aren't added automatically.</small>

          <div
            class="aa-client-task-anchor-client-picker"
            data-aa-shared-anchor-client-picker
            ${assignmentMode === 'all' ? 'hidden' : ''}
          >
            ${this.clients
              .map(
                (item) => `
                  <label>
                    <input
                      type="checkbox"
                      value="${this.escapeHtml(item.id)}"
                      data-aa-shared-anchor-client
                      ${assignedIds.has(String(item.id)) ? 'checked' : ''}
                    >
                    <span>
                      ${this.escapeHtml(item.business_name)}
                    </span>
                  </label>
                `
              )
              .join('')}
          </div>
        </div>

        <div class="aa-client-task-anchor-editor__grid">
          <label class="aa-client-task-anchor-editor__wide">
            <span>Task Name</span>
            <input
              type="text"
              data-aa-shared-task-anchor-field="task_name"
              value="${this.escapeHtml(anchor?.taskName || '')}"
              placeholder="e.g. Catalog Social Post"
              required
            >
          </label>

          <label>
            <span>Task Type</span>
            <select
              data-aa-shared-task-anchor-field="task_type"
              required
            >
              <option value="">Select task type</option>
              ${taskTypeNames
                .map(
                  (name) => `
                    <option
                      value="${this.escapeHtml(name)}"
                      ${name === currentTaskType ? 'selected' : ''}
                    >
                      ${this.escapeHtml(name)}
                    </option>
                  `
                )
                .join('')}
            </select>
          </label>

          <label>
            <span>When It Happens</span>
            <select
              data-aa-shared-task-anchor-field="schedule_kind"
            >
              <option
                value="day_of_month"
                ${scheduleKind === 'day_of_month' ? 'selected' : ''}
              >
                Fixed date each month
              </option>
              <option
                value="nth_weekday"
                ${scheduleKind === 'nth_weekday' ? 'selected' : ''}
              >
                Weekday pattern
              </option>
              <option
                value="weekly"
                ${scheduleKind === 'weekly' ? 'selected' : ''}
              >
                Every week
              </option>
              <option
                value="monthly_flexible"
                ${scheduleKind === 'monthly_flexible' ? 'selected' : ''}
              >
                Once per month, flexible date
              </option>
                          <option value="yearly" ${scheduleKind === 'yearly' ? 'selected' : ''}>Once per year, fixed date</option>
              <option value="yearly_flexible" ${scheduleKind === 'yearly_flexible' ? 'selected' : ''}>Once per year, flexible date</option>
              <option value="quarterly" ${scheduleKind === 'quarterly' ? 'selected' : ''}>Once per quarter, fixed date</option>
              <option value="quarterly_flexible" ${scheduleKind === 'quarterly_flexible' ? 'selected' : ''}>Once per quarter, flexible date</option>
            </select>
          </label>

          <div class="aa-client-task-anchor-editor__schedule aa-client-task-anchor-editor__schedule--weekday"
            data-aa-shared-anchor-periodic-fields
            ${!['yearly', 'yearly_flexible', 'quarterly', 'quarterly_flexible'].includes(scheduleKind) ? 'hidden' : ''}>
            <label>
              <span data-aa-shared-anchor-periodic-month-label>${scheduleKind.startsWith('quarterly') ? 'First Month of Quarterly Cycle' : 'Month'}</span>
              <select data-aa-shared-task-anchor-field="month_of_year">
                <option value="1" ${Number(anchor?.monthOfYear || 1) === 1 ? 'selected' : ''}>January</option>
                <option value="2" ${Number(anchor?.monthOfYear || 1) === 2 ? 'selected' : ''}>February</option>
                <option value="3" ${Number(anchor?.monthOfYear || 1) === 3 ? 'selected' : ''}>March</option>
                <option value="4" ${Number(anchor?.monthOfYear || 1) === 4 ? 'selected' : ''}>April</option>
                <option value="5" ${Number(anchor?.monthOfYear || 1) === 5 ? 'selected' : ''}>May</option>
                <option value="6" ${Number(anchor?.monthOfYear || 1) === 6 ? 'selected' : ''}>June</option>
                <option value="7" ${Number(anchor?.monthOfYear || 1) === 7 ? 'selected' : ''}>July</option>
                <option value="8" ${Number(anchor?.monthOfYear || 1) === 8 ? 'selected' : ''}>August</option>
                <option value="9" ${Number(anchor?.monthOfYear || 1) === 9 ? 'selected' : ''}>September</option>
                <option value="10" ${Number(anchor?.monthOfYear || 1) === 10 ? 'selected' : ''}>October</option>
                <option value="11" ${Number(anchor?.monthOfYear || 1) === 11 ? 'selected' : ''}>November</option>
                <option value="12" ${Number(anchor?.monthOfYear || 1) === 12 ? 'selected' : ''}>December</option>
              </select>
            </label>
            <label data-aa-shared-anchor-periodic-day-fields ${scheduleKind.endsWith('_flexible') ? 'hidden' : ''}>
              <span>Day of Month</span>
              <input type="number" min="1" max="31"
                data-aa-shared-task-anchor-field="periodic_day_of_month"
                value="${this.escapeHtml(anchor?.dayOfMonth || 1)}">
            </label>
            <div class="aa-client-task-anchor-flexible-note"
              data-aa-shared-anchor-periodic-flex-note
              ${!scheduleKind.endsWith('_flexible') ? 'hidden' : ''}>
              ${scheduleKind.startsWith('quarterly') ? 'One task every three months. The generator chooses a date within each selected month.' : 'One task per year. The generator chooses a date within the selected month.'}
            </div>
          </div>

          <div
            class="aa-client-task-anchor-editor__schedule"
            data-aa-shared-anchor-day-fields
            ${scheduleKind !== 'day_of_month' ? 'hidden' : ''}
          >
            <label>
              <span>Day of Month</span>
              <input
                type="number"
                min="1"
                max="31"
                data-aa-shared-task-anchor-field="day_of_month"
                value="${this.escapeHtml(anchor?.dayOfMonth || 1)}"
              >
            </label>
          </div>

          <div
            class="aa-client-task-anchor-editor__schedule aa-client-task-anchor-editor__schedule--weekday"
            data-aa-shared-anchor-weekday-fields
            ${scheduleKind !== 'nth_weekday' ? 'hidden' : ''}
          >
            <label>
              <span>Week</span>
              <select data-aa-shared-task-anchor-field="week_of_month">
                ${[
                  ['first','First'],
                  ['second','Second'],
                  ['third','Third'],
                  ['fourth','Fourth'],
                  ['last','Last']
                ].map(
                  ([value,label]) => `
                    <option
                      value="${value}"
                      ${String(anchor?.weekOfMonth || 'first') === value ? 'selected' : ''}
                    >
                      ${label}
                    </option>
                  `
                ).join('')}
              </select>
            </label>

            <label>
              <span>Day</span>
              <select data-aa-shared-task-anchor-field="weekday">
                ${[
                  'Monday',
                  'Tuesday',
                  'Wednesday',
                  'Thursday',
                  'Friday',
                  'Saturday',
                  'Sunday'
                ].map(
                  (day) => `
                    <option
                      value="${day}"
                      ${String(anchor?.weekday || 'Monday') === day ? 'selected' : ''}
                    >
                      ${day}
                    </option>
                  `
                ).join('')}
              </select>
            </label>
          </div>

          <div
            class="aa-client-task-anchor-editor__schedule"
            data-aa-shared-anchor-weekly-fields
            ${scheduleKind !== 'weekly' ? 'hidden' : ''}
          >
            <label>
              <span>Day</span>
              <select data-aa-shared-task-anchor-field="weekly_weekday">
                ${[
                  'Monday',
                  'Tuesday',
                  'Wednesday',
                  'Thursday',
                  'Friday',
                  'Saturday',
                  'Sunday'
                ].map(
                  (day) => `
                    <option
                      value="${day}"
                      ${String(anchor?.weekday || 'Monday') === day ? 'selected' : ''}
                    >
                      ${day}
                    </option>
                  `
                ).join('')}
              </select>
            </label>
          </div>

          <div
            class="aa-client-task-anchor-flexible-note"
            data-aa-shared-anchor-flexible-fields
            ${scheduleKind !== 'monthly_flexible' ? 'hidden' : ''}
          >
            One task per month. The generator will choose the most appropriate date for that month.
          </div>

          <label>
            <span>Owner</span>
            <select data-aa-shared-task-anchor-field="owner">
              <option
                value="client_owner"
                ${ownerValue === 'client_owner' ? 'selected' : ''}
              >
                Each Client's Account Manager
              </option>

              ${this.internalTeamMembers
                .map(
                  (member) => `
                    <option
                      value="${this.escapeHtml(member.id)}"
                      ${String(ownerValue) === String(member.id) ? 'selected' : ''}
                    >
                      ${this.escapeHtml(
                        member.display_name ||
                        member.aa_roles?.display_name ||
                        'Team Member'
                      )}
                    </option>
                  `
                )
                .join('')}
            </select>
          </label>

          <label class="aa-client-task-anchor-check">
            <input
              type="checkbox"
              data-aa-shared-task-anchor-field="counts_toward_package"
              ${countsTowardPackage ? 'checked' : ''}
            >
            <span>
              Counts toward the client's package
            </span>
            <small>
              Off = courtesy or internal work.
            </small>
          </label>

          <div
            class="aa-client-task-anchor-editor__package aa-client-task-anchor-editor__package--simple"
            data-aa-shared-anchor-package-fields
            ${countsTowardPackage ? '' : 'hidden'}
          >
            <label>
              <span>Which package service does this use?</span>
              <select data-aa-shared-task-anchor-field="package_service_catalog_id">
                <option value="">Select package service</option>

                ${this.serviceCatalog
                  .filter((service) => !service.retired)
                  .map(
                    (service) => `
                      <option
                        value="${this.escapeHtml(service.id)}"
                        ${String(anchor?.packageServiceCatalogId || '') === String(service.id) ? 'selected' : ''}
                      >
                        ${this.escapeHtml(service.name)}
                      </option>
                    `
                  )
                  .join('')}
              </select>
            </label>
          </div>

          <label class="aa-client-task-anchor-editor__wide">
            <span>Notes / Instructions</span>
            <textarea
              rows="3"
              data-aa-shared-task-anchor-field="notes"
              placeholder="Optional standing instructions for this task"
            >${this.escapeHtml(anchor?.notes || '')}</textarea>
          </label>

          <label class="aa-client-task-anchor-check">
            <input
              type="checkbox"
              data-aa-shared-task-anchor-field="is_active"
              ${anchor?.isActive === false ? '' : 'checked'}
            >
            <span>Generate future tasks</span><small>Uncheck to pause this shared rule for all assigned clients. Existing tasks remain.</small>
          </label>
        </div>

        <div class="aa-client-task-anchor-editor__actions">
          <button
            type="submit"
            class="aa-button aa-button--primary"
          >
            ${anchor ? 'Save Shared Task Anchor' : 'Add Shared Task Anchor'}
          </button>
        </div>
      </form>
    `;
  }

  renderAccountAccessPanel(client) {
    const access =
      Array.isArray(this.clientAccessRequirements)
        ? this.clientAccessRequirements
        : [];

    const required =
      access.filter((item) => item.isRequired !== false);

    const verified =
      required.filter(
        (item) => item.status === 'verified'
      );

    const needsAttention =
      required.filter(
        (item) =>
          item.status !== 'verified'
      );

    return `
      <section class="aa-client-access-panel" data-aa-account-section="access">
        <div class="aa-client-access-panel__header">
          <div>
            <p class="aa-card__label">
              Account Access
            </p>

            <h3>
              Connected Accounts
            </h3>

            <p>
              Track the platforms this client must provide,
              the Artisan's Avenue login identity, and verification status.
            </p>
          </div>

          <button
            class="aa-button aa-button--primary"
            type="button"
            data-aa-manage-access="${this.escapeHtml(client.id)}"
          >
            ${access.length ? 'Manage Access' : 'Set Up Access'}
          </button>
        </div>

        ${this.clientAccessLoading ? `
          <div class="aa-client-access-empty">
            Loading account access...
          </div>
        ` : access.length ? `
          <div class="aa-client-access-summary">
            <div>
              <span>Required</span>
              <strong>${required.length}</strong>
            </div>

            <div>
              <span>Verified</span>
              <strong>${verified.length}</strong>
            </div>

            <div class="${needsAttention.length ? 'is-warning' : 'is-good'}">
              <span>Needs Attention</span>
              <strong>${needsAttention.length}</strong>
            </div>
          </div>

          <div class="aa-client-access-grid">
            ${access.map((item) => `
              <article class="aa-client-access-card">
                <div class="aa-client-access-card__top">
                  <div>
                    <span>
                      ${this.escapeHtml(item.platformName)}
                    </span>

                    <strong>
                      ${this.escapeHtml(
                        this.formatAccessStatus(item.status)
                      )}
                    </strong>
                  </div>

                  <span
                    class="aa-client-access-status"
                    data-status="${this.escapeHtml(item.status)}"
                  ></span>
                </div>

                <dl>
                  <div>
                    <dt>Login Email</dt>
                    <dd>
                      ${this.escapeHtml(
                        item.loginEmail || 'Not set'
                      )}
                    </dd>
                  </div>

                  ${item.loginUsername ? `
                    <div>
                      <dt>Username</dt>
                      <dd>
                        ${this.escapeHtml(item.loginUsername)}
                      </dd>
                    </div>
                  ` : ''}

                  <div>
                    <dt>Access Method</dt>
                    <dd>
                      ${this.escapeHtml(
                        String(item.accessMethod || 'invite')
                          .replaceAll('_', ' ')
                          .replace(/\b\w/g, (letter) => letter.toUpperCase())
                      )}
                    </dd>
                  </div>
                </dl>
              </article>
            `).join('')}
          </div>
        ` : `
          <div class="aa-client-access-empty">
            <strong>No account access requirements configured yet.</strong>
            <span>
              Add the platforms Artisan's Avenue needs for this client.
            </span>
          </div>
        `}
      </section>
    `;
  }

  renderAccountAccessEditor(client) {
    const existingByPlatformId =
      new Map(
        (this.clientAccessRequirements || [])
          .filter((item) => item.platformId)
          .map((item) => [
            String(item.platformId),
            item
          ])
      );

    const customAccess =
      (this.clientAccessRequirements || [])
        .filter((item) => !item.platformId);

    const defaultEmail =
      this.getDefaultAccessEmail(client);

    return `
      <form
        class="aa-client-access-editor"
        data-aa-access-form="${this.escapeHtml(client.id)}"
      >
        <div class="aa-client-access-editor__header">
          <div>
            <p class="aa-card__label">
              Account Access Setup
            </p>

            <h3>
              Required platforms & login details
            </h3>

            <p>
              New accounts default to
              <strong>${this.escapeHtml(defaultEmail || 'the client code login')}</strong>.
              Change it anywhere an older account already uses a different login.
            </p>
          </div>

          <button
            class="aa-button aa-button--secondary"
            type="button"
            data-aa-cancel-access
          >
            Close
          </button>
        </div>

        <div class="aa-client-access-editor__list" data-aa-access-row-list>
          ${(this.accessPlatformCatalog || []).map((platform, index) => {
            const existing =
              existingByPlatformId.get(
                String(platform.id)
              );

            return this.renderAccessEditorRow({
              item: existing || {
                platformId: platform.id,
                platformName: platform.name,
                isRequired: false,
                accessMethod:
                  platform.defaultAccessMethod || 'invite',
                loginEmail: defaultEmail,
                loginUsername: '',
                clientInstructions: '',
                status: 'not_requested',
                mfaStatus: 'unknown',
                mfaOwner: '',
                internalNotes: '',
                vaultReference: ''
              },
              index,
              custom: false
            });
          }).join('')}

          ${customAccess.map((item, customIndex) =>
            this.renderAccessEditorRow({
              item,
              index:
                (this.accessPlatformCatalog || []).length +
                customIndex,
              custom: true
            })
          ).join('')}
        </div>

        <button
          type="button"
          class="aa-button aa-button--secondary aa-client-access-editor__add"
          data-aa-add-custom-access
        >
          + Add Custom Platform
        </button>

        <div class="aa-client-access-editor__footer">
          <span>
            Passwords are not stored here. Use the vault reference
            to note where credentials are securely stored.
          </span>

          <div>
            <button
              type="button"
              class="aa-button aa-button--secondary"
              data-aa-cancel-access
            >
              Cancel
            </button>

            <button
              type="submit"
              class="aa-button aa-button--primary"
              data-aa-save-access
            >
              Save Access
            </button>
          </div>
        </div>
      </form>
    `;
  }

  renderAccessEditorRow({
    item,
    index,
    custom = false
  }) {
    const statusOptions = [
      ['not_requested', 'Not Requested'],
      ['requested', 'Requested'],
      ['waiting_on_client', 'Waiting on Client'],
      ['provided', 'Provided · Verify'],
      ['verified', 'Verified'],
      ['problem', 'Problem']
    ];

    const methodOptions = [
      ['invite', 'Invite Artisan’s Avenue'],
      ['create_login', 'Create Login'],
      ['shared_login', 'Shared Login'],
      ['oauth', 'Connected / OAuth'],
      ['other', 'Other']
    ];

    const mfaOptions = [
      ['unknown', 'Not Set'],
      ['aa_controls', 'Artisan’s Avenue'],
      ['client_controls', 'Client'],
      ['shared', 'Shared'],
      ['not_applicable', 'Not Applicable']
    ];

    return `
      <article
        class="aa-client-access-editor__row ${item.isRequired !== false ? 'is-required' : ''}"
        data-aa-access-row
      >
        <div class="aa-client-access-editor__row-head">
          <label class="aa-client-access-editor__required">
            <input
              type="checkbox"
              data-aa-access-required
              ${item.isRequired !== false ? 'checked' : ''}
            >
            <span></span>
            <strong>Required</strong>
          </label>

          ${custom ? `
            <label class="aa-client-access-editor__platform-name">
              <span>Platform</span>
              <input
                type="text"
                value="${this.escapeHtml(item.platformName || '')}"
                placeholder="Platform name"
                data-aa-access-platform-name
              >
            </label>
          ` : `
            <div class="aa-client-access-editor__platform-static">
              <span>Platform</span>
              <strong>
                ${this.escapeHtml(item.platformName)}
              </strong>
            </div>
          `}

          <label>
            <span>Status</span>
            <select data-aa-access-status>
              ${statusOptions.map(([value, label]) => `
                <option
                  value="${value}"
                  ${item.status === value ? 'selected' : ''}
                >
                  ${label}
                </option>
              `).join('')}
            </select>
          </label>
        </div>

        <div class="aa-client-access-editor__fields">
          <label>
            <span>Login Email</span>
            <input
              type="email"
              value="${this.escapeHtml(item.loginEmail || '')}"
              placeholder="tiffany${this.escapeHtml(String(this.getActiveClient()?.client_code || '').toLowerCase().replace(/[^a-z0-9]/g, ''))}@myartisansavenue.com"
              data-aa-access-login-email
            >
          </label>

          <label>
            <span>Username</span>
            <input
              type="text"
              value="${this.escapeHtml(item.loginUsername || '')}"
              placeholder="If the platform uses one"
              data-aa-access-login-username
            >
          </label>

          <label>
            <span>Access Method</span>
            <select data-aa-access-method>
              ${methodOptions.map(([value, label]) => `
                <option
                  value="${value}"
                  ${item.accessMethod === value ? 'selected' : ''}
                >
                  ${label}
                </option>
              `).join('')}
            </select>
          </label>

          <label>
            <span>MFA Controlled By</span>
            <select data-aa-access-mfa-status>
              ${mfaOptions.map(([value, label]) => `
                <option
                  value="${value}"
                  ${item.mfaStatus === value ? 'selected' : ''}
                >
                  ${label}
                </option>
              `).join('')}
            </select>
          </label>

          <label class="aa-client-access-editor__wide">
            <span>Client Instructions</span>
            <input
              type="text"
              value="${this.escapeHtml(item.clientInstructions || '')}"
              placeholder="What the client needs to do"
              data-aa-access-client-instructions
            >
          </label>

          <label>
            <span>Vault Reference</span>
            <input
              type="text"
              value="${this.escapeHtml(item.vaultReference || '')}"
              placeholder="e.g. 1Password · Fabric Warehouse"
              data-aa-access-vault-reference
            >
          </label>

          <label class="aa-client-access-editor__wide">
            <span>Internal Notes</span>
            <input
              type="text"
              value="${this.escapeHtml(item.internalNotes || '')}"
              placeholder="Internal only"
              data-aa-access-internal-notes
            >
          </label>
        </div>

        <input
          type="hidden"
          value="${this.escapeHtml(item.platformId || '')}"
          data-aa-access-platform-id
        >

        <input
          type="hidden"
          value="${this.escapeHtml(custom ? '' : item.platformName)}"
          data-aa-access-platform-static-name
        >

        <input
          type="hidden"
          value="${this.escapeHtml(item.requestedAt || '')}"
          data-aa-access-requested-at
        >

        <input
          type="hidden"
          value="${this.escapeHtml(item.providedAt || '')}"
          data-aa-access-provided-at
        >

        <input
          type="hidden"
          value="${this.escapeHtml(item.verifiedAt || '')}"
          data-aa-access-verified-at
        >

        <input
          type="hidden"
          value="${index}"
          data-aa-access-display-order
        >
      </article>
    `;
  }

  renderBrandAssetsPanel(client) {
    const assets =
      Array.isArray(this.clientBrandAssets)
        ? this.clientBrandAssets
        : [];

    return `
      <section class="aa-client-brand-panel" data-aa-account-section="brand">
        <div class="aa-client-brand-panel__header">
          <div>
            <p class="aa-card__label">
              Brand Assets
            </p>

            <h3>
              Client Brand Kit
            </h3>

            <p>
              Store the client's own logos, colors, fonts, store photography,
              and other brand materials here.
            </p>
          </div>

          <div class="aa-client-brand-panel__actions">
            <button
              class="aa-button aa-button--primary"
              type="button"
              data-aa-manage-brand-assets="${this.escapeHtml(client.id)}"
              data-aa-brand-focus="kit"
            >
              Manage Brand Kit
            </button>
          </div>
        </div>

        ${this.clientBrandLoading ? `
          <div class="aa-client-brand-empty">
            Loading brand assets...
          </div>
        ` : `
          <div>
            <div class="aa-client-brand-subhead">
              <span>Client Brand Kit</span>
              <strong>${assets.length}</strong>
            </div>

            ${assets.length ? `
              <div class="aa-client-brand-assets-grid">
                ${assets.map((asset) => `
                  <article class="aa-client-brand-asset-card">
                    <span class="aa-client-brand-asset-card__type">
                      ${this.escapeHtml(this.formatBrandAssetType(asset.type))}
                    </span>

                    <strong>
                      ${this.escapeHtml(asset.title)}
                    </strong>

                    ${asset.value ? `
                      <small>
                        ${this.escapeHtml(asset.value)}
                      </small>
                    ` : ''}

                    <div class="aa-client-brand-asset-card__actions">
                      ${asset.signedUrl ? `
                        <a
                          href="${this.escapeHtml(asset.signedUrl)}"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View File
                        </a>
                      ` : ''}

                      <button
                        type="button"
                        class="aa-client-brand-asset-card__remove"
                        data-aa-archive-brand-asset="${this.escapeHtml(asset.id)}"
                      >
                        Remove Asset
                      </button>
                    </div>
                  </article>
                `).join('')}
              </div>
            ` : `
              <div class="aa-client-brand-empty">
                No client-specific brand assets yet.
              </div>
            `}
          </div>
        `}
      </section>
    `;
  }

  renderVendorBrandsPanel(client) {
    const vendors =
      Array.isArray(this.clientVendorBrands)
        ? this.clientVendorBrands
        : [];

    const library =
      Array.isArray(this.vendorLibrary)
        ? this.vendorLibrary
        : [];

    const carriedNames =
      new Set(
        vendors.map((vendor) =>
          String(vendor.vendorName || '')
            .trim()
            .toLowerCase()
        )
      );

    const available =
      vendors.filter(
        (item) =>
          item.accessStatus === 'available'
      ).length;

    const attention =
      vendors.length - available;

    return `
      <section
        class="aa-client-brand-panel aa-client-vendor-quick-panel"
        data-aa-planning-section="vendors"
      >
        <div class="aa-client-brand-panel__header">
          <div>
            <h3>Brands &amp; Vendors</h3>


          </div>

          <div class="aa-client-vendor-quick-summary">
            <span>
              <strong>${vendors.length}</strong>
              carried
            </span>
            <span>
              <strong>${available}</strong>
              access ready
            </span>
            <span class="${attention ? 'needs-attention' : ''}">
              <strong>${attention}</strong>
              need review
            </span>
          </div>
        </div>

        ${this.clientBrandLoading ? `
          <div class="aa-client-brand-empty">
            Loading brands and vendors...
          </div>
        ` : `
          <div class="aa-client-vendor-quick-body">
            <div class="aa-client-vendor-quick-section">
              <div class="aa-client-brand-subhead">
                <span>Vendor Library</span>
                <small>Selected brands are carried by this client</small>
              </div>

              ${library.length ? `
                <div class="aa-client-vendor-toggle-grid">
                  ${library.map((vendor) => {
                    const normalizedName =
                      String(vendor.vendorName || '')
                        .trim()
                        .toLowerCase();

                    const selected =
                      carriedNames.has(normalizedName);

                    return `
                      <div
                        class="aa-client-vendor-toggle ${selected ? 'is-selected' : ''}"
                      >
                        <button
                          type="button"
                          class="aa-client-vendor-toggle__select"
                          data-aa-toggle-client-vendor
                          data-aa-vendor-client-id="${this.escapeHtml(client.id)}"
                          data-aa-vendor-id="${this.escapeHtml(vendor.id || '')}"
                          data-aa-vendor-name="${this.escapeHtml(vendor.vendorName || '')}"
                          aria-pressed="${selected ? 'true' : 'false'}"
                        >
                          <span class="aa-client-vendor-toggle__check">
                            ${selected ? '✓' : '+'}
                          </span>

                          <span class="aa-client-vendor-toggle__body">
                            <strong>
                              ${this.escapeHtml(vendor.vendorName)}
                            </strong>

                            ${selected ? '' : `
                              <small>
                                ${this.escapeHtml(
                                  this.formatVendorAccessStatus(
                                    vendor.accessStatus
                                  )
                                )}
                              </small>
                            `}
                          </span>
                        </button>

                        ${selected ? `
                          <label class="aa-client-vendor-toggle__status">
                            <span class="aa-visually-hidden">
                              Marketing access for
                              ${this.escapeHtml(vendor.vendorName)}
                            </span>

                            <select
                              data-aa-quick-vendor-status
                              data-aa-vendor-client-id="${this.escapeHtml(client.id)}"
                              data-aa-vendor-name="${this.escapeHtml(vendor.vendorName || '')}"
                            >
                              ${[
                                ['unknown', 'Needs Review'],
                                ['available', 'Available'],
                                ['needed', 'Access Needed'],
                                ['requested', 'Requested'],
                                ['problem', 'Problem']
                              ].map(([value, label]) => `
                                <option
                                  value="${value}"
                                  ${String(vendor.accessStatus || 'unknown') === value ? 'selected' : ''}
                                >
                                  ${label}
                                </option>
                              `).join('')}
                            </select>
                          </label>
                        ` : ''}
                      </div>
                    `;
                  }).join('')}
                </div>
              ` : `
                <div class="aa-client-brand-empty">
                  No vendors have been added to the global library yet.
                </div>
              `}
            </div>

            <details class="aa-client-vendor-quick-add">
              <summary>
                + Add a brand that is not in the library
              </summary>

              <form
                class="aa-client-vendor-quick-add__form"
                data-aa-quick-vendor-form="${this.escapeHtml(client.id)}"
              >
                <label>
                  <span>Brand / Vendor Name</span>
                  <input
                    type="text"
                    data-aa-quick-vendor-name
                    placeholder="Enter brand or vendor name"
                    required
                  >
                </label>

                <button
                  type="submit"
                  class="aa-button aa-button--primary"
                  data-aa-quick-vendor-save
                >
                  Add Brand
                </button>

                <small>
                  New brands are added to the shared Vendor Library as Needs Review.
                </small>
              </form>
            </details>
          </div>
        `}
      </section>
    `;
  }

  renderBrandAssetsEditor(client, focus = 'all') {
    const assets =
      Array.isArray(this.clientBrandAssets)
        ? this.clientBrandAssets
        : [];

    const vendors =
      Array.isArray(this.clientVendorBrands)
        ? this.clientVendorBrands
        : [];

    const library =
      Array.isArray(this.vendorLibrary)
        ? this.vendorLibrary
        : [];

    const carriedNames =
      new Set(
        vendors.map((vendor) =>
          String(vendor.vendorName || '')
            .trim()
            .toLowerCase()
        )
      );

    const availableToAdd =
      library.filter((vendor) =>
        !carriedNames.has(
          String(vendor.vendorName || '')
            .trim()
            .toLowerCase()
        )
      );

    const assetTypes = [
      ['logo', 'Logo'],
      ['brand_color', 'Brand Color'],
      ['font', 'Font'],
      ['store_photo', 'Store Photo'],
      ['team_photo', 'Owner / Team Photo']
    ];

    const vendorStatuses = [
      ['unknown', 'Needs Review'],
      ['available', 'Available'],
      ['needed', 'Access Needed'],
      ['requested', 'Requested'],
      ['problem', 'Problem']
    ];

    const showKit =
      focus === 'all' ||
      focus === 'kit';

    const showVendors =
      focus === 'all' ||
      focus === 'vendors';

    return `
      <section class="aa-client-brand-editor">
        ${showKit ? `
                  <div class="aa-client-brand-editor__header">
                    <div>
                      <p class="aa-card__label">
                        Brand Assets Setup
                      </p>
          
                      <h3>
                        Client Brand Kit
                      </h3>
          
                      <p>
                        Colors and fonts are optional. Upload only what this client actually uses.
                      </p>
                    </div>
          
                    <button
                      class="aa-button aa-button--secondary"
                      type="button"
                      data-aa-cancel-brand-assets
                    >
                      Close
                    </button>
                  </div>
          
                  <form
                    class="aa-client-brand-upload-form"
                    data-aa-brand-asset-form="${this.escapeHtml(client.id)}"
                  >
                    <label>
                      <span>Asset Type</span>
                      <select data-aa-brand-asset-type>
                        ${assetTypes.map(([value, label]) => `
                          <option value="${value}">
                            ${label}
                          </option>
                        `).join('')}
                      </select>
                    </label>
          
                    <label>
                      <span>Title</span>
                      <input
                        type="text"
                        placeholder="e.g. Primary Logo"
                        data-aa-brand-asset-title
                        required
                      >
                    </label>
          
                    <label>
                      <span>Color / Font Value</span>
                      <input
                        type="text"
                        placeholder="Optional, e.g. #6F8790 or DM Serif Display"
                        data-aa-brand-asset-value
                      >
                    </label>
          
                    <label>
                      <span>File</span>
                      <input
                        type="file"
                        accept="image/jpeg,image/png,image/webp,image/svg+xml,application/pdf"
                        data-aa-brand-asset-file
                      >
                    </label>
          
                    <label class="aa-client-brand-upload-form__wide">
                      <span>Notes</span>
                      <input
                        type="text"
                        placeholder="Optional"
                        data-aa-brand-asset-description
                      >
                    </label>
          
                    <button
                      class="aa-button aa-button--primary"
                      type="submit"
                      data-aa-save-brand-asset
                    >
                      Add Asset
                    </button>
                  </form>
          
                  ${assets.length ? `
                    <div class="aa-client-brand-editor__current">
                      ${assets.map((asset) => `
                        <div>
                          <span>
                            ${this.escapeHtml(this.formatBrandAssetType(asset.type))}
                          </span>
          
                          <strong>
                            ${this.escapeHtml(asset.title)}
                          </strong>
          
                          <button
                            type="button"
                            data-aa-archive-brand-asset="${this.escapeHtml(asset.id)}"
                          >
                            Archive
                          </button>
                        </div>
                      `).join('')}
                    </div>
                  ` : ''}
          
          
        ` : ''}

        ${showVendors ? `
                  <form
                    class="aa-client-vendor-editor"
                    data-aa-vendor-form="${this.escapeHtml(client.id)}"
                  >
          
                    <div class="aa-client-brand-editor__section-head">
                      <div>
                        <h3>Brands Carried</h3>
                        <p>
                          Add from the global vendor library, or create a new brand only when it does not already exist.
                        </p>
                      </div>
                    </div>
          
                    <div class="aa-client-vendor-library-picker">
                      <div class="aa-client-vendor-library-picker__main">
                        <label>
                          <span>Add From Vendor Library</span>
                          <select data-aa-vendor-library-select>
                            <option value="">Choose a brand</option>
                            ${availableToAdd.map((vendor) => `
                              <option
                                value="${this.escapeHtml(vendor.id)}"
                              >
                                ${this.escapeHtml(vendor.vendorName)}
                                ·
                                ${this.escapeHtml(
                                  this.formatVendorAccessStatus(
                                    vendor.accessStatus
                                  )
                                )}
                              </option>
                            `).join('')}
                          </select>
                        </label>
          
                        <button
                          type="button"
                          class="aa-button aa-button--secondary aa-button--small"
                          data-aa-add-library-vendor
                          ${availableToAdd.length ? '' : 'disabled'}
                        >
                          Add Selected Brand
                        </button>
          
                        <button
                          type="button"
                          class="aa-button aa-button--secondary aa-button--small"
                          data-aa-add-custom-vendor
                        >
                          Add New Brand
                        </button>
                      </div>
          
                      ${library.length ? `
                        <div class="aa-client-vendor-library-summary">
                          <span>Vendor Library</span>
          
                          <div class="aa-client-vendor-library-pills">
                            ${library.map((vendor) => `
                              <span
                                class="aa-client-vendor-library-pill"
                                data-status="${this.escapeHtml(vendor.accessStatus)}"
                              >
                                ${this.escapeHtml(vendor.vendorName)}
                                <small>
                                  ${this.escapeHtml(
                                    this.formatVendorAccessStatus(
                                      vendor.accessStatus
                                    )
                                  )}
                                </small>
                              </span>
                            `).join('')}
                          </div>
                        </div>
                      ` : ''}
                    </div>
          
                    <div data-aa-vendor-row-list>
                      ${vendors.map((vendor, index) =>
                        this.renderVendorEditorRow(
                          vendor,
                          index
                        )
                      ).join('')}
                    </div>
          
                    <div class="aa-client-vendor-editor__footer">
                      <button
                        class="aa-button aa-button--primary"
                        type="submit"
                        data-aa-save-vendors
                      >
                        Save Brands & Access
                      </button>
                    </div>
                  </form>
          
        ` : ''}

      </section>
    `;
  }


  renderVendorEditorRow(vendor = {}, index = 0) {
    const statuses = [
      ['unknown', 'Needs Review'],
      ['available', 'Available'],
      ['needed', 'Access Needed'],
      ['requested', 'Requested'],
      ['problem', 'Problem']
    ];

    const isNew =
      vendor.isNew === true;

    return `
      <div
        class="aa-client-vendor-editor__row"
        data-aa-vendor-row
        data-vendor-id="${this.escapeHtml(vendor.vendorId || '')}"
      >
        <label>
          <span>Brand / Vendor</span>

          ${isNew ? `
            <input
              type="text"
              value="${this.escapeHtml(vendor.vendorName || '')}"
              placeholder="Type a new brand name"
              data-aa-vendor-name
              required
            >
          ` : `
            <input
              type="text"
              value="${this.escapeHtml(vendor.vendorName || '')}"
              data-aa-vendor-name
              readonly
              required
            >
          `}
        </label>

        <label>
          <span>Marketing Access</span>
          <select data-aa-vendor-status>
            ${statuses.map(([value, label]) => `
              <option
                value="${value}"
                ${vendor.accessStatus === value ? 'selected' : ''}
              >
                ${label}
              </option>
            `).join('')}
          </select>
        </label>

        <input
          type="hidden"
          value="${index}"
          data-aa-vendor-display-order
        >

        <button
          type="button"
          class="aa-client-vendor-editor__remove"
          data-aa-remove-vendor-row
        >
          Remove
        </button>
      </div>
    `;
  }

  renderContractPanel(client) {
    const contracts =
      Array.isArray(this.clientContracts)
        ? this.clientContracts
        : [];

    const priority = {
      renewal_due: 1,
      pending_signature: 2,
      sent: 3,
      viewed: 4,
      signed: 5,
      active: 6,
      draft: 7,
      expired: 90,
      archived: 99
    };

    const sorted =
      [...contracts].sort((a, b) => {
        const statusDifference =
          (priority[a.status] || 50) -
          (priority[b.status] || 50);

        if (statusDifference !== 0) {
          return statusDifference;
        }

        return String(
          b.effectiveDate ||
          b.createdAt ||
          ''
        ).localeCompare(
          String(
            a.effectiveDate ||
            a.createdAt ||
            ''
          )
        );
      });

    const current =
      sorted.find(
        (contract) =>
          ['active', 'renewal_due']
            .includes(
              this.resolveContractDisplayStatus(
                contract
              )
            )
      ) || null;

    const pending =
      sorted.find(
        (contract) =>
          [
            'sent',
            'pending_signature',
            'viewed',
            'signed',
            'draft'
          ].includes(
            this.resolveContractDisplayStatus(
              contract
            )
          ) &&
          contract.id !== current?.id
      ) || null;

    const history =
      sorted.filter(
        (contract) =>
          contract.id !== current?.id &&
          contract.id !== pending?.id
      );

    const pendingDocument =
      (pending?.documents || []).find(
        (document) =>
          document.type === 'signed_agreement'
      ) ||
      (pending?.documents || []).find(
        (document) =>
          document.type === 'agreement'
      ) ||
      (pending?.documents || [])[0] ||
      null;

    const renderDocument = (document) => {
      if (!document?.signedUrl) return '';

      return `
        <a
          class="aa-client-contract-document-link"
          href="${this.escapeHtml(document.signedUrl)}"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>
            ${this.escapeHtml(
              document.title ||
              this.formatContractDocumentType(
                document.type
              )
            )}
          </span>
          <small>
            ${this.escapeHtml(
              this.formatContractDocumentType(
                document.type
              )
            )}
          </small>
          <strong>View PDF</strong>
        </a>
      `;
    };

    return `
      <section class="aa-client-contract-panel" data-aa-account-section="agreements">
        <div class="aa-client-contract-panel__header">
          <div>
            <p class="aa-card__label">
              Billing & Agreements
            </p>

            <h3>
              Contract Center
            </h3>

            <p>
              Current agreement, contract documents, renewal details, and history.
            </p>
          </div>

          <button
            class="aa-button aa-button--primary"
            type="button"
            data-aa-manage-contracts="${this.escapeHtml(client.id)}"
          >
            Manage Contracts
          </button>
        </div>

        ${this.clientContractsLoading ? `
          <div class="aa-client-contract-empty">
            Loading contracts...
          </div>
        ` : `
          ${pending ? `
            <div class="aa-client-contract-pending">
              <div class="aa-client-contract-section-heading">
                <span>
                  ${['sent','pending_signature','viewed'].includes(pending.status)
                    ? 'Agreement Awaiting Signature'
                    : pending.status === 'signed'
                      ? 'Upcoming Signed Agreement'
                      : 'Pending Agreement'
                  }
                </span>

                <span
                  class="aa-client-contract-status"
                  data-status="${this.escapeHtml(
                    pending.status || 'draft'
                  )}"
                >
                  ${this.escapeHtml(
                    this.formatContractStatus(
                      this.resolveContractDisplayStatus(
                        pending
                      )
                    )
                  )}
                </span>
              </div>

              <div class="aa-client-contract-pending__body">
                <div>
                  <h4>
                    ${this.escapeHtml(
                      pending.title || 'Service Agreement'
                    )}
                  </h4>

                  <p>
                    ${this.escapeHtml(
                      pending.type || 'Service Agreement'
                    )}
                    ${pending.version ? `
                      ·
                      ${this.escapeHtml(pending.version)}
                    ` : ''}
                  </p>
                </div>

                <div class="aa-client-contract-current__metrics">
                  <div>
                    <span>Effective</span>
                    <strong>
                      ${this.escapeHtml(
                        this.formatContractDate(
                          pending.effectiveDate
                        )
                      )}
                    </strong>
                  </div>

                  <div>
                    <span>Expiration</span>
                    <strong>
                      ${this.escapeHtml(
                        this.formatContractDate(
                          pending.expirationDate
                        )
                      )}
                    </strong>
                  </div>
                </div>
              </div>

              ${pendingDocument?.signedUrl ? `
                <div class="aa-client-contract-current__documents">
                  ${renderDocument(pendingDocument)}
                </div>
              ` : ''}
            </div>
          ` : ''}

          <div class="aa-client-contract-layout">
            <div class="aa-client-contract-current">
              <div class="aa-client-contract-section-heading">
                <span>Current Agreement</span>
                ${current ? `
                  <span
                    class="aa-client-contract-status"
                    data-status="${this.escapeHtml(
                      current.status || 'draft'
                    )}"
                  >
                    ${this.escapeHtml(
                      this.formatContractStatus(
                        this.resolveContractDisplayStatus(
                          current
                        )
                      )
                    )}
                  </span>
                ` : ''}
              </div>

              ${current ? `
                <div class="aa-client-contract-current__main">
                  <div>
                    <h4>
                      ${this.escapeHtml(
                        current.title || 'Service Agreement'
                      )}
                    </h4>

                    <p>
                      ${this.escapeHtml(
                        current.type || 'Service Agreement'
                      )}
                      ${current.version ? `
                        ·
                        ${this.escapeHtml(current.version)}
                      ` : ''}
                    </p>
                  </div>

                  <div class="aa-client-contract-current__metrics">
                    <div>
                      <span>Effective</span>
                      <strong>
                        ${this.escapeHtml(
                          this.formatContractDate(
                            current.effectiveDate
                          )
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        ${current.renewalDate
                          ? 'Renewal'
                          : 'Expiration'
                        }
                      </span>
                      <strong>
                        ${this.escapeHtml(
                          this.formatContractDate(
                            current.renewalDate ||
                            current.expirationDate
                          )
                        )}
                      </strong>
                    </div>
                  </div>
                </div>

                <div class="aa-client-contract-document-summary">
                  <div class="aa-client-contract-section-heading aa-client-contract-section-heading--documents">
                    <span>Agreement Documents</span>
                    <small>
                      ${Number(current.documents?.length || 0)}
                    </small>
                  </div>

                  ${current.documents?.length ? `
                    <div class="aa-client-contract-document-links">
                      ${current.documents
                        .map(renderDocument)
                        .join('')}
                    </div>
                  ` : `
                    <div class="aa-client-contract-documents__empty">
                      No PDFs attached to this agreement yet.
                    </div>
                  `}
                </div>
              ` : `
                <div class="aa-client-contract-empty aa-client-contract-empty--current">
                  <strong>No current agreement.</strong>
                  <span>
                    ${history.length
                      ? 'Previous agreements remain available in Contract History.'
                      : 'Add an agreement when this client is ready.'
                    }
                  </span>
                </div>
              `}
            </div>

            <div class="aa-client-contract-history-panel">
              <div class="aa-client-contract-section-heading">
                <span>Contract History</span>
                <small>${history.length}</small>
              </div>

              ${history.length ? `
                <div class="aa-client-contract-history-list">
                  ${history.map((contract) => {
                    const primaryDocument =
                      (contract.documents || []).find(
                        (document) =>
                          document.type === 'signed_agreement'
                      ) ||
                      (contract.documents || []).find(
                        (document) =>
                          document.type === 'agreement'
                      ) ||
                      (contract.documents || [])[0];

                    return `
                      <div class="aa-client-contract-history-row">
                        <div>
                          <strong>
                            ${this.escapeHtml(
                              contract.title || 'Agreement'
                            )}
                          </strong>

                          <small>
                            ${this.escapeHtml(
                              this.formatContractStatus(
                                contract.status
                              )
                            )}
                            ·
                            ${this.escapeHtml(
                              this.formatContractDate(
                                contract.effectiveDate
                              )
                            )}
                          </small>
                        </div>

                        <div class="aa-client-contract-history-row__actions">
                          ${primaryDocument?.signedUrl ? `
                            <a
                              href="${this.escapeHtml(
                                primaryDocument.signedUrl
                              )}"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View PDF
                            </a>
                          ` : ''}

                          <button
                            type="button"
                            data-aa-edit-contract-record="${this.escapeHtml(contract.id)}"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    `;
                  }).join('')}
                </div>
              ` : `
                <div class="aa-client-contract-history-empty">
                  No previous agreements.
                </div>
              `}
            </div>
          </div>
        `}
      </section>
    `;
  }

  renderBillingSetupPanel(client) {
    const businesses =
      Array.isArray(this.waveBusinesses)
        ? this.waveBusinesses
        : [];

    const customers =
      Array.isArray(this.waveCustomers)
        ? this.waveCustomers
        : [];

    const connection =
      this.waveConnection || null;

    const mapping =
      this.waveClientMapping || null;

    return `
      <section class="aa-client-billing-setup">
        <div class="aa-client-billing-setup__header">
          <div>
            <p class="aa-card__label">
              Billing Setup
            </p>

            <h3>
              Wave Connection
            </h3>

            <p>
              Wave remains the billing system of record. This connection is read-only.
            </p>
          </div>

          <button
            class="aa-button aa-button--secondary"
            type="button"
            data-aa-test-wave-connection
            ${this.waveConnectionLoading ? 'disabled' : ''}
          >
            ${this.waveConnectionLoading
              ? 'Testing...'
              : connection?.businessId
                ? 'Refresh Wave Connection'
                : 'Test Wave Connection'
            }
          </button>
        </div>

        ${connection?.businessId ? `
          <div class="aa-client-wave-connected">
            <div>
              <span>Connected Wave Business</span>
              <strong>
                ${this.escapeHtml(
                  connection.businessName ||
                  'Wave Business'
                )}
              </strong>
            </div>

            <span class="aa-client-wave-connected__status">
              Connected
            </span>
          </div>
        ` : ''}

        ${this.waveConnectionError ? `
          <div class="aa-client-billing-setup__message" data-state="error">
            ${this.escapeHtml(this.waveConnectionError)}
          </div>
        ` : ''}

        ${businesses.length && !connection?.businessId ? `
          <div class="aa-client-billing-businesses">
            <div class="aa-client-billing-businesses__heading">
              <span>Wave businesses found</span>
              <strong>${businesses.length}</strong>
            </div>

            ${businesses.map((business) => `
              <div class="aa-client-billing-business-row">
                <div>
                  <strong>
                    ${this.escapeHtml(business.name)}
                  </strong>
                  <small>
                    ${business.isPersonal
                      ? 'Personal'
                      : 'Business'
                    }
                  </small>
                </div>

                ${business.isPersonal ? `
                  <span class="aa-client-billing-business-row__muted">
                    Not used for client billing
                  </span>
                ` : `
                  <button
                    class="aa-button aa-button--secondary aa-button--small"
                    type="button"
                    data-aa-select-wave-business="${this.escapeHtml(business.id)}"
                  >
                    Use This Business
                  </button>
                `}
              </div>
            `).join('')}
          </div>
        ` : ''}

        <div class="aa-client-wave-customer">
          <div class="aa-client-wave-customer__heading">
            <div>
              <span>Client Billing Connection</span>
              <strong>
                ${this.escapeHtml(client.business_name)}
              </strong>
            </div>

            ${connection?.businessId ? `
              <button
                class="aa-button aa-button--secondary aa-button--small"
                type="button"
                data-aa-open-wave-customer-picker
              >
                ${mapping
                  ? 'Change Wave Customer'
                  : 'Connect Wave Customer'
                }
              </button>
            ` : ''}
          </div>

          ${mapping ? `
            <div class="aa-client-wave-customer__connected">
              <div>
                <span>Wave Customer</span>
                <strong>
                  ${this.escapeHtml(
                    mapping.waveCustomerName ||
                    'Connected customer'
                  )}
                </strong>
                ${mapping.waveCustomerEmail ? `
                  <small>
                    ${this.escapeHtml(
                      mapping.waveCustomerEmail
                    )}
                  </small>
                ` : ''}
              </div>

              <span>Connected</span>
            </div>
          ` : `
            <div class="aa-client-billing-setup__quiet">
              Wave Customer Not Connected
            </div>
          `}

          ${this.waveCustomerError ? `
            <div class="aa-client-billing-setup__message" data-state="error">
              ${this.escapeHtml(this.waveCustomerError)}
            </div>
          ` : ''}

          ${mapping ? `
            <div class="aa-client-wave-invoice-test">
              <div class="aa-client-wave-invoice-test__heading">
                <div>
                  <span>Invoice Retrieval Test</span>
                  <strong>
                    ${this.waveInvoiceTested
                      ? `${this.waveInvoices.length} invoice${this.waveInvoices.length === 1 ? '' : 's'} returned`
                      : 'Not tested yet'
                    }
                  </strong>
                </div>

                <button
                  class="aa-button aa-button--secondary aa-button--small"
                  type="button"
                  data-aa-test-wave-invoices
                  ${this.waveInvoiceLoading ? 'disabled' : ''}
                >
                  ${this.waveInvoiceLoading
                    ? 'Retrieving...'
                    : 'Test Invoice Retrieval'
                  }
                </button>
              </div>

              ${this.waveInvoiceError ? `
                <div class="aa-client-billing-setup__message" data-state="error">
                  ${this.escapeHtml(this.waveInvoiceError)}
                </div>
              ` : ''}

              ${this.waveInvoiceTested && this.waveInvoices.length ? `
                <div class="aa-client-wave-invoice-preview">
                  ${this.waveInvoices.slice(0, 5).map((invoice) => `
                    <div class="aa-client-wave-invoice-preview__row">
                      <div>
                        <strong>
                          #${this.escapeHtml(invoice.invoiceNumber || '')}
                        </strong>
                        <small>
                          ${this.escapeHtml(invoice.status || '')}
                        </small>
                      </div>

                      <span>
                        ${this.escapeHtml(
                          `${invoice.total?.symbol || ''}${invoice.total?.value || '0'}`
                        )}
                      </span>
                    </div>
                  `).join('')}
                </div>
              ` : this.waveInvoiceTested && !this.waveInvoices.length ? `
                <div class="aa-client-billing-setup__quiet">
                  Wave returned no invoices for this mapped customer.
                </div>
              ` : ''}
            </div>
          ` : ''}

          ${this.waveCustomerPickerOpen ? `
            <div class="aa-client-wave-customer-picker">
              <div class="aa-client-wave-customer-picker__toolbar">
                <input
                  type="search"
                  placeholder="Search Wave customers..."
                  data-aa-wave-customer-search
                >

                <button
                  type="button"
                  class="aa-button aa-button--secondary aa-button--small"
                  data-aa-close-wave-customer-picker
                >
                  Close
                </button>
              </div>

              ${this.waveCustomerLoading ? `
                <div class="aa-client-billing-setup__quiet">
                  Loading Wave customers...
                </div>
              ` : customers.length ? `
                <div class="aa-client-wave-customer-results">
                  ${customers.map((customer) => `
                    <div
                      class="aa-client-wave-customer-row"
                      data-aa-wave-customer-row
                      data-search="${this.escapeHtml(
                        `${customer.name || ''} ${customer.email || ''}`
                          .toLowerCase()
                      )}"
                    >
                      <div>
                        <strong>
                          ${this.escapeHtml(customer.name)}
                        </strong>
                        <small>
                          ${this.escapeHtml(
                            customer.email || 'No email on file'
                          )}
                        </small>
                      </div>

                      <button
                        type="button"
                        class="aa-button aa-button--secondary aa-button--small"
                        data-aa-select-wave-customer="${this.escapeHtml(customer.id)}"
                      >
                        ${String(mapping?.waveCustomerId || '') ===
                           String(customer.id || '')
                          ? 'Connected'
                          : 'Use This Customer'
                        }
                      </button>
                    </div>
                  `).join('')}
                </div>
              ` : `
                <div class="aa-client-billing-setup__quiet">
                  No Wave customers found.
                </div>
              `}
            </div>
          ` : ''}
        </div>
      </section>
    `;
  }

  renderContractEditor(client) {
    const contracts =
      Array.isArray(this.clientContracts)
        ? this.clientContracts
        : [];

    const statusOptions = [
      ['draft', 'Draft'],
      ['sent', 'Sent for Signature'],
      ['signed', 'Signed'],
      ['active', 'Active'],
      ['renewal_due', 'Renewal Due'],
      ['expired', 'Expired']
    ];

    const documentTypes = [
      ['agreement', 'Agreement'],
      ['signed_agreement', 'Signed Agreement'],
      ['amendment', 'Amendment'],
      ['audit_certificate', 'Signature Certificate'],
      ['other', 'Other']
    ];

    return `
      <section class="aa-client-contract-editor">
        <div class="aa-client-contract-editor__header">
          <div>
            <p class="aa-card__label">
              Contract Setup
            </p>

            <h3>
              Manage Contracts
            </h3>

            <p>
              Keep the agreement record here. Digital signing will connect to this same contract history later.
            </p>
          </div>

          <button
            class="aa-button aa-button--secondary"
            type="button"
            data-aa-cancel-contracts
          >
            Close
          </button>
        </div>

        <details class="aa-client-contract-create" ${contracts.length ? '' : 'open'}>
          <summary>Add New Agreement</summary>

          <form
            class="aa-client-contract-form"
            data-aa-contract-create-form="${this.escapeHtml(client.id)}"
          >
            <label class="aa-client-contract-form__wide">
              <span>Contract Title</span>
              <input
                type="text"
                data-aa-contract-title
                value="Monthly Marketing Services Agreement"
                required
              >
            </label>

            <label>
              <span>Type</span>
              <input
                type="text"
                data-aa-contract-type
                value="Service Agreement"
              >
            </label>

            <label>
              <span>Version</span>
              <input
                type="text"
                data-aa-contract-version
                placeholder="v1.0"
              >
            </label>

            <label>
              <span>Status</span>
              <select data-aa-contract-status>
                ${statusOptions.map(([value, label]) => `
                  <option
                    value="${value}"
                    ${value === 'draft' ? 'selected' : ''}
                  >
                    ${label}
                  </option>
                `).join('')}
              </select>
            </label>

            <label>
              <span>Effective Date</span>
              <input
                type="date"
                data-aa-contract-effective-date
              >
            </label>

            <label>
              <span>Renewal Date</span>
              <input
                type="date"
                data-aa-contract-renewal-date
              >
            </label>

            <label>
              <span>Expiration Date</span>
              <input
                type="date"
                data-aa-contract-expiration-date
              >
            </label>

            <label class="aa-client-contract-form__wide">
              <span>Initial Contract PDF</span>
              <input
                type="file"
                accept="application/pdf,.pdf"
                data-aa-contract-file
              >
            </label>

            <label class="aa-client-contract-form__wide">
              <span>Internal Notes</span>
              <textarea
                rows="3"
                data-aa-contract-internal-notes
                placeholder="Internal only"
              ></textarea>
            </label>

            <label class="aa-client-contract-check">
              <input
                type="checkbox"
                data-aa-contract-client-visible
                checked
              >
              <span>
                Show this agreement in the client Workspace
              </span>
            </label>

            <div class="aa-client-contract-form__actions">
              <button
                class="aa-button aa-button--primary"
                type="submit"
                data-aa-save-contract
              >
                Add Contract
              </button>
            </div>
          </form>
        </details>

        <div class="aa-client-contract-editor__list">
          ${contracts.length ? contracts.map((contract) => `
            <article
              class="aa-client-contract-record"
              data-aa-contract-record="${this.escapeHtml(contract.id)}"
            >
              <div class="aa-client-contract-record__header">
                <div>
                  <span
                    class="aa-client-contract-status"
                    data-status="${this.escapeHtml(
                      contract.status || 'draft'
                    )}"
                  >
                    ${this.escapeHtml(
                      this.formatContractStatus(
                        contract.status
                      )
                    )}
                  </span>

                  <h4>
                    ${this.escapeHtml(
                      contract.title || 'Agreement'
                    )}
                  </h4>
                </div>

                <div class="aa-client-contract-record__actions">
                  <button
                    type="button"
                    class="aa-client-contract-record__archive"
                    data-aa-archive-contract="${this.escapeHtml(contract.id)}"
                  >
                    Archive
                  </button>

                  ${!['signed','active','renewal_due','expired'].includes(contract.status) ? `
                    <button
                      type="button"
                      class="aa-client-contract-record__delete"
                      data-aa-delete-contract="${this.escapeHtml(contract.id)}"
                    >
                      Delete Permanently
                    </button>
                  ` : ''}
                </div>
              </div>

              <form
                class="aa-client-contract-form aa-client-contract-form--existing"
                data-aa-contract-update-form="${this.escapeHtml(contract.id)}"
                data-aa-contract-client-id="${this.escapeHtml(client.id)}"
              >
                <label class="aa-client-contract-form__wide">
                  <span>Contract Title</span>
                  <input
                    type="text"
                    data-aa-contract-title
                    value="${this.escapeHtml(contract.title || '')}"
                    required
                  >
                </label>

                <label>
                  <span>Type</span>
                  <input
                    type="text"
                    data-aa-contract-type
                    value="${this.escapeHtml(contract.type || '')}"
                  >
                </label>

                <label>
                  <span>Version</span>
                  <input
                    type="text"
                    data-aa-contract-version
                    value="${this.escapeHtml(contract.version || '')}"
                  >
                </label>

                <label>
                  <span>Status</span>
                  <select data-aa-contract-status>
                    ${statusOptions.map(([value, label]) => `
                      <option
                        value="${value}"
                        ${contract.status === value ? 'selected' : ''}
                      >
                        ${label}
                      </option>
                    `).join('')}
                  </select>
                </label>

                <label>
                  <span>Effective Date</span>
                  <input
                    type="date"
                    data-aa-contract-effective-date
                    value="${this.escapeHtml(
                      String(
                        contract.effectiveDate || ''
                      ).slice(0, 10)
                    )}"
                  >
                </label>

                <label>
                  <span>Renewal Date</span>
                  <input
                    type="date"
                    data-aa-contract-renewal-date
                    value="${this.escapeHtml(
                      String(
                        contract.renewalDate || ''
                      ).slice(0, 10)
                    )}"
                  >
                </label>

                <label>
                  <span>Expiration Date</span>
                  <input
                    type="date"
                    data-aa-contract-expiration-date
                    value="${this.escapeHtml(
                      String(
                        contract.expirationDate || ''
                      ).slice(0, 10)
                    )}"
                  >
                </label>

                <label class="aa-client-contract-form__wide">
                  <span>Internal Notes</span>
                  <textarea
                    rows="3"
                    data-aa-contract-internal-notes
                    placeholder="Internal only"
                  >${this.escapeHtml(
                    contract.internalNotes || ''
                  )}</textarea>
                </label>

                <label class="aa-client-contract-check">
                  <input
                    type="checkbox"
                    data-aa-contract-client-visible
                    ${contract.clientVisible ? 'checked' : ''}
                  >
                  <span>
                    Show this agreement in the client Workspace
                  </span>
                </label>

                <div class="aa-client-contract-form__actions">
                  <button
                    class="aa-button aa-button--primary"
                    type="submit"
                    data-aa-update-contract
                  >
                    Save Contract
                  </button>
                </div>
              </form>

              <div class="aa-client-contract-documents">
                <div class="aa-client-contract-documents__header">
                  <strong>Documents</strong>
                  <span>
                    ${Number(
                      contract.documents?.length || 0
                    )}
                  </span>
                </div>

                ${contract.documents?.length ? `
                  <div class="aa-client-contract-documents__list">
                    ${contract.documents.map((document) => `
                      <div class="aa-client-contract-document-row">
                        <div>
                          <strong>
                            ${this.escapeHtml(
                              document.title ||
                              this.formatContractDocumentType(
                                document.type
                              )
                            )}
                          </strong>

                          <small>
                            ${this.escapeHtml(
                              this.formatContractDocumentType(
                                document.type
                              )
                            )}
                            ·
                            ${document.clientVisible
                              ? 'Client visible'
                              : 'Internal only'
                            }
                          </small>
                        </div>

                        <div>
                          ${document.signedUrl ? `
                            <a
                              href="${this.escapeHtml(
                                document.signedUrl
                              )}"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View
                            </a>
                          ` : ''}

                          <button
                            type="button"
                            data-aa-archive-contract-document="${this.escapeHtml(document.id)}"
                          >
                            Archive
                          </button>

                          ${!['signed_agreement','audit_certificate'].includes(document.type) ? `
                            <button
                              type="button"
                              data-aa-delete-contract-document="${this.escapeHtml(document.id)}"
                            >
                              Delete
                            </button>
                          ` : ''}
                        </div>
                      </div>
                    `).join('')}
                  </div>
                ` : `
                  <div class="aa-client-contract-documents__empty">
                    No PDFs attached yet.
                  </div>
                `}

                <form
                  class="aa-client-contract-document-form"
                  data-aa-contract-document-form="${this.escapeHtml(contract.id)}"
                  data-aa-contract-document-client-id="${this.escapeHtml(client.id)}"
                >
                  <label>
                    <span>Document Type</span>
                    <select data-aa-contract-document-type>
                      ${documentTypes.map(([value, label]) => `
                        <option value="${value}">
                          ${label}
                        </option>
                      `).join('')}
                    </select>
                  </label>

                  <label>
                    <span>Title</span>
                    <input
                      type="text"
                      data-aa-contract-document-title
                      placeholder="Optional"
                    >
                  </label>

                  <label>
                    <span>PDF</span>
                    <input
                      type="file"
                      accept="application/pdf,.pdf"
                      data-aa-contract-document-file
                      required
                    >
                  </label>

                  <label class="aa-client-contract-check">
                    <input
                      type="checkbox"
                      data-aa-contract-document-client-visible
                      checked
                    >
                    <span>Client visible</span>
                  </label>

                  <button
                    class="aa-button aa-button--secondary"
                    type="submit"
                    data-aa-upload-contract-document
                  >
                    Add Document
                  </button>
                </form>
              </div>
            </article>
          `).join('') : `
            <div class="aa-client-contract-empty">
              No existing agreements yet.
            </div>
          `}
        </div>
      </section>
    `;
  }

  renderInternalNotesPanel(client) {
    const notes = String(client.notes || '').trim();
    return `
      <section class="aa-client-team-notes ${notes ? 'has-notes' : ''}">
        <div class="aa-client-team-notes__header">
          <div>
            <strong>Team Notes ${notes ? '<span class="aa-client-team-notes__indicator">Notes on file</span>' : ''}</strong>
            <small>Visible to Artisan's Avenue team. Not shared with Leo or clients.</small>
          </div>
          <button type="button" class="aa-button aa-button--secondary" data-aa-edit-client="${this.escapeHtml(client.id)}">Edit Notes</button>
        </div>
        <p>${notes ? this.escapeHtml(notes) : 'No team notes for this client.'}</p>
      </section>
    `;
  }

 renderEditClient(client) {
  return `
    <form class="aa-client-edit-panel" data-aa-client-edit-panel="${client.id}">
      <p class="aa-card__label">Edit Client Info</p>
      <div class="aa-client-edit__group-heading">Business Information <small>Basic contact information used throughout the account.</small></div>

      <label>
        Business Name
        <input type="text" data-aa-edit-client-field="business_name" value="${this.escapeHtml(client.business_name)}">
      </label>

      <label>
        Primary Contact
        <input type="text" data-aa-edit-client-field="primary_contact" value="${this.escapeHtml(client.primary_contact)}">
      </label>

      <label>
        Email
        <input type="email" data-aa-edit-client-field="email" value="${this.escapeHtml(client.email)}">
      </label>

      <label>
        Phone
        <input type="tel" data-aa-edit-client-field="phone" value="${this.escapeHtml(client.phone)}">
      </label>

      <label class="aa-client-edit__address">
        Business Address
        <textarea rows="3" data-aa-edit-client-field="mailing_address" placeholder="Street address, suite or unit, city, state, ZIP">${this.escapeHtml(client.mailing_address || '')}</textarea>
      </label>

      <div class="aa-client-edit__group-heading">Internal Administration <small>Client codes are used for task and reporting references. Change an established code with care.</small></div>

      ${this.clientCodeEnabled ? `
        <label class="aa-client-edit__code">
          Client Code
          <input
            type="text"
            data-aa-edit-client-field="client_code"
            value="${this.escapeHtml(client.client_code || '')}"
            placeholder="CSC"
            maxlength="12"
            required
          >
        </label>
      ` : ''}

      ${this.clientAssignmentEnabled ? `
        <label class="aa-client-edit__manager">
          Primary Account Manager
          <select data-aa-edit-client-primary-team>
            <option value="">Unassigned</option>
            ${this.internalTeamMembers.map((member) => `
              <option
                value="${this.escapeHtml(member.id)}"
                ${String(client.primary_team_member_id || '') === String(member.id) ? 'selected' : ''}
              >
                ${this.escapeHtml(
                  member.display_name ||
                  member.aa_roles?.display_name ||
                  'Team Member'
                )}
              </option>
            `).join('')}
          </select>
        </label>
      ` : ''}


      <label>
        Engagement Type
        <select data-aa-edit-client-field="client_type">

        
          ${this.getClientTypeOptions().map((option) => `
            <option value="${option}" ${client.client_type === option ? 'selected' : ''}>${option}</option>
          `).join('')}
        </select>
      </label>


      <label>
        Status
        <select data-aa-edit-client-field="active_status">
          ${this.getStatusOptions().map((option) => `
            <option value="${option}" ${client.active_status === option ? 'selected' : ''}>${option}</option>
          `).join('')}
        </select>
      </label>

      <label>
  Email Request Access
  <select data-aa-edit-client-email-access>
    <option value="off" ${this.hasEmailAccess(client.access) ? '' : 'selected'}>Disabled</option>
    <option value="on" ${this.hasEmailAccess(client.access) ? 'selected' : ''}>Enabled</option>
  </select>
</label>

<label>
  Internal Notes (team only, not for Leo)
  <textarea data-aa-edit-client-field="notes">${this.escapeHtml(client.notes || '')}</textarea>
</label>

      <div class="aa-client-card__actions">
        <button class="aa-button aa-button--primary" type="submit" data-aa-save-client-edit="${client.id}">
          Save Client
        </button>

        <button class="aa-button" type="button" data-aa-cancel-client-edit>
          Cancel
        </button>
      </div>
    </form>
  `;
}

  bindNewClientForm() {
  this.root.addEventListener('change', (event) => {
  const effectiveMode = event.target.closest(
    '[data-aa-package-effective-mode]'
  );

  if (effectiveMode) {
    const form = effectiveMode.closest('[data-aa-package-form]');
    const scheduled = form?.querySelector(
      '[data-aa-package-effective-mode][value="scheduled"]'
    )?.checked === true;
    const dateLabel = form?.querySelector('[data-aa-package-schedule]');
    const dateInput = form?.querySelector('[data-aa-package-effective-date]');
    if (dateLabel) dateLabel.hidden = !scheduled;
    if (dateInput) dateInput.required = scheduled;
    return;
  }

  const packageInclude =
    event.target.closest(
      '[data-aa-package-include]'
    );

  if (packageInclude) {
    const row =
      packageInclude.closest(
        '[data-aa-package-service-row]'
      );

    row?.classList.toggle(
      'is-included',
      packageInclude.checked
    );

    return;
  }

  const accessRequired =
    event.target.closest(
      '[data-aa-access-required]'
    );

  if (accessRequired) {
    const row =
      accessRequired.closest(
        '[data-aa-access-row]'
      );

    row?.classList.toggle(
      'is-required',
      accessRequired.checked
    );
  }
});

this.root.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-aa-new-client-toggle]');
    if (!toggle) return;

    const form = this.root.querySelector('[data-aa-new-client-form]');
    const input = this.root.querySelector('[data-aa-new-client-name]');

    if (!form || !input) return;

let clientCodeField =
  form.querySelector('[data-aa-new-client-code]');

if (
  this.clientCodeEnabled &&
  !clientCodeField
) {
  const codeLabel =
    document.createElement('label');

  codeLabel.innerHTML = `
    Client Code
    <input
      type="text"
      data-aa-new-client-code
      maxlength="12"
      placeholder="CSC"
      required
    >
  `;

  form.insertBefore(
    codeLabel,
    input.parentElement?.nextSibling || null
  );

  clientCodeField =
    codeLabel.querySelector(
      '[data-aa-new-client-code]'
    );
}

let emailAccessField =
  form.querySelector('[data-aa-new-client-email-access]');

if (!emailAccessField) {
  const label = document.createElement('label');

  label.innerHTML = `
    Email Request Access
    <select data-aa-new-client-email-access>
      <option value="off" selected>Disabled</option>
      <option value="on">Enabled</option>
    </select>
  `;

  form.insertBefore(
    label,
    form.querySelector('button[type="submit"]') || null
  );

  emailAccessField =
    label.querySelector('[data-aa-new-client-email-access]');
}

form.hidden = !form.hidden;

if (!form.hidden) {
  input.focus();
}
  });

  this.root.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-aa-new-client-form]');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('[data-aa-new-client-name]');
const businessName = input?.value.trim();
const clientCode =
  form
    .querySelector('[data-aa-new-client-code]')
    ?.value
    .trim()
    .toUpperCase() || '';
const submitButton = form.querySelector('[type="submit"]');
const emailAccessField =
  form.querySelector('[data-aa-new-client-email-access]');

const initialAccess =
  emailAccessField?.value === 'on'
    ? ['email']
    : [];

    if (!businessName) return;

    if (
      this.clientCodeEnabled &&
      !clientCode
    ) {
      alert('Client Code is required.');
      return;
    }

    if (!window.AASupabaseClient?.createClient) {
      alert('Supabase request failed. Client creation is not available.');
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Creating Client...';
    }

    try {
      const createdClient = await window.AASupabaseClient.createClient({
        business_name: businessName,
        client_code:
          this.clientCodeEnabled
            ? clientCode
            : undefined,
        active_status: 'Pending Setup'
      });

      if (!createdClient?.id) {
        throw new Error('Supabase did not return the new client id.');
      }

      await window.AASupabaseClient.saveClientConfiguration({
        clientId: createdClient.id,
        configuration: {
          current_package: 'Monthly Marketing',
          client_type: 'Monthly Marketing',
          contract_status: 'No Contract',
          invoice_status: 'Current',
          services: [],
          brands: [],
          access: initialAccess,
          reminder_schedule: '5 & 2 days',
          reminder_email_template: 'Standard Playbook Reminder',
          reminder_status: 'Not Scheduled',
          next_scheduled_reminder: '—',
          internal_notes: '',
          assigned_templates: []
        }
      });

      this.activeClientId = createdClient.id;
      this.editingClientId = createdClient.id;

      form.reset();
      form.hidden = true;

      await this.loadClients();

      this.activeClientId = createdClient.id;
      this.editingClientId = createdClient.id;

      this.render();

      this.showStatusMessage('Client created.');
    } catch (error) {
      console.error('Error creating client:', error);

      alert(
        `Supabase request failed: ${
          error?.message || 'Unable to create client.'
        }`
      );
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = 'Create Client';
      }
    }
  });
}

  async saveSharedTaskAnchorForm(form) {
    const anchorId =
      form.dataset
        .aaSharedTaskAnchorId ||
      '';

    const getValue = (name) =>
      form
        .querySelector(
          `[data-aa-shared-task-anchor-field="${name}"]`
        )
        ?.value ||
      '';

    const taskName =
      String(
        getValue('task_name')
      ).trim();

    const taskType =
      String(
        getValue('task_type')
      ).trim();

    const scheduleKind =
      getValue('schedule_kind') ||
      'day_of_month';

    const periodicSchedule = ['yearly', 'yearly_flexible', 'quarterly', 'quarterly_flexible'].includes(scheduleKind);
    const monthOfYear = periodicSchedule ? Number(getValue('month_of_year')) : null;
    const dayOfMonth = Number(((scheduleKind === 'yearly' || scheduleKind === 'quarterly')
      ? getValue('periodic_day_of_month') : getValue('day_of_month')) || 1);

    const weekOfMonth =
      getValue('week_of_month') ||
      'first';

    const weekday =
      scheduleKind === 'weekly'
        ? (
            getValue('weekly_weekday') ||
            'Monday'
          )
        : (
            getValue('weekday') ||
            'Monday'
          );

    const ownerValue =
      getValue('owner') ||
      'client_owner';

    const countsTowardPackage =
      Boolean(
        form
          .querySelector(
            '[data-aa-shared-task-anchor-field="counts_toward_package"]'
          )
          ?.checked
      );

    const packageServiceCatalogId =
      getValue(
        'package_service_catalog_id'
      );

    const isActive =
      Boolean(
        form
          .querySelector(
            '[data-aa-shared-task-anchor-field="is_active"]'
          )
          ?.checked
      );

    const notes =
      String(
        getValue('notes')
      ).trim();

    const assignmentMode =
      form
        .querySelector(
          '[data-aa-shared-anchor-assignment-mode]:checked'
        )
        ?.value ||
      'selected';

    const clientIds =
      assignmentMode === 'all'
        ? this.clients.map(
            (item) => item.id
          )
        : Array.from(
            form.querySelectorAll(
              '[data-aa-shared-anchor-client]:checked'
            )
          ).map(
            (input) => input.value
          );

    if (!taskName || !taskType) {
      this.showStatusMessage(
        'Task name and task type are required.',
        'error'
      );
      return;
    }

    if (!clientIds.length) {
      this.showStatusMessage(
        'Choose at least one client.',
        'error'
      );
      return;
    }

    if (
      scheduleKind ===
        'day_of_month' &&
      (
        dayOfMonth < 1 ||
        dayOfMonth > 31
      )
    ) {
      this.showStatusMessage(
        'Choose a day from 1 through 31.',
        'error'
      );
      return;
    }

    if (periodicSchedule && (!Number.isInteger(monthOfYear) || monthOfYear < 1 || monthOfYear > 12)) {
      this.showStatusMessage('Choose a month from January through December.', 'error');
      return;
    }
    if ((scheduleKind === 'yearly' || scheduleKind === 'quarterly') &&
        (!Number.isInteger(dayOfMonth) || dayOfMonth < 1 || dayOfMonth > 31)) {
      this.showStatusMessage('Choose a day from 1 through 31.', 'error');
      return;
    }

    if (
      countsTowardPackage &&
      !packageServiceCatalogId
    ) {
      this.showStatusMessage(
        'Choose which package service this Task Anchor counts toward.',
        'error'
      );
      return;
    }

    const submitButton =
      form.querySelector(
        '[type="submit"]'
      );

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent =
        'Saving...';
    }

    const payload = {
      taskName,
      taskType,
      scheduleKind,
      dayOfMonth:
        ['day_of_month', 'yearly', 'quarterly'].includes(scheduleKind)
          ? dayOfMonth : null,
      monthOfYear,
      weekOfMonth:
        scheduleKind ===
          'nth_weekday'
          ? weekOfMonth
          : null,
      weekday:
        (
          scheduleKind ===
            'nth_weekday' ||
          scheduleKind ===
            'weekly'
        )
          ? weekday
          : null,
      useClientOwner:
        ownerValue ===
        'client_owner',
      assigneeTeamMemberId:
        ownerValue ===
          'client_owner'
          ? ''
          : ownerValue,
      countsTowardPackage,
      packageServiceCatalogId:
        countsTowardPackage
          ? packageServiceCatalogId
          : '',
      notes,
      isActive
    };

    try {
      if (anchorId) {
        await window.AASupabaseClient
          .updateSharedTaskAnchor({
            id: anchorId,
            updates: payload,
            clientIds
          });
      } else {
        await window.AASupabaseClient
          .createSharedTaskAnchor({
            ...payload,
            clientIds
          });
      }

      this.taskAnchorEditorOpen =
        false;

      this.editingSharedTaskAnchorId =
        null;

      await this
        .loadActiveClientTaskAnchors();

      this.render();

      this.showStatusMessage(
        anchorId
          ? 'Shared Task Anchor saved.'
          : 'Shared Task Anchor added.'
      );
    } catch (error) {
      console.error(
        'Unable to save Shared Task Anchor:',
        error
      );

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent =
          anchorId
            ? 'Save Shared Task Anchor'
            : 'Add Shared Task Anchor';
      }

      this.showStatusMessage(
        'Unable to save Shared Task Anchor.',
        'error'
      );
    }
  }

  bindTaskAnchorActions() {
    this.root.addEventListener(
      'click',
      async (event) => {
        const addSharedButton =
          event.target.closest(
            '[data-aa-add-shared-task-anchor]'
          );

        if (addSharedButton) {
          this.taskAnchorEditorOpen = true;
          this.taskAnchorEditorScope = 'shared';
          this.editingSharedTaskAnchorId = null;
          this.editingTaskAnchorId = null;
          this.render();

          requestAnimationFrame(() => {
            this.root
              .querySelector(
                '[data-aa-shared-task-anchor-form]'
              )
              ?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
          });

          return;
        }

        const addClientButton =
          event.target.closest(
            '[data-aa-add-client-task-anchor]'
          );

        if (addClientButton) {
          this.taskAnchorEditorOpen = true;
          this.taskAnchorEditorScope = 'client';
          this.editingTaskAnchorId = null;
          this.editingSharedTaskAnchorId = null;
          this.render();

          requestAnimationFrame(() => {
            this.root
              .querySelector(
                '[data-aa-task-anchor-form]'
              )
              ?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
          });

          return;
        }

        const editButton =
          event.target.closest(
            '[data-aa-edit-task-anchor]'
          );

        if (editButton) {
          this.taskAnchorEditorOpen = true;
          this.taskAnchorEditorScope = 'client';
          this.editingSharedTaskAnchorId = null;
          this.editingTaskAnchorId =
            editButton.dataset
              .aaEditTaskAnchor ||
            null;

          this.render();

          requestAnimationFrame(() => {
            this.root
              .querySelector(
                '[data-aa-task-anchor-form]'
              )
              ?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
          });

          return;
        }

        const editSharedButton =
          event.target.closest(
            '[data-aa-edit-shared-task-anchor]'
          );

        if (editSharedButton) {
          this.taskAnchorEditorOpen = true;
          this.taskAnchorEditorScope = 'shared';
          this.editingTaskAnchorId = null;
          this.editingSharedTaskAnchorId =
            editSharedButton.dataset
              .aaEditSharedTaskAnchor ||
            null;

          this.render();

          requestAnimationFrame(() => {
            this.root
              .querySelector(
                '[data-aa-shared-task-anchor-form]'
              )
              ?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
          });

          return;
        }

        const cancelButton =
          event.target.closest(
            '[data-aa-cancel-task-anchor]'
          );

        if (cancelButton) {
          this.taskAnchorEditorOpen = false;
          this.editingTaskAnchorId = null;
          this.editingSharedTaskAnchorId = null;
          this.render();
          return;
        }

        const toggleSharedButton =
          event.target.closest(
            '[data-aa-toggle-shared-task-anchor]'
          );

        if (toggleSharedButton) {
          const id =
            toggleSharedButton.dataset
              .aaToggleSharedTaskAnchor ||
            '';

          const currentlyActive =
            toggleSharedButton.dataset
              .aaTaskAnchorActive ===
            'true';

          if (!id) {
            return;
          }

          toggleSharedButton.disabled = true;

          try {
            await window.AASupabaseClient
              .updateSharedTaskAnchor({
                id,
                updates: {
                  isActive:
                    !currentlyActive
                }
              });

            await this
              .loadActiveClientTaskAnchors();

            this.render();

            this.showStatusMessage(
              currentlyActive
                ? 'Shared Task Anchor deactivated.'
                : 'Shared Task Anchor activated.'
            );
          } catch (error) {
            console.error(
              'Unable to update Shared Task Anchor:',
              error
            );

            toggleSharedButton.disabled = false;

            this.showStatusMessage(
              'Unable to update Shared Task Anchor.',
              'error'
            );
          }

          return;
        }

        const toggleButton =
          event.target.closest(
            '[data-aa-toggle-task-anchor]'
          );

        if (toggleButton) {
          const id =
            toggleButton.dataset
              .aaToggleTaskAnchor ||
            '';

          const currentlyActive =
            toggleButton.dataset
              .aaTaskAnchorActive ===
            'true';

          if (!id) {
            return;
          }

          toggleButton.disabled = true;

          try {
            await window.AASupabaseClient
              .updateClientTaskAnchor({
                id,
                updates: {
                  isActive:
                    !currentlyActive
                }
              });

            await this
              .loadActiveClientTaskAnchors();

            this.render();

            this.showStatusMessage(
              currentlyActive
                ? 'Task Anchor deactivated.'
                : 'Task Anchor activated.'
            );
          } catch (error) {
            console.error(
              'Unable to update Task Anchor:',
              error
            );

            toggleButton.disabled = false;

            this.showStatusMessage(
              'Unable to update Task Anchor.',
              'error'
            );
          }

          return;
        }
      }
    );

    this.root.addEventListener(
      'change',
      (event) => {
        const assignmentMode =
          event.target.closest(
            '[data-aa-shared-anchor-assignment-mode]'
          );

        if (assignmentMode) {
          const form =
            assignmentMode.closest(
              '[data-aa-shared-task-anchor-form]'
            );

          const picker =
            form?.querySelector(
              '[data-aa-shared-anchor-client-picker]'
            );

          if (picker) {
            picker.hidden =
              assignmentMode.value ===
              'all';
          }

          return;
        }

        const sharedScheduleField =
          event.target.closest(
            '[data-aa-shared-task-anchor-field="schedule_kind"]'
          );

        if (sharedScheduleField) {
          const form =
            sharedScheduleField.closest(
              '[data-aa-shared-task-anchor-form]'
            );

          const dayFields =
            form?.querySelector(
              '[data-aa-shared-anchor-day-fields]'
            );

          const weekdayFields =
            form?.querySelector(
              '[data-aa-shared-anchor-weekday-fields]'
            );

          const weeklyFields =
            form?.querySelector(
              '[data-aa-shared-anchor-weekly-fields]'
            );

          const flexibleFields =
            form?.querySelector(
              '[data-aa-shared-anchor-flexible-fields]'
            );

          const periodicFields = form?.querySelector('[data-aa-shared-anchor-periodic-fields]');
          const periodicDayFields = form?.querySelector('[data-aa-shared-anchor-periodic-day-fields]');
          const periodicFlexNote = form?.querySelector('[data-aa-shared-anchor-periodic-flex-note]');
          const periodicMonthLabel = form?.querySelector('[data-aa-shared-anchor-periodic-month-label]');
          const periodic = ['yearly', 'yearly_flexible', 'quarterly', 'quarterly_flexible'].includes(sharedScheduleField.value);
          const flexiblePeriodic = periodic && sharedScheduleField.value.endsWith('_flexible');
          if (periodicFields) periodicFields.hidden = !periodic;
          if (periodicDayFields) periodicDayFields.hidden = !periodic || flexiblePeriodic;
          if (periodicFlexNote) {
            periodicFlexNote.hidden = !flexiblePeriodic;
            periodicFlexNote.textContent = sharedScheduleField.value.startsWith('quarterly')
              ? 'One task every three months. The generator chooses a date within each selected month.'
              : 'One task per year. The generator chooses a date within the selected month.';
          }
          if (periodicMonthLabel) periodicMonthLabel.textContent =
            sharedScheduleField.value.startsWith('quarterly') ? 'First Month of Quarterly Cycle' : 'Month';

          if (dayFields) {
            dayFields.hidden =
              sharedScheduleField.value !==
              'day_of_month';
          }

          if (weekdayFields) {
            weekdayFields.hidden =
              sharedScheduleField.value !==
              'nth_weekday';
          }

          if (weeklyFields) {
            weeklyFields.hidden =
              sharedScheduleField.value !==
              'weekly';
          }

          if (flexibleFields) {
            flexibleFields.hidden =
              sharedScheduleField.value !==
              'monthly_flexible';
          }

          return;
        }

        const sharedPackageField =
          event.target.closest(
            '[data-aa-shared-task-anchor-field="counts_toward_package"]'
          );

        if (sharedPackageField) {
          const form =
            sharedPackageField.closest(
              '[data-aa-shared-task-anchor-form]'
            );

          const packageWrap =
            form?.querySelector(
              '[data-aa-shared-anchor-package-fields]'
            );

          if (packageWrap) {
            packageWrap.hidden =
              !sharedPackageField.checked;
          }

          return;
        }

        const taskTypeField =
          event.target.closest(
            '[data-aa-task-anchor-field="task_type"]'
          );

        if (taskTypeField) {
          const form =
            taskTypeField.closest(
              '[data-aa-task-anchor-form]'
            );

          const packageSelect =
            form?.querySelector(
              '[data-aa-task-anchor-field="package_service_id"]'
            );

          if (
            packageSelect &&
            !packageSelect.value
          ) {
            const suggestedId =
              this.getSuggestedPackageServiceId(
                taskTypeField.value
              );

            if (suggestedId) {
              packageSelect.value =
                suggestedId;
            }
          }

          return;
        }

        const scheduleField =
          event.target.closest(
            '[data-aa-task-anchor-field="schedule_kind"]'
          );

        if (scheduleField) {
          const form =
            scheduleField.closest(
              '[data-aa-task-anchor-form]'
            );

          const dayFields =
            form?.querySelector(
              '[data-aa-anchor-day-fields]'
            );

          const weekdayFields =
            form?.querySelector(
              '[data-aa-anchor-weekday-fields]'
            );

          const weeklyFields =
            form?.querySelector(
              '[data-aa-anchor-weekly-fields]'
            );

          const flexibleFields =
            form?.querySelector(
              '[data-aa-anchor-flexible-fields]'
            );

          const periodicFields = form?.querySelector('[data-aa-anchor-periodic-fields]');
          const periodicDayFields = form?.querySelector('[data-aa-anchor-periodic-day-fields]');
          const periodicFlexNote = form?.querySelector('[data-aa-anchor-periodic-flex-note]');
          const periodicMonthLabel = form?.querySelector('[data-aa-anchor-periodic-month-label]');
          const periodic = ['yearly', 'yearly_flexible', 'quarterly', 'quarterly_flexible'].includes(scheduleField.value);
          const flexiblePeriodic = periodic && scheduleField.value.endsWith('_flexible');
          if (periodicFields) periodicFields.hidden = !periodic;
          if (periodicDayFields) periodicDayFields.hidden = !periodic || flexiblePeriodic;
          if (periodicFlexNote) {
            periodicFlexNote.hidden = !flexiblePeriodic;
            periodicFlexNote.textContent = scheduleField.value.startsWith('quarterly')
              ? 'One task every three months. The generator chooses a date within each selected month.'
              : 'One task per year. The generator chooses a date within the selected month.';
          }
          if (periodicMonthLabel) periodicMonthLabel.textContent =
            scheduleField.value.startsWith('quarterly') ? 'First Month of Quarterly Cycle' : 'Month';

          if (dayFields) {
            dayFields.hidden =
              scheduleField.value !==
              'day_of_month';
          }

          if (weekdayFields) {
            weekdayFields.hidden =
              scheduleField.value !==
              'nth_weekday';
          }

          if (weeklyFields) {
            weeklyFields.hidden =
              scheduleField.value !==
              'weekly';
          }

          if (flexibleFields) {
            flexibleFields.hidden =
              scheduleField.value !==
              'monthly_flexible';
          }

          return;
        }

        const packageField =
          event.target.closest(
            '[data-aa-task-anchor-field="counts_toward_package"]'
          );

        if (packageField) {
          const form =
            packageField.closest(
              '[data-aa-task-anchor-form]'
            );

          const packageWrap =
            form?.querySelector(
              '[data-aa-anchor-package-fields]'
            );

          if (packageWrap) {
            packageWrap.hidden =
              !packageField.checked;
          }
        }
      }
    );

    this.root.addEventListener(
      'submit',
      async (event) => {
        const productionForm =
          event.target.closest(
            '[data-aa-production-settings-form]'
          );

        if (productionForm) {
          event.preventDefault();

          const clientId =
            productionForm.dataset
              .aaProductionSettingsForm ||
            '';

          const submitButton =
            productionForm.querySelector(
              '[type="submit"]'
            );

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent =
              'Saving...';
          }

          try {
            await window.AASupabaseClient
              .saveClientProductionSettings({
                clientId,
                preferredEmailWeekdays:
                  [...productionForm.querySelectorAll('[data-aa-production-email-day]:checked')]
                    .map(input => input.value),
                preferredEmailTime:
                  productionForm
                    .querySelector(
                      '[data-aa-production-field="preferred_email_time"]'
                    )
                    ?.value ||
                  '',
                doNotPromote:
                  productionForm
                    .querySelector(
                      '[data-aa-production-field="do_not_promote"]'
                    )
                    ?.value ||
                  '',
                priorityPromotions:
                  productionForm
                    .querySelector(
                      '[data-aa-production-field="priority_promotions"]'
                    )
                    ?.value ||
                  '',
                standingRules:
                  productionForm
                    .querySelector(
                      '[data-aa-production-field="standing_rules"]'
                    )
                    ?.value ||
                  ''
              });

            await this
              .loadActiveClientTaskAnchors();

            this.render();

            this.showStatusMessage(
              'Production rules saved.'
            );
          } catch (error) {
            console.error(
              'Unable to save production rules:',
              error
            );

            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent =
                'Save Production Rules';
            }

            this.showStatusMessage(
              'Unable to save production rules.',
              'error'
            );
          }

          return;
        }

        const sharedAnchorForm =
          event.target.closest(
            '[data-aa-shared-task-anchor-form]'
          );

        if (sharedAnchorForm) {
          event.preventDefault();
          await this
            .saveSharedTaskAnchorForm(
              sharedAnchorForm
            );
          return;
        }

        const anchorForm =
          event.target.closest(
            '[data-aa-task-anchor-form]'
          );

        if (!anchorForm) {
          return;
        }

        event.preventDefault();

        const clientId =
          anchorForm.dataset
            .aaTaskAnchorForm ||
          '';

        const anchorId =
          anchorForm.dataset
            .aaTaskAnchorId ||
          '';

        const getValue = (name) =>
          anchorForm
            .querySelector(
              `[data-aa-task-anchor-field="${name}"]`
            )
            ?.value ||
          '';

        const taskName =
          String(
            getValue('task_name')
          ).trim();

        const taskType =
          String(
            getValue('task_type')
          ).trim();

        const scheduleKind =
          getValue('schedule_kind') ||
          'day_of_month';

        const periodicSchedule = ['yearly', 'yearly_flexible', 'quarterly', 'quarterly_flexible'].includes(scheduleKind);
        const monthOfYear = periodicSchedule ? Number(getValue('month_of_year')) : null;
        const dayOfMonth = Number(((scheduleKind === 'yearly' || scheduleKind === 'quarterly')
          ? getValue('periodic_day_of_month') : getValue('day_of_month')) || 1);

        const weekOfMonth =
          getValue('week_of_month') ||
          'first';

        const weekday =
          scheduleKind === 'weekly'
            ? (
                getValue('weekly_weekday') ||
                'Monday'
              )
            : (
                getValue('weekday') ||
                'Monday'
              );

        const ownerValue =
          getValue('owner') ||
          'client_owner';

        const countsTowardPackage =
          Boolean(
            anchorForm
              .querySelector(
                '[data-aa-task-anchor-field="counts_toward_package"]'
              )
              ?.checked
          );

        const packageServiceId =
          getValue(
            'package_service_id'
          );

        const packageUnits = 1;

        const isActive =
          Boolean(
            anchorForm
              .querySelector(
                '[data-aa-task-anchor-field="is_active"]'
              )
              ?.checked
          );

        const notes =
          String(
            getValue('notes')
          ).trim();

        if (!taskName || !taskType) {
          this.showStatusMessage(
            'Task name and task type are required.',
            'error'
          );
          return;
        }

        if (
          scheduleKind ===
            'day_of_month' &&
          (
            dayOfMonth < 1 ||
            dayOfMonth > 31
          )
        ) {
          this.showStatusMessage(
            'Choose a day from 1 through 31.',
            'error'
          );
          return;
        }

        if (periodicSchedule && (!Number.isInteger(monthOfYear) || monthOfYear < 1 || monthOfYear > 12)) {
          this.showStatusMessage('Choose a month from January through December.', 'error');
          return;
        }
        if ((scheduleKind === 'yearly' || scheduleKind === 'quarterly') &&
            (!Number.isInteger(dayOfMonth) || dayOfMonth < 1 || dayOfMonth > 31)) {
          this.showStatusMessage('Choose a day from 1 through 31.', 'error');
          return;
        }

        if (
          countsTowardPackage &&
          !packageServiceId
        ) {
          this.showStatusMessage(
            'Choose which package service this Task Anchor counts toward.',
            'error'
          );
          return;
        }

        const submitButton =
          anchorForm.querySelector(
            '[type="submit"]'
          );

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent =
            'Saving...';
        }

        const payload = {
          clientId,
          taskName,
          taskType,
          scheduleKind,
          dayOfMonth:
            ['day_of_month', 'yearly', 'quarterly'].includes(scheduleKind)
              ? dayOfMonth : null,
          monthOfYear,
          weekOfMonth:
            scheduleKind ===
              'nth_weekday'
              ? weekOfMonth
              : null,
          weekday:
            (
              scheduleKind ===
                'nth_weekday' ||
              scheduleKind ===
                'weekly'
            )
              ? weekday
              : null,
          useClientOwner:
            ownerValue ===
            'client_owner',
          assigneeTeamMemberId:
            ownerValue ===
              'client_owner'
              ? ''
              : ownerValue,
          countsTowardPackage,
          packageServiceId:
            countsTowardPackage
              ? packageServiceId
              : '',
          packageUnits:
            countsTowardPackage
              ? packageUnits
              : 1,
          notes,
          isActive
        };

        try {
          if (anchorId) {
            await window.AASupabaseClient
              .updateClientTaskAnchor({
                id: anchorId,
                updates: payload
              });
          } else {
            await window.AASupabaseClient
              .createClientTaskAnchor(
                payload
              );
          }

          this.taskAnchorEditorOpen =
            false;

          this.editingTaskAnchorId =
            null;

          await this
            .loadActiveClientTaskAnchors();

          this.render();

          this.showStatusMessage(
            anchorId
              ? 'Task Anchor saved.'
              : 'Task Anchor added.'
          );
        } catch (error) {
          console.error(
            'Unable to save Task Anchor:',
            error
          );

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent =
              anchorId
                ? 'Save Task Anchor'
                : 'Add Task Anchor';
          }

          this.showStatusMessage(
            'Unable to save Task Anchor.',
            'error'
          );
        }
      }
    );
  }

  printCoopReport(
    report,
    client
  ) {
    if (!report || !client) {
      return;
    }

    const popup =
      window.open(
        '',
        '_blank',
        'noopener,noreferrer'
      );

    if (!popup) {
      this.showStatusMessage(
        'Your browser blocked the report window.',
        'error'
      );
      return;
    }

    const reportHtml =
      this.renderCoopReportDocument(
        report,
        client
      );

    popup.document.open();
    popup.document.write(`
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>${this.escapeHtml(report.reportTitle || 'Co-op Report')}</title>
          <style>
            *{box-sizing:border-box}
            html,body{margin:0;padding:0;background:#eeeae2;color:#303537}
            body{font-family:Arial,sans-serif}
            .aa-coop-document{position:relative;width:8.5in;height:11in;margin:0 auto;padding:.43in .5in .46in;background:#fff;overflow:hidden}
            .aa-coop-document__topbar,.aa-coop-document__bottombar{position:absolute;left:0;right:0;height:.065in;background:#689097}
            .aa-coop-document__topbar{top:0}.aa-coop-document__bottombar{bottom:0}
            .aa-coop-document__masthead{display:flex;align-items:center;justify-content:space-between;gap:.25in;padding:.03in 0 .11in;border-bottom:1px solid #ddd8ce}
            .aa-coop-document__logo{display:block;width:2.72in;height:auto}
            .aa-coop-document__masthead>span{color:#689097;font-size:7.6px;font-weight:700;letter-spacing:1.55px;white-space:nowrap}
            .aa-coop-document__heading{padding:.16in 0 .13in;text-align:center}
            .aa-coop-document__heading h2{margin:0;color:#303537;font-family:Georgia,'Times New Roman',serif;font-size:23px;font-weight:400;line-height:1.05}
            .aa-coop-document__heading p{margin:.07in 0 0;color:#77736d;font-size:8px;line-height:1.25}
            .aa-coop-document__rule{height:2px;margin:0 0 .19in;background:#689097}
            .aa-coop-document__catalogs{display:grid;gap:.16in .12in;align-items:start}
            .aa-coop-document__catalogs--1{grid-template-columns:1.72in;justify-content:center}
            .aa-coop-document__catalogs--2{grid-template-columns:repeat(2,1.72in);justify-content:center}
            .aa-coop-document__catalogs--3{grid-template-columns:repeat(3,1.72in);justify-content:center}
            .aa-coop-document__catalogs--4{grid-template-columns:repeat(4,1fr)}
            .aa-coop-document__catalog{min-width:0;break-inside:avoid}
            .aa-coop-document__cover{aspect-ratio:3/4;overflow:hidden;border:1px solid #d2ccc2;background:#f5f1e8;box-shadow:0 2px 7px rgba(43,41,37,.08)}
            .aa-coop-document__cover img{display:block;width:100%;height:100%;object-fit:cover}
            .aa-coop-document__cover-empty{height:100%;display:flex;align-items:center;justify-content:center;color:#8a867f;font-size:8px}
            .aa-coop-document__catalog-line{display:flex;align-items:baseline;justify-content:space-between;gap:7px;padding:.045in .01in 0}
            .aa-coop-document__catalog-line strong{color:#303537;font-family:Georgia,'Times New Roman',serif;font-size:8.3px;font-weight:600;white-space:nowrap}
            .aa-coop-document__catalog-line a{color:#5d8389;font-size:6.8px;font-weight:700;text-decoration:none;border-bottom:1px solid #aac0c4;white-space:nowrap}
            .aa-coop-document__footer{position:absolute;left:.5in;right:.5in;bottom:.18in;padding-top:.055in;border-top:1px solid #ddd8ce;color:#7d8586;font-size:6.5px;font-weight:700;letter-spacing:.8px;text-align:center;text-transform:uppercase}
            .aa-coop-document.is-annual .aa-coop-document__masthead{padding-bottom:.08in}
            .aa-coop-document.is-annual .aa-coop-document__heading{padding:.12in 0 .1in}
            .aa-coop-document.is-annual .aa-coop-document__heading h2{font-size:21px}
            .aa-coop-document.is-annual .aa-coop-document__rule{margin-bottom:.14in}
            .aa-coop-document.is-annual .aa-coop-document__catalogs{gap:.12in .1in}
            .aa-coop-document.is-annual .aa-coop-document__catalog-line{padding-top:.035in}
            @media print{
              @page{size:letter portrait;margin:0}
              body{background:#fff}
              .aa-coop-document{margin:0;width:8.5in;height:11in;box-shadow:none}
            }
          </style>
        </head>
        <body>
          ${reportHtml}
          <script>
            window.addEventListener('load', function(){
              setTimeout(function(){ window.print(); }, 450);
            });
          <\/script>
        </body>
      </html>
    `);
    popup.document.close();
  }

  async saveCoopReportForm(
    form
  ) {
    const clientId =
      form.dataset
        .aaCoopReportForm ||
      '';

    const client =
      this.clients.find(
        (item) =>
          String(item.id) ===
          String(clientId)
      );

    if (!client) {
      return;
    }

    const getValue = (name) =>
      form
        .querySelector(
          `[data-aa-coop-field="${name}"]`
        )
        ?.value ||
      '';

    const period =
      getValue('period');

    const manufacturer =
      String(
        getValue('manufacturer')
      ).trim();

    let dateStart = '';
    let dateEnd = '';
    let periodLabel = '';

    if (period === 'custom') {
      const startMonth =
        getValue('start_month');
      const endMonth =
        getValue('end_month');

      if (!startMonth || !endMonth) {
        this.showStatusMessage(
          'Choose a start and end month.',
          'error'
        );
        return;
      }

      if (startMonth > endMonth) {
        this.showStatusMessage(
          'The start month must come before the end month.',
          'error'
        );
        return;
      }

      dateStart =
        `${startMonth}-01`;
      dateEnd =
        `${endMonth}-01`;

      periodLabel =
        `${this.formatCatalogMonth(dateStart)} - ${this.formatCatalogMonth(dateEnd)}`;
    } else {
      const year =
        Number(period);

      if (!Number.isInteger(year)) {
        this.showStatusMessage(
          'Choose a reporting year.',
          'error'
        );
        return;
      }

      dateStart =
        `${year}-01-01`;
      dateEnd =
        `${year}-12-01`;
      periodLabel =
        String(year);
    }

    const manufacturerKey =
      manufacturer.toLowerCase();

    const catalogs =
      this.getCatalogRecords(client)
        .filter((catalog) => {
          const month =
            String(
              catalog.catalog_month ||
              ''
            ).slice(0, 10);

          const dateMatches =
            month >= dateStart &&
            month <= dateEnd;

          const brandMatches =
            !manufacturerKey ||
            (
              Array.isArray(
                catalog.brands
              ) &&
              catalog.brands.some(
                (brand) =>
                  String(brand)
                    .trim()
                    .toLowerCase() ===
                  manufacturerKey
              )
            );

          return (
            dateMatches &&
            brandMatches
          );
        })
        .sort((a, b) =>
          String(
            a.catalog_month || ''
          ).localeCompare(
            String(
              b.catalog_month || ''
            )
          )
        );

    if (!catalogs.length) {
      this.showStatusMessage(
        'No catalog records match that report.',
        'error'
      );
      return;
    }

    const snapshot =
      catalogs.map((catalog) => ({
        id: catalog.id,
        catalog_month:
          catalog.catalog_month ||
          '',
        publication_date:
          catalog.publication_date ||
          '',
        catalog_title:
          catalog.catalog_title ||
          '',
        catalog_url:
          catalog.catalog_url ||
          '',
        catalog_pdf_storage_path:
          catalog.catalog_pdf_storage_path ||
          '',
        cover_image_url:
          catalog.cover_image_url ||
          '',
        catalog_views:
          catalog.catalog_views ??
          null,
        brands:
          Array.isArray(
            catalog.brands
          )
            ? catalog.brands
            : []
      }));

    const reportTitle =
      `${periodLabel} Co-op Marketing Catalog Summary`;

    const submitButton =
      form.querySelector(
        '[type="submit"]'
      );

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent =
        'Generating...';
    }

    try {
      const report = {
        id:
          `preview-${Date.now()}`,
        clientId,
        reportTitle,
        dateStart,
        dateEnd,
        manufacturer,
        catalogSnapshot:
          snapshot,
        catalogCount:
          snapshot.length,
        totalViews: null
      };

      this.coopReportPreview =
        report;

      this.coopReportPreviewId =
        report.id;

      this.activeCatalogSection =
        'coop';

      this.render();

      this.showStatusMessage(
        'Co-op report generated.'
      );
    } catch (error) {
      console.error(
        'Unable to generate Co-op report:',
        error
      );

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent =
          'Generate Co-op Report';
      }

      this.showStatusMessage(
        'Unable to generate Co-op report.',
        'error'
      );
    } }


  bindClientActions() {
    this.root.addEventListener('input', (event) => {
      const confirmation = event.target.closest('[data-aa-catalog-delete-phrase]');
      if (confirmation) {
        const approve = this.root.querySelector('[data-aa-catalog-delete-confirm]');
        if (approve) approve.disabled = confirmation.value.trim() !== 'DELETE';
        return;
      }
      const waveCustomerSearch =
        event.target.closest(
          '[data-aa-wave-customer-search]'
        );

      if (waveCustomerSearch) {
        const query =
          String(
            waveCustomerSearch.value || ''
          )
            .trim()
            .toLowerCase();

        this.root
          .querySelectorAll(
            '[data-aa-wave-customer-row]'
          )
          .forEach((row) => {
            const haystack =
              String(
                row.dataset.search || ''
              );

            row.hidden =
              Boolean(query) &&
              !haystack.includes(query);
          });

        return;
      }

      const search =
        event.target.closest(
          '[data-aa-client-search]'
        );

      if (!search) return;

      this.clientSearch =
        search.value || '';

      this.filterClientDirectory();
    });

    this.root.addEventListener('change', async (event) => {
  const quickVendorStatus =
    event.target.closest(
      '[data-aa-quick-vendor-status]'
    );

  if (quickVendorStatus) {
    const clientId =
      quickVendorStatus.dataset
        .aaVendorClientId ||
      this.activeClientId;

    const vendorName =
      String(
        quickVendorStatus.dataset
          .aaVendorName || ''
      ).trim();

    const nextStatus =
      quickVendorStatus.value ||
      'unknown';

    if (!clientId || !vendorName) {
      return;
    }

    const nextBrands =
      this.clientVendorBrands.map(
        (vendor, index) => ({
          vendorName:
            vendor.vendorName || '',
          accessStatus:
            String(vendor.vendorName || '')
              .trim()
              .toLowerCase() ===
            vendorName.toLowerCase()
              ? nextStatus
              : vendor.accessStatus || 'unknown',
          displayOrder:
            Number(
              vendor.displayOrder ?? index
            )
        })
      );

    quickVendorStatus.disabled = true;

    try {
      const result =
        await window.AAPlaybookService
          .saveClientVendorBrands({
            clientId,
            brands: nextBrands
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to update marketing access.'
          )
        );
      }

      await this.loadActiveClientBrandWorkspace();
      this.render();
    } catch (error) {
      console.error(
        'Unable to update vendor marketing access:',
        error
      );

      quickVendorStatus.disabled = false;

      this.showStatusMessage(
        error?.message ||
          'Unable to update marketing access.',
        'error'
      );
    }

    return;
  }

  const picker = event.target.closest('[data-aa-client-picker]');
  if (!picker) return;

  this.activeClientId = picker.value;
this.editingClientId = null;
this.editingPackageClientId = null;
this.taskAnchorEditorOpen = false;
this.editingTaskAnchorId = null;
this.editingAccessClientId = null;
this.editingBrandClientId = null;
this.editingContractClientId = null;
this.waveCustomerPickerOpen = false;
this.waveInvoices = [];
this.waveInvoiceError = '';
this.waveInvoiceTested = false;
this.activeClientTab = 'overview';
this.activeCatalogSection = 'history';
this.coopReportPreviewId = null;
this.coopReportPreview = null;

this.rememberActiveClientInUrl();

await Promise.all([
  this.loadActiveClientPlaybooks(),
  this.loadActiveClientPackage(),
  this.loadActiveClientTaskAnchors(),
  this.loadActiveClientAccess(),
  this.loadActiveClientBrandWorkspace(),
  this.loadActiveClientContracts(),
  this.loadActiveClientWaveMapping()
]);

this.render();
});

this.root.addEventListener('change', (event) => {
  const deleteYear = event.target.closest('[data-aa-catalog-delete-year]');
  if (deleteYear) {
    this.catalogDeleteYear = deleteYear.value || 'all';
    const selectYear = this.root.querySelector('[data-aa-catalog-delete-select-year]');
    if (selectYear) {
      selectYear.textContent = 'Select ' + (
        this.catalogDeleteYear === 'all' ? 'All Shown' : this.catalogDeleteYear
      );
    }
    return;
  }
  const periodField =
    event.target.closest(
      '[data-aa-coop-field="period"]'
    );

  if (!periodField) {
    return;
  }

  const form =
    periodField.closest(
      '[data-aa-coop-report-form]'
    );

  const customRange =
    form?.querySelector(
      '[data-aa-coop-custom-range]'
    );

  if (customRange) {
    customRange.hidden =
      periodField.value !==
      'custom';
  }
});

this.root.addEventListener('click', async (event) => {
const openCatalogPdfButton =
  event.target.closest(
    '[data-aa-open-catalog-pdf]'
  );

if (openCatalogPdfButton) {
  const path =
    openCatalogPdfButton.dataset
      .aaOpenCatalogPdf ||
    '';

  if (!path) {
    return;
  }

  openCatalogPdfButton.disabled = true;
  openCatalogPdfButton.textContent =
    'Opening...';

  try {
    const url =
      await window.AASupabaseClient
        .getCatalogPdfSignedUrl({
          path
        });

    window.open(
      url,
      '_blank',
      'noopener,noreferrer'
    );
  } catch (error) {
    console.error(
      'Unable to open stored catalog PDF:',
      error
    );

    this.showStatusMessage(
      'Unable to open stored catalog PDF.',
      'error'
    );
  } finally {
    if (
      openCatalogPdfButton.isConnected
    ) {
      openCatalogPdfButton.disabled =
        false;
      openCatalogPdfButton.textContent =
        'Open Stored PDF';
    }
  }

  return;
}

const catalogJumpButton =
  event.target.closest(
    '[data-aa-catalog-jump]'
  );

if (catalogJumpButton) {
  this.activeCatalogSection =
    catalogJumpButton.dataset
      .aaCatalogJump ||
    'history';

  this.coopReportPreviewId = null;
this.coopReportPreview = null;
  this.render();
  return;
}

const printCoopReportButton =
  event.target.closest(
    '[data-aa-print-coop-report]'
  );

if (printCoopReportButton) {
  const report =
    this.coopReportPreview;

  const client =
    this.getActiveClient();

  if (report && client) {
    this.printCoopReport(
      report,
      client
    );
  }

  return;
}

const clientSelectButton =
  event.target.closest('[data-aa-client-select]');

if (clientSelectButton) {
  this.activeClientId =
    clientSelectButton.dataset.aaClientSelect || null;

  // Always start the next client in active catalog view.
  this.showArchivedCatalogs = false;
  this.resetCatalogDeletion();
  this.editingClientId = null;
  this.editingPackageClientId = null;
  this.editingAccessClientId = null;
  this.editingBrandClientId = null;
  this.editingContractClientId = null;
  this.waveCustomerPickerOpen = false;
  this.activeClientTab = 'overview';
  
  this.rememberActiveClientInUrl();

  await Promise.all([
    this.loadActiveClientPlaybooks(),
    this.loadActiveClientPackage(),
    this.loadActiveClientAccess(),
    this.loadActiveClientBrandWorkspace(),
    this.loadActiveClientContracts(),
    this.loadActiveClientWaveMapping()
  ]);

  this.render();
  return;
}

const planningJumpButton =
  event.target.closest(
    '[data-aa-planning-jump]'
  );

if (planningJumpButton) {
  this.activePlanningSection =
    planningJumpButton.dataset
      .aaPlanningJump ||
    'package';

  this.rememberActiveClientInUrl();
  this.render();
  return;
}

const accountJumpButton =
  event.target.closest(
    '[data-aa-account-jump]'
  );

if (accountJumpButton) {
  this.activeAccountSection =
    accountJumpButton.dataset
      .aaAccountJump ||
    'agreements';

  this.rememberActiveClientInUrl();
  this.render();
  return;
}

const clientTabButton =
  event.target.closest('[data-aa-client-tab]');

if (clientTabButton) {
  this.activeClientTab =
    clientTabButton.dataset.aaClientTab ||
    'overview';

  this.rememberActiveClientInUrl();
  this.render();
  return;
}

      const editButton = event.target.closest('[data-aa-edit-client]');
const cancelButton = event.target.closest('[data-aa-cancel-client-edit]');
const viewWorkspaceButton = event.target.closest('[data-aa-view-client-workspace]');
const manageRemindersButton = event.target.closest('[data-aa-manage-reminders]');
const archiveButton = event.target.closest('[data-aa-archive-client]');
const restoreClientButton = event.target.closest('[data-aa-restore-client]');

const archiveTemplateButton =
  event.target.closest('[data-aa-archive-template-assignment]');

const restoreTemplateButton =
  event.target.closest('[data-aa-restore-template-assignment]');

const deleteTemplateButton =
  event.target.closest('[data-aa-delete-template-assignment]');

const archiveCatalogButton =
  event.target.closest('[data-aa-archive-catalog]');
const catalogDeleteModeButton = event.target.closest('[data-aa-catalog-delete-mode]');
const catalogDeleteSelect = event.target.closest('[data-aa-catalog-delete-select]');
const catalogDeleteSelectYear = event.target.closest('[data-aa-catalog-delete-select-year]');
const catalogDeleteReview = event.target.closest('[data-aa-catalog-delete-review]');
const catalogDeleteCancel = event.target.closest('[data-aa-catalog-delete-cancel]');
const catalogDeleteConfirm = event.target.closest('[data-aa-catalog-delete-confirm]');
const archivedCatalogsToggle = event.target.closest('[data-aa-toggle-archived-catalogs]');
const restoreCatalogButton = event.target.closest('[data-aa-restore-catalog]');

const addCatalogButton =
  event.target.closest('[data-aa-add-catalog]');

const editCatalogButton =
  event.target.closest('[data-aa-edit-catalog]');

const cancelCatalogButton =
  event.target.closest('[data-aa-cancel-catalog]');

const managePackageButton =
  event.target.closest('[data-aa-manage-package]');

const cancelPackageButton =
  event.target.closest('[data-aa-cancel-package]');

const manageServiceLibraryButton =
  event.target.closest('[data-aa-manage-service-library]');

const libraryDoneButton =
  event.target.closest('[data-aa-close-service-library]');

const libraryRemoveButton =
  event.target.closest('[data-aa-remove-service-library-item]');

const addServiceLibraryItemButton =
  event.target.closest('[data-aa-add-service-library-item]');

const manageAccessButton =
  event.target.closest('[data-aa-manage-access]');

const cancelAccessButton =
  event.target.closest('[data-aa-cancel-access]');

const addCustomAccessButton =
  event.target.closest('[data-aa-add-custom-access]');

const manageBrandAssetsButton =
  event.target.closest('[data-aa-manage-brand-assets]');

const cancelBrandAssetsButton =
  event.target.closest('[data-aa-cancel-brand-assets]');

const testWaveConnectionButton =
  event.target.closest('[data-aa-test-wave-connection]');

const selectWaveBusinessButton =
  event.target.closest('[data-aa-select-wave-business]');

const openWaveCustomerPickerButton =
  event.target.closest('[data-aa-open-wave-customer-picker]');

const closeWaveCustomerPickerButton =
  event.target.closest('[data-aa-close-wave-customer-picker]');

const selectWaveCustomerButton =
  event.target.closest('[data-aa-select-wave-customer]');

const testWaveInvoicesButton =
  event.target.closest('[data-aa-test-wave-invoices]');

const manageContractsButton =
  event.target.closest('[data-aa-manage-contracts]');

const cancelContractsButton =
  event.target.closest('[data-aa-cancel-contracts]');

const editContractRecordButton =
  event.target.closest('[data-aa-edit-contract-record]');

const archiveContractButton =
  event.target.closest('[data-aa-archive-contract]');

const deleteContractButton =
  event.target.closest('[data-aa-delete-contract]');

const archiveContractDocumentButton =
  event.target.closest('[data-aa-archive-contract-document]');

const deleteContractDocumentButton =
  event.target.closest('[data-aa-delete-contract-document]');

const archiveBrandAssetButton =
  event.target.closest('[data-aa-archive-brand-asset]');

const toggleClientVendorButton =
  event.target.closest('[data-aa-toggle-client-vendor]');

const addLibraryVendorButton =
  event.target.closest('[data-aa-add-library-vendor]');

const addCustomVendorButton =
  event.target.closest('[data-aa-add-custom-vendor]');

const removeVendorRowButton =
  event.target.closest('[data-aa-remove-vendor-row]');

  const reviewPlaybookButton =
  event.target.closest('[data-aa-review-playbook]');

  if (managePackageButton) {
    this.editingPackageClientId =
      managePackageButton.dataset
        .aaManagePackage || null;

    this.packageLibraryOpen = false;
    this.render();
    return;
  }

  if (cancelPackageButton) {
    this.editingPackageClientId = null;
    this.packageLibraryOpen = false;
    this.render();
    return;
  }

  if (manageServiceLibraryButton) {
    this.packageLibraryOpen = true;
    this.render();
    return;
  }

  if (libraryDoneButton) {
    this.packageLibraryOpen = false;
    this.render();
    return;
  }

  if (addServiceLibraryItemButton) {
    const panel =
      addServiceLibraryItemButton.closest(
        '[data-aa-service-library-panel]'
      );

    if (!panel) {
      return;
    }

    const serviceName =
      panel.querySelector(
        '[data-aa-service-library-name]'
      )?.value.trim() || '';

    const category =
      panel.querySelector(
        '[data-aa-service-library-category]'
      )?.value.trim() || '';

    const defaultUnitLabel =
      panel.querySelector(
        '[data-aa-service-library-unit]'
      )?.value || 'per month';

    const description =
      panel.querySelector(
        '[data-aa-service-library-description]'
      )?.value.trim() || '';

    const messageEl =
      panel.querySelector(
        '[data-aa-service-library-message]'
      );

    const setMessage = (
      message,
      state = ''
    ) => {
      if (!messageEl) {
        return;
      }

      messageEl.textContent = message;
      messageEl.hidden = !message;

      if (state) {
        messageEl.dataset.state = state;
      } else {
        delete messageEl.dataset.state;
      }
    };

    if (!serviceName) {
      setMessage(
        'Enter a service name.',
        'error'
      );
      return;
    }

    addServiceLibraryItemButton.disabled = true;
    addServiceLibraryItemButton.textContent =
      'Adding...';

    try {
      const result =
        await window.AAPlaybookService
          .upsertServiceCatalogItem({
            serviceName,
            category,
            defaultUnitLabel,
            description
          });

      if (!result?.success) {
        throw new Error(
          'Unable to add service.'
        );
      }

      await this.loadActiveClientPackage();

      this.packageLibraryOpen = true;
      this.render();



      this.showStatusMessage(
        'Service added to the reusable package library.'
      );
    } catch (error) {
      console.error(
        'Unable to add package service:',
        error
      );

      addServiceLibraryItemButton.disabled =
        false;

      addServiceLibraryItemButton.textContent =
        'Add to Library';

      setMessage(
        'Unable to add this service. Please try again.',
        'error'
      );
    }

    return;
  }

  if (libraryRemoveButton) {
    const serviceId =
      libraryRemoveButton.dataset
        .aaRemoveServiceLibraryItem || '';

    if (!serviceId) {
      return;
    }

    if (
      libraryRemoveButton.dataset
        .confirmRemove !== 'true'
    ) {
      libraryRemoveButton.dataset
        .confirmRemove = 'true';

      libraryRemoveButton.textContent =
        'Confirm Remove';

      window.setTimeout(() => {
        if (
          libraryRemoveButton.isConnected &&
          libraryRemoveButton.dataset
            .confirmRemove === 'true'
        ) {
          delete libraryRemoveButton.dataset
            .confirmRemove;

          libraryRemoveButton.textContent =
            'Remove from Builder';
        }
      }, 5000);

      return;
    }

    libraryRemoveButton.disabled = true;
    libraryRemoveButton.textContent =
      'Removing...';

    try {
      const result =
        await window.AAPlaybookService
          .archiveServiceCatalogItem({
            serviceId
          });

      if (!result?.success) {
        throw new Error(
          'Unable to remove service.'
        );
      }

      await this.loadActiveClientPackage();
      this.packageLibraryOpen = true;
      this.render();



      this.showStatusMessage(
        'Service removed from future package builders.'
      );
    } catch (error) {
      console.error(
        'Unable to remove package service:',
        error
      );

      this.showStatusMessage(
        'Unable to remove that service.',
        'error'
      );
    }

    return;
  }

  if (manageAccessButton) {
    this.editingAccessClientId =
      manageAccessButton.dataset
        .aaManageAccess || null;

    this.render();
    return;
  }

  if (cancelAccessButton) {
    this.editingAccessClientId = null;
    this.render();
    return;
  }

  if (addCustomAccessButton) {
    const form =
      addCustomAccessButton.closest(
        '[data-aa-access-form]'
      );

    const list =
      form?.querySelector(
        '[data-aa-access-row-list]'
      );

    if (list) {
      const index =
        list.querySelectorAll(
          '[data-aa-access-row]'
        ).length;

      list.insertAdjacentHTML(
        'beforeend',
        this.renderAccessEditorRow({
          item: {
            platformId: '',
            platformName: '',
            isRequired: true,
            accessMethod: 'create_login',
            loginEmail:
              this.getDefaultAccessEmail(
                this.getActiveClient()
              ),
            loginUsername: '',
            clientInstructions: '',
            status: 'not_requested',
            mfaStatus: 'unknown',
            mfaOwner: '',
            internalNotes: '',
            vaultReference: ''
          },
          index,
          custom: true
        })
      );
    }

    return;
  }

  if (openWaveCustomerPickerButton) {
    this.waveCustomerPickerOpen = true;

    if (!this.waveCustomers.length) {
      await this.loadWaveCustomers();
    }

    this.render();

    requestAnimationFrame(() => {
      this.root
        .querySelector(
          '[data-aa-wave-customer-search]'
        )
        ?.focus();
    });

    return;
  }

  if (closeWaveCustomerPickerButton) {
    this.waveCustomerPickerOpen = false;
    this.waveCustomerError = '';
    this.render();
    return;
  }

  if (selectWaveCustomerButton) {
    const client =
      this.getActiveClient();

    const customerId =
      selectWaveCustomerButton.dataset
        .aaSelectWaveCustomer || '';

    if (!client?.id || !customerId) {
      return;
    }

    selectWaveCustomerButton.disabled = true;
    selectWaveCustomerButton.textContent =
      'Connecting...';

    try {
      const result =
        await window.AAPlaybookService
          .setClientWaveCustomer({
            clientId: client.id,
            customerId
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to connect Wave customer.'
          )
        );
      }

      this.waveClientMapping =
        result.mapping || null;

      this.waveCustomerPickerOpen = false;
      this.waveCustomerError = '';
      this.waveInvoices = [];
      this.waveInvoiceError = '';
      this.waveInvoiceTested = false;

      this.render();

      this.showStatusMessage(
        'Wave customer connected.'
      );
    } catch (error) {
      console.error(
        'Unable to connect Wave customer:',
        error
      );

      this.waveCustomerError =
        error?.message ||
        'Unable to connect Wave customer.';

      selectWaveCustomerButton.disabled = false;
      selectWaveCustomerButton.textContent =
        'Use This Customer';

      this.render();
    }

    return;
  }

  if (testWaveInvoicesButton) {
    const client =
      this.getActiveClient();

    if (!client?.id) {
      return;
    }

    this.waveInvoiceLoading = true;
    this.waveInvoiceError = '';
    this.waveInvoiceTested = false;
    this.render();

    try {
      const result =
        await window.AAPlaybookService
          .getClientWaveInvoices({
            clientId: client.id
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to retrieve Wave invoices.'
          )
        );
      }

      this.waveInvoices =
        Array.isArray(result.invoices)
          ? result.invoices
          : [];

      this.waveInvoiceTested = true;
    } catch (error) {
      console.error(
        'Unable to retrieve Wave invoices:',
        error
      );

      this.waveInvoices = [];
      this.waveInvoiceTested = true;
      this.waveInvoiceError =
        error?.message ||
        'Unable to retrieve Wave invoices.';
    } finally {
      this.waveInvoiceLoading = false;
      this.render();

      requestAnimationFrame(() => {
        this.root
          .querySelector(
            '.aa-client-wave-invoice-test'
          )
          ?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
      });
    }

    return;
  }

  if (testWaveConnectionButton) {
    this.waveConnectionLoading = true;
    this.waveConnectionError = '';
    this.waveBusinesses = [];
    this.render();

    try {
      const result =
        await window.AAPlaybookService
          .listWaveBusinesses();

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to connect to Wave.'
          )
        );
      }

      this.waveBusinesses =
        Array.isArray(result.businesses)
          ? result.businesses
          : [];

      this.waveConnection =
        result.connection || null;

      this.waveConnectionError =
        this.waveBusinesses.length
          ? ''
          : 'Wave connected, but no businesses were returned.';
    } catch (error) {
      console.error(
        'Unable to test Wave connection:',
        error
      );

      this.waveConnectionError =
        error?.message ||
        'Unable to connect to Wave.';
    } finally {
      this.waveConnectionLoading = false;
      this.render();

      requestAnimationFrame(() => {
        this.root
          .querySelector(
            '.aa-client-billing-setup'
          )
          ?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
      });
    }

    return;
  }

  if (selectWaveBusinessButton) {
    const businessId =
      selectWaveBusinessButton.dataset
        .aaSelectWaveBusiness || '';

    if (!businessId) return;

    selectWaveBusinessButton.disabled = true;
    selectWaveBusinessButton.textContent =
      'Connecting...';

    try {
      const result =
        await window.AAPlaybookService
          .setWaveBusiness({
            businessId
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to save Wave business.'
          )
        );
      }

      this.waveConnection =
        result.connection || null;
      this.waveConnectionError = '';

      this.render();

      this.showStatusMessage(
        'Wave business connected.'
      );
    } catch (error) {
      console.error(
        'Unable to save Wave business:',
        error
      );

      this.waveConnectionError =
        error?.message ||
        'Unable to save Wave business.';

      this.render();
    }

    return;
  }

  if (manageContractsButton) {
    this.editingContractClientId =
      manageContractsButton.dataset
        .aaManageContracts || null;

    this.render();

    requestAnimationFrame(() => {
      this.root
        .querySelector('.aa-client-contract-editor')
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
    });

    return;
  }

  if (cancelContractsButton) {
    this.editingContractClientId = null;
    this.render();
    return;
  }

  if (editContractRecordButton) {
    const contractId =
      editContractRecordButton.dataset
        .aaEditContractRecord;

    this.editingContractClientId =
      this.getActiveClient()?.id || null;

    this.render();

    requestAnimationFrame(() => {
      const record =
        this.root.querySelector(
          `[data-aa-contract-record="${contractId}"]`
        );

      record?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      record?.classList.add('is-contract-focus');

      window.setTimeout(() => {
        record?.classList.remove('is-contract-focus');
      }, 1800);
    });

    return;
  }

  if (archiveContractButton) {
    const contractId =
      archiveContractButton.dataset
        .aaArchiveContract;

    const confirmed =
      archiveContractButton.dataset
        .aaConfirmArchive === 'true';

    if (!confirmed) {
      archiveContractButton.dataset
        .aaConfirmArchive = 'true';
      archiveContractButton.textContent =
        'Confirm Archive';

      window.setTimeout(() => {
        if (
          archiveContractButton?.isConnected &&
          !archiveContractButton.disabled
        ) {
          archiveContractButton.dataset
            .aaConfirmArchive = 'false';
          archiveContractButton.textContent =
            'Archive';
        }
      }, 5000);

      return;
    }

    archiveContractButton.disabled = true;
    archiveContractButton.textContent =
      'Archiving...';

    try {
      const result =
        await window.AAPlaybookService
          .archiveContract({
            contractId
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to archive contract.'
          )
        );
      }

      await this.loadActiveClientContracts();
      this.render();
      this.showStatusMessage(
        'Contract archived.'
      );
    } catch (error) {
      console.error(
        'Unable to archive contract:',
        error
      );

      archiveContractButton.disabled = false;

      this.showStatusMessage(
        error?.message ||
          'Unable to archive contract.',
        'error'
      );
    }

    return;
  }

  if (deleteContractButton) {
    const contractId =
      deleteContractButton.dataset
        .aaDeleteContract;

    const confirmed =
      deleteContractButton.dataset
        .aaConfirmDelete === 'true';

    if (!confirmed) {
      deleteContractButton.dataset
        .aaConfirmDelete = 'true';
      deleteContractButton.textContent =
        'Confirm Permanent Delete';

      window.setTimeout(() => {
        if (
          deleteContractButton?.isConnected &&
          !deleteContractButton.disabled
        ) {
          deleteContractButton.dataset
            .aaConfirmDelete = 'false';
          deleteContractButton.textContent =
            'Delete Permanently';
        }
      }, 5000);

      return;
    }

    deleteContractButton.disabled = true;
    deleteContractButton.textContent =
      'Deleting...';

    try {
      const result =
        await window.AAPlaybookService
          .deleteContractPermanently({
            contractId
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to delete contract.'
          )
        );
      }

      await this.loadActiveClientContracts();
      this.render();
      this.showStatusMessage(
        'Contract permanently deleted.'
      );
    } catch (error) {
      console.error(
        'Unable to permanently delete contract:',
        error
      );

      deleteContractButton.disabled = false;

      this.showStatusMessage(
        error?.message ||
          'Unable to delete contract.',
        'error'
      );
    }

    return;
  }

  if (deleteContractDocumentButton) {
    const documentId =
      deleteContractDocumentButton.dataset
        .aaDeleteContractDocument;

    const confirmed =
      deleteContractDocumentButton.dataset
        .aaConfirmDelete === 'true';

    if (!confirmed) {
      deleteContractDocumentButton.dataset
        .aaConfirmDelete = 'true';
      deleteContractDocumentButton.textContent =
        'Confirm Delete';

      window.setTimeout(() => {
        if (
          deleteContractDocumentButton?.isConnected &&
          !deleteContractDocumentButton.disabled
        ) {
          deleteContractDocumentButton.dataset
            .aaConfirmDelete = 'false';
          deleteContractDocumentButton.textContent =
            'Delete';
        }
      }, 5000);

      return;
    }

    deleteContractDocumentButton.disabled = true;
    deleteContractDocumentButton.textContent =
      'Deleting...';

    try {
      const result =
        await window.AAPlaybookService
          .deleteContractDocumentPermanently({
            documentId
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to delete contract document.'
          )
        );
      }

      await this.loadActiveClientContracts();
      this.render();
      this.showStatusMessage(
        'Contract document permanently deleted.'
      );
    } catch (error) {
      console.error(
        'Unable to permanently delete contract document:',
        error
      );

      deleteContractDocumentButton.disabled = false;

      this.showStatusMessage(
        error?.message ||
          'Unable to delete contract document.',
        'error'
      );
    }

    return;
  }

  if (archiveContractDocumentButton) {
    const documentId =
      archiveContractDocumentButton.dataset
        .aaArchiveContractDocument;

    archiveContractDocumentButton.disabled = true;

    try {
      const result =
        await window.AAPlaybookService
          .archiveContractDocument({
            documentId
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to archive document.'
          )
        );
      }

      await this.loadActiveClientContracts();
      this.render();
      this.showStatusMessage(
        'Contract document archived.'
      );
    } catch (error) {
      console.error(
        'Unable to archive contract document:',
        error
      );

      archiveContractDocumentButton.disabled =
        false;

      this.showStatusMessage(
        error?.message ||
          'Unable to archive document.',
        'error'
      );
    }

    return;
  }

  if (manageBrandAssetsButton) {
    this.editingBrandClientId =
      manageBrandAssetsButton.dataset
        .aaManageBrandAssets || null;

    const brandFocus =
      manageBrandAssetsButton.dataset
        .aaBrandFocus || 'kit';

    this.editingBrandFocus =
      brandFocus;

    this.render();

    requestAnimationFrame(() => {
      const target =
        brandFocus === 'vendors'
          ? this.root.querySelector(
              '[data-aa-vendor-form]'
            )
          : this.root.querySelector(
              '[data-aa-brand-asset-form]'
            );

      target?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    return;
  }

  if (cancelBrandAssetsButton) {
    this.editingBrandClientId = null;
    this.editingBrandFocus = null;
    this.render();
    return;
  }

  if (archiveBrandAssetButton) {
    const assetId =
      archiveBrandAssetButton.dataset
        .aaArchiveBrandAsset;

    if (
      archiveBrandAssetButton.dataset
        .confirmRemove !== 'true'
    ) {
      archiveBrandAssetButton.dataset
        .confirmRemove = 'true';

      archiveBrandAssetButton.textContent =
        'Confirm Remove';

      archiveBrandAssetButton.classList.add(
        'is-confirming'
      );

      window.setTimeout(() => {
        if (
          archiveBrandAssetButton.isConnected &&
          archiveBrandAssetButton.dataset
            .confirmRemove === 'true'
        ) {
          delete archiveBrandAssetButton.dataset
            .confirmRemove;

          archiveBrandAssetButton.textContent =
            'Remove Asset';

          archiveBrandAssetButton.classList.remove(
            'is-confirming'
          );
        }
      }, 5000);

      return;
    }

    archiveBrandAssetButton.disabled = true;
    archiveBrandAssetButton.textContent =
      'Removing...';

    try {
      const result =
        await window.AAPlaybookService
          .archiveBrandAsset({
            assetId
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error('Unable to remove asset.')
        );
      }

      await this.loadActiveClientBrandWorkspace();
      this.render();
      this.showStatusMessage(
        'Brand asset removed.'
      );
    } catch (error) {
      console.error(
        'Unable to remove brand asset:',
        error
      );

      delete archiveBrandAssetButton.dataset
        .confirmRemove;

      archiveBrandAssetButton.disabled = false;
      archiveBrandAssetButton.textContent =
        'Remove Asset';

      archiveBrandAssetButton.classList.remove(
        'is-confirming'
      );

      this.showStatusMessage(
        error?.message ||
          'Unable to remove this brand asset.',
        'error'
      );
    }

    return;
  }

  if (toggleClientVendorButton) {
    const clientId =
      toggleClientVendorButton.dataset
        .aaVendorClientId ||
      this.activeClientId;

    const vendorName =
      String(
        toggleClientVendorButton.dataset
          .aaVendorName || ''
      ).trim();

    const vendorId =
      toggleClientVendorButton.dataset
        .aaVendorId || '';

    if (!clientId || !vendorName) {
      return;
    }

    const existingIndex =
      this.clientVendorBrands.findIndex(
        (vendor) =>
          String(vendor.vendorName || '')
            .trim()
            .toLowerCase() ===
          vendorName.toLowerCase()
      );

    const nextBrands =
      this.clientVendorBrands.map(
        (vendor, index) => ({
          vendorName:
            vendor.vendorName || '',
          accessStatus:
            vendor.accessStatus || 'unknown',
          displayOrder:
            Number(
              vendor.displayOrder ?? index
            )
        })
      );

    const removing =
      existingIndex >= 0;

    if (removing) {
      nextBrands.splice(
        existingIndex,
        1
      );
    } else {
      const libraryVendor =
        this.vendorLibrary.find(
          (vendor) =>
            String(vendor.id || '') ===
            String(vendorId || '')
        );

      nextBrands.push({
        vendorName,
        accessStatus:
          libraryVendor?.accessStatus ||
          'unknown',
        displayOrder:
          nextBrands.length
      });
    }

    toggleClientVendorButton.disabled =
      true;
    toggleClientVendorButton.classList.add(
      'is-saving'
    );

    try {
      const result =
        await window.AAPlaybookService
          .saveClientVendorBrands({
            clientId,
            brands: nextBrands
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to update brands.'
          )
        );
      }

      await this.loadActiveClientBrandWorkspace();
      this.render();
    } catch (error) {
      console.error(
        'Unable to update client brands:',
        error
      );

      toggleClientVendorButton.disabled =
        false;
      toggleClientVendorButton.classList.remove(
        'is-saving'
      );

      this.showStatusMessage(
        error?.message ||
          'Unable to update brands.',
        'error'
      );
    }

    return;
  }

  if (addLibraryVendorButton) {
    const form =
      addLibraryVendorButton.closest(
        '[data-aa-vendor-form]'
      );

    const select =
      form?.querySelector(
        '[data-aa-vendor-library-select]'
      );

    const vendorId =
      select?.value || '';

    const vendor =
      this.vendorLibrary.find(
        (item) =>
          String(item.id) ===
          String(vendorId)
      );

    const list =
      form?.querySelector(
        '[data-aa-vendor-row-list]'
      );

    if (!vendor || !list) {
      return;
    }

    const duplicate =
      [...list.querySelectorAll(
        '[data-aa-vendor-name]'
      )].some((input) =>
        String(input.value || '')
          .trim()
          .toLowerCase() ===
        String(vendor.vendorName || '')
          .trim()
          .toLowerCase()
      );

    if (duplicate) {
      return;
    }

    const index =
      list.querySelectorAll(
        '[data-aa-vendor-row]'
      ).length;

    list.insertAdjacentHTML(
      'beforeend',
      this.renderVendorEditorRow(
        {
          vendorId: vendor.id,
          vendorName: vendor.vendorName,
          accessStatus:
            vendor.accessStatus || 'unknown'
        },
        index
      )
    );

    select.value = '';

    return;
  }

  if (addCustomVendorButton) {
    const form =
      addCustomVendorButton.closest(
        '[data-aa-vendor-form]'
      );

    const list =
      form?.querySelector(
        '[data-aa-vendor-row-list]'
      );

    if (!list) return;

    const existingNew =
      [...list.querySelectorAll(
        '[data-aa-vendor-name]'
      )].find((input) =>
        !input.hasAttribute('readonly') &&
        !String(input.value || '').trim()
      );

    if (existingNew) {
      existingNew.focus();
      return;
    }

    const index =
      list.querySelectorAll(
        '[data-aa-vendor-row]'
      ).length;

    list.insertAdjacentHTML(
      'beforeend',
      this.renderVendorEditorRow(
        {
          vendorName: '',
          accessStatus: 'unknown',
          isNew: true
        },
        index
      )
    );

    list
      .querySelector(
        '[data-aa-vendor-row]:last-child [data-aa-vendor-name]'
      )
      ?.focus();

    return;
  }

  if (removeVendorRowButton) {
    removeVendorRowButton
      .closest('[data-aa-vendor-row]')
      ?.remove();

    return;
  }

  if (reviewPlaybookButton) {
  const playbookId =
    reviewPlaybookButton.dataset.aaReviewPlaybook;

  const clientId =
    this.activeClientId;

  if (!playbookId || !clientId) {
    return;
  }

  window.location.href =
  `/pages/workspace-current-playbook?playbook=${encodeURIComponent(playbookId)}&aa_admin_client=${encodeURIComponent(clientId)}&aa_review=1`;

  return;
}

  if (addCatalogButton) {
  this.resetCatalogDeletion();
  this.showArchivedCatalogs = false;
  this.addingCatalogClientId =
    addCatalogButton.dataset.aaAddCatalog;

  this.editingCatalogId = null;

  this.render();
  return;
}

if (editCatalogButton) {
  this.editingCatalogId =
    editCatalogButton.dataset.aaEditCatalog;

  this.addingCatalogClientId = null;

  this.render();

  requestAnimationFrame(() => {
    const catalogForm =
      this.root.querySelector(
        '[data-aa-catalog-form]'
      );

    catalogForm?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    catalogForm
      ?.querySelector(
        '[data-aa-catalog-field="catalogMonth"]'
      )
      ?.focus();
  });

  return;
}

if (cancelCatalogButton) {
  this.addingCatalogClientId = null;
  this.editingCatalogId = null;

  this.render();
  return;
}

      if (restoreClientButton) {
        const clientId =
          restoreClientButton.dataset.aaRestoreClient;

        restoreClientButton.disabled = true;
        restoreClientButton.textContent = 'Restoring...';

        try {
          await window.AASupabaseClient.updateClient({
            clientId,
            updates: {
              active_status: 'Active'
            }
          });

          await this.loadClients();

          this.activeClientId = clientId;
          this.editingClientId = null;
          this.render();

          this.showStatusMessage('Client restored.');
        } catch (error) {
          console.error('Error restoring client:', error);

          alert(
            `Client restore failed: ${
              error?.message || 'Unable to restore client.'
            }`
          );

          restoreClientButton.disabled = false;
          restoreClientButton.textContent = 'Restore';
        }

        return;
      }

      if (deleteTemplateButton) {
    const assignmentId =
      deleteTemplateButton.dataset.aaDeleteTemplateAssignment;

    const confirmed =
      deleteTemplateButton.dataset.aaDeleteConfirmed === 'true';

    if (!confirmed) {
      deleteTemplateButton.dataset.aaDeleteConfirmed = 'true';
      deleteTemplateButton.textContent = 'Confirm Delete';
      return;
    }

    deleteTemplateButton.disabled = true;
    deleteTemplateButton.textContent = 'Deleting...';

    try {
      // Resolve the owning client before deletion removes this assignment.
      const client = this.clients.find(item =>
        this.getAssignedTemplates(item).some(assignment =>
          String(assignment.id) === String(assignmentId)
        )
      );

      await window.AASupabaseClient.deleteClientTemplateAssignment({
        assignmentId
      });

      if (!client) {
        this.showStatusMessage('Deleted. Refresh to verify assignment list.');
        return;
      }

      try {
        const assignments = await window.AASupabaseClient
          .getClientTemplateAssignments({ clientId: client.id });
        client.assigned_templates = Array.isArray(assignments) ? assignments : [];
      } catch (refreshError) {
        console.warn('Assignment deleted; unable to refresh its display:', refreshError);
        this.showStatusMessage('Deleted, but the display could not refresh. Please reload.', 'error');
        return;
      }

      this.render();
      this.showStatusMessage(
        'Template assignment permanently deleted.'
      );
    } catch (error) {
      console.error(
        'Error deleting template assignment:',
        error
      );

      alert(
        `Supabase request failed: ${
          error?.message ||
          'Unable to delete template assignment.'
        }`
      );

      deleteTemplateButton.disabled = false;
      deleteTemplateButton.textContent = 'Delete';
      deleteTemplateButton.dataset.aaDeleteConfirmed = 'false';
    }

    return;
  }

  if (catalogDeleteModeButton) {
  if (!this.catalogDeleteAdmin) return;
  this.catalogDeleteMode = !this.catalogDeleteMode;
  this.catalogDeleteSelected.clear();
  this.catalogDeletePreview = null;
  this.catalogDeleteYear = 'all';
  this.render();
  return;
}

if (catalogDeleteSelect) {
  if (!this.catalogDeleteMode || !this.catalogDeleteAdmin) return;
  const id = String(catalogDeleteSelect.dataset.aaCatalogDeleteSelect);
  if (catalogDeleteSelect.checked) this.catalogDeleteSelected.add(id);
  else this.catalogDeleteSelected.delete(id);
  this.updateCatalogDeleteSelectionDisplay();
  return;
}

if (catalogDeleteSelectYear) {
  if (!this.catalogDeleteAdmin || !this.catalogDeleteMode) return;
  const client = this.getActiveClient();
  const records = this.showArchivedCatalogs
    ? (this.archivedCatalogsClientId === client?.id ? this.archivedCatalogs : [])
    : this.getCatalogRecords(client);
  for (const catalog of records) {
    if (this.catalogDeleteYear === 'all' ||
        String(catalog.catalog_month || '').slice(0, 4) === this.catalogDeleteYear) {
      this.catalogDeleteSelected.add(String(catalog.id));
    }
  }
  this.updateCatalogDeleteSelectionDisplay();
  return;
}

if (catalogDeleteReview) {
  if (!this.catalogDeleteAdmin || !this.catalogDeleteSelected.size) return;
  const client = this.getActiveClient();
  catalogDeleteReview.disabled = true;
  catalogDeleteReview.textContent = 'Reviewing...';
  try {
    const preview = await window.AASupabaseClient.previewCatalogDeletion({
      clientId: client.id,
      catalogIds: [...this.catalogDeleteSelected]
    });
    this.catalogDeletePreview = { ...preview, clientId: client.id };
    this.render();
  } catch (error) {
    console.error('Catalog deletion preview failed:', error);
    this.showStatusMessage(error?.message || 'Unable to review deletion.', 'error');
    catalogDeleteReview.disabled = false;
    this.updateCatalogDeleteSelectionDisplay();
  }
  return;
}

if (catalogDeleteCancel) {
  this.catalogDeletePreview = null;
  this.render();
  return;
}

if (catalogDeleteConfirm) {
  const client = this.getActiveClient();
  const preview = this.catalogDeletePreview;
  const phrase = this.root.querySelector('[data-aa-catalog-delete-phrase]')?.value.trim();
  if (!this.catalogDeleteAdmin || !preview ||
      !client || client.id !== preview.clientId || phrase !== 'DELETE') return;
  const ids = (preview.catalogs || []).map(catalog => catalog.id);
  catalogDeleteConfirm.disabled = true;
  catalogDeleteConfirm.textContent = 'Deleting...';
  let deletionSucceeded = false;
  try {
    // Stop if connected records changed since the user reviewed the impact.
    const latest = await window.AASupabaseClient.previewCatalogDeletion({
      clientId: client.id,
      catalogIds: ids
    });
    if (latest.count !== preview.count ||
      latest.coOpReports !== preview.coOpReports ||
      latest.generationBatches !== preview.generationBatches ||
      latest.linkedTasks !== preview.linkedTasks ||
      JSON.stringify(latest.catalogs) !== JSON.stringify(preview.catalogs)) {
      this.catalogDeletePreview = null;
      this.render();
      this.showStatusMessage('Catalog records changed. Review deletion again.', 'error');
      return;
    }
    const result = await window.AASupabaseClient.permanentlyDeleteCatalogs({
      clientId: client.id,
      catalogIds: ids
    });
    deletionSucceeded = true;
    const [active, archived] = await Promise.all([
      window.AASupabaseClient.getCatalogRecords({ clientId: client.id }),
      window.AASupabaseClient.getCatalogRecords({ clientId: client.id, status: 'archived' })
    ]);
    client.catalog_records = active;
    this.archivedCatalogs = archived;
    this.archivedCatalogsClientId = client.id;
    this.resetCatalogDeletion();
    await this.loadActiveClientCoopReports();
    this.render();
    if (result.cleanupFailures?.length) {
      console.warn('Storage files requiring cleanup:', result.cleanupFailures);
      this.showStatusMessage(
        result.deletedCount + ' catalogs deleted. ' + result.cleanupFailures.length +
        ' stored files still need cleanup.', 'error');
    } else {
      this.showStatusMessage(result.deletedCount + ' catalogs permanently deleted.');
    }
  } catch (error) {
    if (deletionSucceeded) {
      // The database deletion committed; a refresh error must not be
      // misreported as a failed deletion or offer a second delete.
      console.error('Catalogs deleted; refresh failed:', error);
      this.resetCatalogDeletion();
      this.render();
      this.showStatusMessage(
        'Catalogs were deleted, but the history could not refresh. Reload the page.', 'error'
      );
    } else {
      console.error('Permanent catalog deletion failed:', error);
      this.showStatusMessage(error?.message || 'Catalog deletion failed.', 'error');
      catalogDeleteConfirm.disabled = false;
      catalogDeleteConfirm.textContent = 'Permanently Delete';
    }
  }
  return;
}

if (archivedCatalogsToggle) {
  this.resetCatalogDeletion();
  const clientId = archivedCatalogsToggle.dataset.aaToggleArchivedCatalogs;
  if (this.showArchivedCatalogs && this.archivedCatalogsClientId === clientId) {
    this.showArchivedCatalogs = false;
    this.render();
    return;
  }
  try {
    this.archivedCatalogs = await window.AASupabaseClient.getCatalogRecords({ clientId, status: 'archived' });
    this.archivedCatalogsClientId = clientId;
    this.showArchivedCatalogs = true;
    this.render();
  } catch (error) {
    console.error('Archived catalog lookup failed:', error);
    this.showStatusMessage('Unable to load archived catalogs.', 'error');
  }
  return;
}

if (restoreCatalogButton) {
  const id = restoreCatalogButton.dataset.aaRestoreCatalog;
  const client = this.getActiveClient();
  if (!client) return;
  restoreCatalogButton.disabled = true;
  try {
    await window.AASupabaseClient.updateCatalogRecord({ id, updates: { status: 'active' } });
    const [active, archived] = await Promise.all([
      window.AASupabaseClient.getCatalogRecords({ clientId: client.id }),
      window.AASupabaseClient.getCatalogRecords({ clientId: client.id, status: 'archived' })
    ]);
    client.catalog_records = active;
    this.archivedCatalogs = archived;
    this.archivedCatalogsClientId = client.id;
    this.render();
    this.showStatusMessage('Catalog restored.');
  } catch (error) {
    console.error('Catalog restore failed:', error);
    this.showStatusMessage('Unable to restore catalog. Please refresh and verify.', 'error');
    restoreCatalogButton.disabled = false;
  }
  return;
}

if (archiveCatalogButton) {
  const catalogId =
    archiveCatalogButton.dataset.aaArchiveCatalog;

  const confirmed =
    archiveCatalogButton.dataset.aaArchiveConfirmed === 'true';

  if (!confirmed) {
    archiveCatalogButton.dataset.aaArchiveConfirmed = 'true';
    archiveCatalogButton.textContent = 'Confirm Archive';
    return;
  }

  archiveCatalogButton.disabled = true;
  archiveCatalogButton.textContent = 'Archiving...';

  try {
    // Find the owner before changing the archived record's visibility.
    const client = this.clients.find(item =>
      this.getCatalogRecords(item).some(catalog =>
        String(catalog.id) === String(catalogId)
      )
    );

    await window.AASupabaseClient.archiveCatalogRecord({
      id: catalogId
    });

    if (!client) {
      this.showStatusMessage('Catalog archived. Refresh to verify catalog history.');
      return;
    }

    try {
      const records = await window.AASupabaseClient.getCatalogRecords({
        clientId: client.id
      });
      client.catalog_records = Array.isArray(records) ? records : [];
    } catch (refreshError) {
      console.warn('Catalog archived but catalog history could not refresh:', refreshError);
      this.showStatusMessage('Catalog archived, but the display could not refresh. Please reload.', 'error');
      return;
    }

    this.render();
    this.showStatusMessage(
      'Catalog archived. It is hidden from active Catalog History and future Co-op report selections.'
    );
  } catch (error) {
    console.error('Error archiving catalog:', error);

    alert(
      `Supabase request failed: ${
        error?.message || 'Unable to archive catalog.'
      }`
    );

    archiveCatalogButton.disabled = false;
    archiveCatalogButton.textContent = 'Archive';
    archiveCatalogButton.dataset.aaArchiveConfirmed = 'false';
  }

  return;
}

  if (archiveTemplateButton) {
        const assignmentId =
          archiveTemplateButton.dataset.aaArchiveTemplateAssignment;

        archiveTemplateButton.disabled = true;
        archiveTemplateButton.textContent = 'Archiving...';

        try {
          await window.AASupabaseClient.updateClientTemplateAssignmentStatus({
            assignmentId,
            status: 'archived'
          });

          // Refresh only this client's assignment list, not the whole directory.
          const client = this.clients.find(item =>
            this.getAssignedTemplates(item).some(assignment =>
              String(assignment.id) === String(assignmentId)
            )
          );
          if (client) {
            try {
              const assignments = await window.AASupabaseClient
                .getClientTemplateAssignments({ clientId: client.id });
              client.assigned_templates = Array.isArray(assignments)
                ? assignments
                : [];
            } catch (refreshError) {
              console.warn('Assignment archived; unable to refresh its display:', refreshError);
              // Keep existing data rather than claiming the display is up to date.
              this.showStatusMessage('Archived, but the display could not refresh. Please reload.', 'error');
              return;
            }
          } else {
            this.showStatusMessage('Archived. Refresh to verify assignment list.');
            return;
          }
          this.render();
          this.showStatusMessage('Template assignment archived.');
        } catch (error) {
          console.error('Error archiving template assignment:', error);

          alert(
            `Supabase request failed: ${
              error?.message || 'Unable to archive template assignment.'
            }`
          );
        }

        return;
      }

      if (restoreTemplateButton) {
        const assignmentId =
          restoreTemplateButton.dataset.aaRestoreTemplateAssignment;

        restoreTemplateButton.disabled = true;
        restoreTemplateButton.textContent = 'Restoring...';

        try {
          await window.AASupabaseClient.updateClientTemplateAssignmentStatus({
            assignmentId,
            status: 'assigned'
          });

          const client = this.clients.find(item =>
            this.getAssignedTemplates(item).some(assignment =>
              String(assignment.id) === String(assignmentId)
            )
          );
          if (!client) {
            this.showStatusMessage('Restored. Refresh to verify assignment list.');
            return;
          }
          try {
            const assignments = await window.AASupabaseClient
              .getClientTemplateAssignments({ clientId: client.id });
            client.assigned_templates = Array.isArray(assignments)
              ? assignments
              : [];
          } catch (refreshError) {
            console.warn('Assignment restored; unable to refresh its display:', refreshError);
            this.showStatusMessage('Restored, but the display could not refresh. Please reload.', 'error');
            return;
          }
          this.render();
          this.showStatusMessage('Template assignment restored.');
        } catch (error) {
          console.error('Error restoring template assignment:', error);

          alert(
            `Supabase request failed: ${
              error?.message || 'Unable to restore template assignment.'
            }`
          );
        }

        return;
      }

      if (editButton) {
        this.editingClientId =
          editButton.dataset.aaEditClient;

        this.render();
        return;
      }

      if (cancelButton) {
        this.editingClientId = null;
        this.render();
        return;
      }

      if (viewWorkspaceButton) {
        const clientId =
          viewWorkspaceButton.dataset.aaViewClientWorkspace;

        if (!clientId) return;

        window.location.href =
          `/pages/workspace-dashboard?aa_admin_client=${encodeURIComponent(clientId)}`;

        return;
      }

      if (manageRemindersButton) {
  this.activeClientTab = 'account';
  this.activeAccountSection = 'reminders';
  this.rememberActiveClientInUrl();
  this.render();
  this.root.querySelector('[data-aa-playbook-reminder-due]')?.focus();
  return;
}

if (archiveButton) {
  const clientId = archiveButton.dataset.aaArchiveClient;

  archiveButton.disabled = true;
  archiveButton.textContent = 'Archiving Client...';

  try {
    await window.AASupabaseClient.archiveClient({
      clientId
    });

    this.editingClientId = null;
    this.activeClientId = null;

    await this.loadClients();

    this.activeClientId = this.clients[0]?.id || null;
    this.render();

    this.showStatusMessage('Client archived.');
  } catch (error) {
    console.error('Error archiving client:', error);

    alert(
      `Supabase request failed: ${
        error?.message || 'Unable to archive client.'
      }`
    );

    archiveButton.disabled = false;
    archiveButton.textContent = 'Archive Client';
  }
}
    });

   this.root.addEventListener('submit', async (event) => {
  const reminderForm = event.target.closest('[data-aa-client-reminder-form]');
  if (reminderForm) {
    event.preventDefault();
    const clientId = reminderForm.dataset.aaClientReminderForm;
    const values = Object.fromEntries(new FormData(reminderForm).entries());
    const day = Number(values.monthly_due_day);
    if (!Number.isInteger(day) || day < 1 || day > 31) {
      this.showStatusMessage('Enter a valid day of the month.', 'error');
      return;
    }
    const button = reminderForm.querySelector('[type="submit"]');
    if (button) { button.disabled = true; button.textContent = 'Saving...'; }
    try {
      const existing = (await window.AASupabaseClient.getClientConfiguration({ clientId })) || {};
      const reminderData = { monthly_due_day: String(day), reminder_schedule: values.reminder_schedule, reminder_email_template: values.reminder_email_template };
      await window.AASupabaseClient.saveClientConfiguration({ clientId, configuration: { ...existing, ...reminderData } });
      const client = this.clients.find(item => String(item.id) === String(clientId));
      if (client) Object.assign(client, reminderData);
      this.render();
      this.showStatusMessage('Playbook reminder settings saved.');
    } catch (error) {
      console.error('Reminder settings save failed:', error);
      this.showStatusMessage(error?.message || 'Could not save reminder settings.', 'error');
      if (button) { button.disabled = false; button.textContent = 'Save Reminder Settings'; }
    }
    return;
  }
  const identityForm = event.target.closest('[data-aa-marketing-identity-form]');
  if (identityForm) {
    event.preventDefault();
    const clientId = identityForm.dataset.aaMarketingIdentityForm;
    const button = identityForm.querySelector('[type="submit"]');
    const profile = {};
    identityForm.querySelectorAll('[data-aa-marketing-identity-field]').forEach(input => {
      profile[input.dataset.aaMarketingIdentityField] = input.value.trim();
    });
    if (button) { button.disabled = true; button.textContent = 'Saving...'; }
    try {
      const current = (await window.AASupabaseClient.getClientConfiguration({ clientId })) || {};
      await window.AASupabaseClient.saveClientConfiguration({
        clientId,
        configuration: { ...current, marketing_identity: profile }
      });
      const localClient = this.clients.find(item => String(item.id) === String(clientId));
      if (localClient) localClient.marketing_identity = profile;
      this.showStatusMessage('Marketing Identity & Voice saved.');
    } catch (error) {
      console.error('Unable to save marketing identity:', error);
      this.showStatusMessage(error?.message || 'Could not save marketing identity.', 'error');
    } finally {
      if (button) { button.disabled = false; button.textContent = 'Save Marketing Identity'; }
    }
    return;
  }
  const quickVendorForm =
    event.target.closest(
      '[data-aa-quick-vendor-form]'
    );

  if (quickVendorForm) {
    event.preventDefault();

    const clientId =
      quickVendorForm.dataset
        .aaQuickVendorForm ||
      this.activeClientId;

    const vendorName =
      String(
        quickVendorForm.querySelector(
          '[data-aa-quick-vendor-name]'
        )?.value || ''
      ).trim();

    if (!clientId || !vendorName) {
      return;
    }

    const duplicate =
      this.vendorLibrary.some(
        (vendor) =>
          String(vendor.vendorName || '')
            .trim()
            .toLowerCase() ===
          vendorName.toLowerCase()
      );

    if (duplicate) {
      this.showStatusMessage(
        'That brand is already in the Vendor Library. Select it above instead.',
        'error'
      );
      return;
    }

    const saveButton =
      quickVendorForm.querySelector(
        '[data-aa-quick-vendor-save]'
      );

    if (saveButton) {
      saveButton.disabled = true;
      saveButton.textContent =
        'Adding...';
    }

    const nextBrands =
      this.clientVendorBrands.map(
        (vendor, index) => ({
          vendorName:
            vendor.vendorName || '',
          accessStatus:
            vendor.accessStatus || 'unknown',
          displayOrder:
            Number(
              vendor.displayOrder ?? index
            )
        })
      );

    nextBrands.push({
      vendorName,
      accessStatus: 'unknown',
      displayOrder:
        nextBrands.length
    });

    try {
      const result =
        await window.AAPlaybookService
          .saveClientVendorBrands({
            clientId,
            brands: nextBrands
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to add brand.'
          )
        );
      }

      await this.loadActiveClientBrandWorkspace();
      this.render();

      this.showStatusMessage(
        'Brand added.'
      );
    } catch (error) {
      console.error(
        'Unable to add brand:',
        error
      );

      if (saveButton) {
        saveButton.disabled = false;
        saveButton.textContent =
          'Add Brand';
      }

      this.showStatusMessage(
        error?.message ||
          'Unable to add brand.',
        'error'
      );
    }

    return;
  }

  const coopReportForm =
    event.target.closest(
      '[data-aa-coop-report-form]'
    );

  if (coopReportForm) {
    event.preventDefault();

    await this.saveCoopReportForm(
      coopReportForm
    );

    return;
  }

  const contractCreateForm =
    event.target.closest('[data-aa-contract-create-form]');

  if (contractCreateForm) {
    event.preventDefault();

    const clientId =
      contractCreateForm.dataset.aaContractCreateForm;

    const title =
      contractCreateForm.querySelector('[data-aa-contract-title]')
        ?.value.trim() || '';

    if (!clientId || !title) return;

    const validationMessage =
      this.validateContractForm(
        contractCreateForm
      );

    if (validationMessage) {
      this.showContractFormMessage(
        contractCreateForm,
        validationMessage,
        'error'
      );
      return;
    }

    this.clearContractFormMessage(
      contractCreateForm
    );

    const saveButton =
      contractCreateForm.querySelector('[data-aa-save-contract]');

    if (saveButton) {
      saveButton.disabled = true;
      saveButton.textContent = 'Adding Contract...';
    }

    try {
      const clientVisible =
        Boolean(
          contractCreateForm.querySelector(
            '[data-aa-contract-client-visible]'
          )?.checked
        );

      const result =
        await window.AAPlaybookService.createContract({
          clientId,
          title,
          type:
            contractCreateForm.querySelector('[data-aa-contract-type]')
              ?.value.trim() || 'Service Agreement',
          version:
            contractCreateForm.querySelector('[data-aa-contract-version]')
              ?.value.trim() || '',
          status:
            contractCreateForm.querySelector('[data-aa-contract-status]')
              ?.value || 'draft',
          effectiveDate:
            contractCreateForm.querySelector('[data-aa-contract-effective-date]')
              ?.value || null,
          renewalDate:
            contractCreateForm.querySelector('[data-aa-contract-renewal-date]')
              ?.value || null,
          expirationDate:
            contractCreateForm.querySelector('[data-aa-contract-expiration-date]')
              ?.value || null,
          clientVisible,
          internalNotes:
            contractCreateForm.querySelector('[data-aa-contract-internal-notes]')
              ?.value.trim() || ''
        });

      if (!result?.success) {
        throw result?.error || new Error('Unable to create contract.');
      }

      const file =
        contractCreateForm.querySelector('[data-aa-contract-file]')
          ?.files?.[0] || null;

      if (file) {
        const upload =
          await window.AAPlaybookService.uploadContractDocument({
            clientId,
            contractId: result.contractId,
            file,
            documentType: 'agreement',
            title,
            clientVisible
          });

        if (!upload?.success) {
          throw upload?.error ||
            new Error('Contract created, but the PDF upload failed.');
        }
      }

      await this.loadActiveClientContracts();
      this.render();
      this.showStatusMessage('Contract added.');
    } catch (error) {
      console.error('Unable to create contract:', error);
      this.showContractFormMessage(
        contractCreateForm,
        error?.message || 'Unable to create contract.',
        'error'
      );

      if (saveButton) {
        saveButton.disabled = false;
        saveButton.textContent = 'Add Contract';
      }
    }

    return;
  }

  const contractUpdateForm =
    event.target.closest('[data-aa-contract-update-form]');

  if (contractUpdateForm) {
    event.preventDefault();

    const contractId =
      contractUpdateForm.dataset.aaContractUpdateForm;

    const validationMessage =
      this.validateContractForm(
        contractUpdateForm
      );

    if (validationMessage) {
      this.showContractFormMessage(
        contractUpdateForm,
        validationMessage,
        'error'
      );
      return;
    }

    this.clearContractFormMessage(
      contractUpdateForm
    );

    const saveButton =
      contractUpdateForm.querySelector('[data-aa-update-contract]');

    if (saveButton) {
      saveButton.disabled = true;
      saveButton.textContent = 'Saving Contract...';
    }

    try {
      const existingContract =
        this.clientContracts.find(
          (contract) =>
            String(contract.id) ===
            String(contractId)
        ) || null;

      const nextStatus =
        contractUpdateForm.querySelector(
          '[data-aa-contract-status]'
        )?.value || 'draft';

      const result =
        await window.AAPlaybookService.updateContract({
          contractId,
          title:
            contractUpdateForm.querySelector('[data-aa-contract-title]')
              ?.value.trim() || '',
          type:
            contractUpdateForm.querySelector('[data-aa-contract-type]')
              ?.value.trim() || 'Service Agreement',
          version:
            contractUpdateForm.querySelector('[data-aa-contract-version]')
              ?.value.trim() || '',
          status: nextStatus,
          sentForSignatureAt:
            nextStatus === 'sent' &&
            existingContract?.status !== 'sent'
              ? new Date().toISOString()
              : undefined,
          signedAt:
            nextStatus === 'signed' &&
            existingContract?.status !== 'signed'
              ? new Date().toISOString()
              : undefined,
          effectiveDate:
            contractUpdateForm.querySelector('[data-aa-contract-effective-date]')
              ?.value || null,
          renewalDate:
            contractUpdateForm.querySelector('[data-aa-contract-renewal-date]')
              ?.value || null,
          expirationDate:
            contractUpdateForm.querySelector('[data-aa-contract-expiration-date]')
              ?.value || null,
          clientVisible:
            Boolean(
              contractUpdateForm.querySelector(
                '[data-aa-contract-client-visible]'
              )?.checked
            ),
          internalNotes:
            contractUpdateForm.querySelector('[data-aa-contract-internal-notes]')
              ?.value.trim() || ''
        });

      if (!result?.success) {
        throw result?.error || new Error('Unable to update contract.');
      }

      await this.loadActiveClientContracts();
      this.render();
      this.showStatusMessage('Contract saved.');
    } catch (error) {
      console.error('Unable to update contract:', error);
      this.showContractFormMessage(
        contractUpdateForm,
        error?.message || 'Unable to update contract.',
        'error'
      );

      if (saveButton) {
        saveButton.disabled = false;
        saveButton.textContent = 'Save Contract';
      }
    }

    return;
  }

  const contractDocumentForm =
    event.target.closest('[data-aa-contract-document-form]');

  if (contractDocumentForm) {
    event.preventDefault();

    const contractId =
      contractDocumentForm.dataset.aaContractDocumentForm;

    const clientId =
      contractDocumentForm.dataset.aaContractDocumentClientId;

    const file =
      contractDocumentForm.querySelector('[data-aa-contract-document-file]')
        ?.files?.[0] || null;

    if (!file) {
      this.showContractFormMessage(
        contractDocumentForm,
        'Choose a PDF to upload.',
        'error'
      );
      return;
    }

    this.clearContractFormMessage(
      contractDocumentForm
    );

    const uploadButton =
      contractDocumentForm.querySelector(
        '[data-aa-upload-contract-document]'
      );

    if (uploadButton) {
      uploadButton.disabled = true;
      uploadButton.textContent = 'Uploading...';
    }

    try {
      const result =
        await window.AAPlaybookService.uploadContractDocument({
          clientId,
          contractId,
          file,
          documentType:
            contractDocumentForm.querySelector(
              '[data-aa-contract-document-type]'
            )?.value || 'agreement',
          title:
            contractDocumentForm.querySelector(
              '[data-aa-contract-document-title]'
            )?.value.trim() || file.name,
          clientVisible:
            Boolean(
              contractDocumentForm.querySelector(
                '[data-aa-contract-document-client-visible]'
              )?.checked
            )
        });

      if (!result?.success) {
        throw result?.error ||
          new Error('Unable to upload contract document.');
      }

      await this.loadActiveClientContracts();
      this.render();
      this.showStatusMessage('Contract document added.');
    } catch (error) {
      console.error('Unable to upload contract document:', error);
      this.showContractFormMessage(
        contractDocumentForm,
        error?.message || 'Unable to upload contract document.',
        'error'
      );

      if (uploadButton) {
        uploadButton.disabled = false;
        uploadButton.textContent = 'Add Document';
      }
    }

    return;
  }

  const brandAssetForm =
    event.target.closest(
      '[data-aa-brand-asset-form]'
    );

  if (brandAssetForm) {
    event.preventDefault();

    const clientId =
      brandAssetForm.dataset
        .aaBrandAssetForm;

    const type =
      brandAssetForm.querySelector(
        '[data-aa-brand-asset-type]'
      )?.value || 'logo';

    const title =
      brandAssetForm.querySelector(
        '[data-aa-brand-asset-title]'
      )?.value.trim() || '';

    const value =
      brandAssetForm.querySelector(
        '[data-aa-brand-asset-value]'
      )?.value.trim() || '';

    const description =
      brandAssetForm.querySelector(
        '[data-aa-brand-asset-description]'
      )?.value.trim() || '';

    const file =
      brandAssetForm.querySelector(
        '[data-aa-brand-asset-file]'
      )?.files?.[0] || null;

    if (!clientId || !title) {
      return;
    }

    const fileRequired =
      ['logo','store_photo','team_photo']
        .includes(type);

    if (fileRequired && !file) {
      alert('Choose a file for this asset.');
      return;
    }

    if (
      ['brand_color','font'].includes(type) &&
      !value
    ) {
      alert('Enter the color or font value.');
      return;
    }

    const saveButton =
      brandAssetForm.querySelector(
        '[data-aa-save-brand-asset]'
      );

    if (saveButton) {
      saveButton.disabled = true;
      saveButton.textContent = 'Saving...';
    }

    try {
      let upload = {
        success: true,
        path: '',
        fileName: ''
      };

      if (file) {
        upload =
          await window.AAPlaybookService
            .uploadBrandAssetFile({
              clientId,
              file
            });

        if (!upload?.success) {
          throw (
            upload?.error ||
            new Error('Unable to upload file.')
          );
        }
      }

      const result =
        await window.AAPlaybookService
          .createBrandAsset({
            clientId,
            type,
            title,
            fileName: upload.fileName,
            storagePath: upload.path,
            value,
            description,
            displayOrder:
              this.clientBrandAssets.length
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error('Unable to save brand asset.')
        );
      }

      await this.loadActiveClientBrandWorkspace();

      this.render();
      this.showStatusMessage('Brand asset added.');
    } catch (error) {
      console.error('Unable to save brand asset:', error);
      alert(
        error?.message ||
        'Unable to save brand asset.'
      );

      if (saveButton) {
        saveButton.disabled = false;
        saveButton.textContent = 'Add Asset';
      }
    }

    return;
  }

  const vendorForm =
    event.target.closest(
      '[data-aa-vendor-form]'
    );

  if (vendorForm) {
    event.preventDefault();

    const clientId =
      vendorForm.dataset
        .aaVendorForm;

    const brands = [
      ...vendorForm.querySelectorAll(
        '[data-aa-vendor-row]'
      )
    ].map((row, index) => ({
      vendorName:
        row.querySelector(
          '[data-aa-vendor-name]'
        )?.value.trim() || '',
      accessStatus:
        row.querySelector(
          '[data-aa-vendor-status]'
        )?.value || 'unknown',
      displayOrder:
        Number(
          row.querySelector(
            '[data-aa-vendor-display-order]'
          )?.value ?? index
        )
    })).filter((item) => item.vendorName);

    const saveButton =
      vendorForm.querySelector(
        '[data-aa-save-vendors]'
      );

    if (saveButton) {
      saveButton.disabled = true;
      saveButton.textContent = 'Saving...';
    }

    try {
      const result =
        await window.AAPlaybookService
          .saveClientVendorBrands({
            clientId,
            brands
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error('Unable to save brands.')
        );
      }

      await this.loadActiveClientBrandWorkspace();

      this.render();
      this.showStatusMessage('Brands and vendor access saved.');
    } catch (error) {
      console.error('Unable to save vendor brands:', error);
      alert(
        error?.message ||
        'Unable to save brands.'
      );

      if (saveButton) {
        saveButton.disabled = false;
        saveButton.textContent = 'Save Brands & Access';
      }
    }

    return;
  }

  const accessForm =
    event.target.closest(
      '[data-aa-access-form]'
    );

  if (accessForm) {
    event.preventDefault();

    const clientId =
      accessForm.dataset
        .aaAccessForm;

    if (
      !clientId ||
      !window.AAPlaybookService
        ?.saveClientAccessRequirements
    ) {
      return;
    }

    const now =
      new Date().toISOString();

    const access = [
      ...accessForm.querySelectorAll(
        '[data-aa-access-row]'
      )
    ]
      .filter((row) =>
        row.querySelector(
          '[data-aa-access-required]'
        )?.checked
      )
      .map((row, index) => {
        const platformName =
          (
            row.querySelector(
              '[data-aa-access-platform-name]'
            )?.value ||
            row.querySelector(
              '[data-aa-access-platform-static-name]'
            )?.value ||
            ''
          ).trim();

        const status =
          row.querySelector(
            '[data-aa-access-status]'
          )?.value ||
          'not_requested';

        let requestedAt =
          row.querySelector(
            '[data-aa-access-requested-at]'
          )?.value || '';

        let providedAt =
          row.querySelector(
            '[data-aa-access-provided-at]'
          )?.value || '';

        let verifiedAt =
          row.querySelector(
            '[data-aa-access-verified-at]'
          )?.value || '';

        if (
          !requestedAt &&
          [
            'requested',
            'waiting_on_client',
            'provided',
            'verified',
            'problem'
          ].includes(status)
        ) {
          requestedAt = now;
        }

        if (
          !providedAt &&
          ['provided', 'verified']
            .includes(status)
        ) {
          providedAt = now;
        }

        if (
          !verifiedAt &&
          status === 'verified'
        ) {
          verifiedAt = now;
        }

        return {
          platformId:
            row.querySelector(
              '[data-aa-access-platform-id]'
            )?.value || '',
          platformName,
          isRequired: true,
          accessMethod:
            row.querySelector(
              '[data-aa-access-method]'
            )?.value || 'invite',
          loginEmail:
            row.querySelector(
              '[data-aa-access-login-email]'
            )?.value.trim() || '',
          loginUsername:
            row.querySelector(
              '[data-aa-access-login-username]'
            )?.value.trim() || '',
          clientInstructions:
            row.querySelector(
              '[data-aa-access-client-instructions]'
            )?.value.trim() || '',
          status,
          requestedAt,
          providedAt,
          verifiedAt,
          mfaStatus:
            row.querySelector(
              '[data-aa-access-mfa-status]'
            )?.value || 'unknown',
          mfaOwner: '',
          internalNotes:
            row.querySelector(
              '[data-aa-access-internal-notes]'
            )?.value.trim() || '',
          vaultReference:
            row.querySelector(
              '[data-aa-access-vault-reference]'
            )?.value.trim() || '',
          displayOrder:
            Number(
              row.querySelector(
                '[data-aa-access-display-order]'
              )?.value ?? index
            )
        };
      });

    if (
      access.some(
        (item) => !item.platformName
      )
    ) {
      alert(
        'Every required access item needs a platform name.'
      );
      return;
    }

    const saveButton =
      accessForm.querySelector(
        '[data-aa-save-access]'
      );

    if (saveButton) {
      saveButton.disabled = true;
      saveButton.textContent =
        'Saving Access...';
    }

    try {
      const result =
        await window.AAPlaybookService
          .saveClientAccessRequirements({
            clientId,
            access
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to save account access.'
          )
        );
      }

      this.editingAccessClientId = null;

      await this.loadActiveClientAccess();

      this.render();

      this.showStatusMessage(
        'Account access saved.'
      );
    } catch (error) {
      console.error(
        'Error saving account access:',
        error
      );

      alert(
        `Supabase request failed: ${
          error?.message ||
          'Unable to save account access.'
        }`
      );

      if (saveButton) {
        saveButton.disabled = false;
        saveButton.textContent =
          'Save Access';
      }
    }

    return;
  }

  const packageForm =
    event.target.closest(
      '[data-aa-package-form]'
    );

  if (packageForm) {
    event.preventDefault();

    const clientId =
      packageForm.dataset
        .aaPackageForm;

    if (
      !clientId ||
      !window.AAPlaybookService
        ?.saveClientMarketingPackage
    ) {
      return;
    }

    const services = [
      ...packageForm.querySelectorAll(
        '[data-aa-package-service-row]'
      )
    ]
      .filter((row) =>
        row.querySelector(
          '[data-aa-package-include]'
        )?.checked
      )
      .map((row) => {
        const include =
          row.querySelector(
            '[data-aa-package-include]'
          );

        return {
          serviceCatalogId:
            include?.dataset
              .aaPackageServiceId || '',
          quantity:
            Number(
              row.querySelector(
                '[data-aa-package-quantity]'
              )?.value || 0
            ),
          unitLabel:
            row.querySelector(
              '[data-aa-package-unit]'
            )?.value || 'per month',
          notes:
            row.querySelector(
              '[data-aa-package-notes]'
            )?.value.trim() || '',
          customName:
            row.querySelector(
              '[data-aa-package-custom-name]'
            )?.value.trim() || '',
          displayOrder:
            Number(
              row.querySelector(
                '[data-aa-package-display-order]'
              )?.value || 0
            )
        };
      });

    const missingCustomName =
      [
        ...packageForm.querySelectorAll(
          '[data-aa-package-service-row]'
        )
      ].some((row) => {
        const customName =
          row.querySelector(
            '[data-aa-package-custom-name]'
          );

        const included =
          row.querySelector(
            '[data-aa-package-include]'
          )?.checked;

        return (
          included &&
          customName &&
          !customName.value.trim()
        );
      });

    if (missingCustomName) {
      alert(
        'Name the custom recurring deliverable before saving.'
      );
      return;
    }

    const scheduleForLater = packageForm.querySelector(
      '[data-aa-package-effective-mode][value="scheduled"]'
    )?.checked === true;
    const today = this.formatPackageDate();
    const effectiveDate = scheduleForLater
      ? packageForm.querySelector('[data-aa-package-effective-date]')?.value || ''
      : today;

    if (scheduleForLater && (!effectiveDate || effectiveDate <= today)) {
      alert('Choose a future date, or select Effective Immediately.');
      return;
    }

    const saveButton =
      packageForm.querySelector(
        '[data-aa-save-package]'
      );

    if (saveButton) {
      saveButton.disabled = true;
      saveButton.textContent =
        'Saving Package...';
    }

    try {
      const result =
        await window.AAPlaybookService
          .saveClientMarketingPackage({
            clientId,
            services,
            effectiveDate
          });

      if (!result?.success) {
        throw (
          result?.error ||
          new Error(
            'Unable to save package.'
          )
        );
      }

      this.editingPackageClientId = null;

      await this.loadActiveClientPackage();

      this.render();

      this.showStatusMessage(
        result?.scheduled
          ? `Package change scheduled for ${result.effectiveDate}.`
          : `Marketing package updated effective ${result?.effectiveDate || effectiveDate}.`
      );
    } catch (error) {
      console.error(
        'Error saving marketing package:',
        error
      );

      alert(
        `Supabase request failed: ${
          error?.message ||
          'Unable to save package.'
        }`
      );

      if (saveButton) {
        saveButton.disabled = false;
        saveButton.textContent =
          'Save Package';
      }
    }

    return;
  }

  const catalogForm =
    event.target.closest('[data-aa-catalog-form]');

  if (catalogForm) {
    event.preventDefault();

    const clientId =
      catalogForm.dataset
        .aaCatalogForm;

    const editingCatalogId =
      catalogForm.dataset
        .aaCatalogEditId ||
      null;

    const isEditing =
      Boolean(editingCatalogId);

    const client =
      this.clients.find(
        (item) =>
          String(item.id) ===
          String(clientId)
      );

    if (!client) {
      return;
    }

    const existingCatalog =
      isEditing
        ? this.getCatalogRecords(client)
            .find(
              (catalog) =>
                String(catalog.id) ===
                String(editingCatalogId)
            ) || null
        : null;

    const getField = (name) =>
      catalogForm.querySelector(
        `[data-aa-catalog-field="${name}"]`
      );

    const catalogMonth =
      getField('catalogMonth')?.value ||
      '';

    const normalizedMonth =
      catalogMonth
        ? `${catalogMonth}-01`
        : '';

    const catalogTitle =
      existingCatalog?.catalog_title ||
      (
        normalizedMonth
          ? `${this.formatCatalogMonth(normalizedMonth)} Catalog`
          : 'Catalog'
      );

    const publicationDate =
      normalizedMonth || null;

    const catalogUrl =
      existingCatalog?.catalog_url || '';

    const catalogViewsRaw =
      getField('catalogViews')
        ?.value.trim() ||
      '';

    const pdfFile =
      catalogForm
        .querySelector(
          '[data-aa-catalog-pdf]'
        )
        ?.files?.[0] ||
      null;

    const selectedBrands = [
      ...catalogForm.querySelectorAll(
        '[data-aa-catalog-brand]:checked'
      )
    ].map(
      (input) =>
        input.value.trim()
    );

    const additionalBrands =
      (
        catalogForm.querySelector(
          '[data-aa-catalog-additional-brands]'
        )?.value ||
        ''
      )
        .split(',')
        .map(
          (brand) =>
            brand.trim()
        )
        .filter(Boolean);

    const brands = [
      ...new Set([
        ...selectedBrands,
        ...additionalBrands
      ])
    ];

    if (!catalogMonth) {
      alert(
        'Catalog Month is required.'
      );
      return;
    }

    if (
      !isEditing &&
      !pdfFile
    ) {
      alert(
        'Please upload the catalog PDF.'
      );
      return;
    }

    const duplicate =
      this.getCatalogRecords(client)
        .find(
          (catalog) =>
            String(
              catalog.catalog_month
            ) ===
              String(
                normalizedMonth
              ) &&
            String(catalog.id) !==
              String(
                editingCatalogId ||
                ''
              )
        );

    if (duplicate) {
      alert(
        'An active catalog already exists for this client and month. Edit the existing catalog instead.'
      );
      return;
    }

    const catalogViews =
      catalogViewsRaw === ''
        ? null
        : Number(
            catalogViewsRaw
          );

    if (
      catalogViews !== null &&
      (
        !Number.isInteger(
          catalogViews
        ) ||
        catalogViews < 0
      )
    ) {
      alert(
        'Catalog Views must be a whole number of 0 or greater.'
      );
      return;
    }

    const submitButton =
      catalogForm.querySelector(
        '[data-aa-save-catalog]'
      );

    if (submitButton) {
      submitButton.disabled =
        true;
      submitButton.textContent =
        'Saving Catalog...';
    }

    let uploadedPdf = null;
    let uploadedCover = null;
    let catalogSaved = false;

    try {
      let coverImageUrl =
        null;

      if (pdfFile) {
        uploadedPdf =
          await window.AASupabaseClient
            .uploadCatalogPdf({
              clientId,
              file: pdfFile
            });

        uploadedCover =
          await this
            .createCatalogCoverFromPdf({
              clientId,
              file: pdfFile
            });

        coverImageUrl =
          uploadedCover.publicUrl;
      }

      if (isEditing) {
        const updates = {
          catalogMonth,
          catalogTitle,
          publicationDate,
          catalogUrl,
          catalogViews,
          brands
        };

        if (coverImageUrl) {
          updates.coverImageUrl =
            coverImageUrl;
        }

        if (uploadedPdf) {
          updates.catalogPdfStoragePath =
            uploadedPdf.path;
          updates.catalogPdfFileName =
            uploadedPdf.fileName;
          updates.catalogPdfFileSize =
            uploadedPdf.fileSize;
          updates.catalogPdfUploadedAt =
            new Date().toISOString();
        }

        const updatedCatalog =
          await window.AASupabaseClient
            .updateCatalogRecord({
              id:
                editingCatalogId,
              updates
            });

        if (!updatedCatalog?.id) {
          throw new Error(
            'Supabase did not return the updated catalog record.'
          );
        }

        catalogSaved = true;

        if (
          uploadedPdf &&
          existingCatalog
            ?.catalog_pdf_storage_path &&
          existingCatalog
            .catalog_pdf_storage_path !==
            uploadedPdf.path
        ) {
          await window.AASupabaseClient
            .deleteCatalogPdf({
              path:
                existingCatalog
                  .catalog_pdf_storage_path
            })
            .catch(
              (error) =>
                console.warn(
                  'Old catalog PDF could not be removed:',
                  error
                )
            );
        }
      } else {
        const createdCatalog =
          await window.AASupabaseClient
            .createCatalogRecord({
              clientId,
              catalogMonth,
              catalogTitle,
              publicationDate,
              catalogUrl,
              coverImageUrl,
              catalogViews,
              brands,
              catalogPdfStoragePath:
                uploadedPdf?.path ||
                '',
              catalogPdfFileName:
                uploadedPdf?.fileName ||
                '',
              catalogPdfFileSize:
                uploadedPdf?.fileSize ||
                null
            });

        if (!createdCatalog?.id) {
          throw new Error(
            'Supabase did not return the new catalog record.'
          );
        }
        catalogSaved = true;
      }

      this.addingCatalogClientId =
        null;
      this.editingCatalogId =
        null;
      this.activeClientId =
        clientId;

      // Refresh only the edited client's catalog history.
      // Reloading every client previously repeated configuration, template,
      // and catalog requests for the entire directory.
      try {
        const refreshedCatalogs = await window.AASupabaseClient
          .getCatalogRecords({ clientId });
        if (!Array.isArray(refreshedCatalogs)) {
          throw new Error('Catalog history returned an invalid response.');
        }
        client.catalog_records = refreshedCatalogs;
      } catch (refreshError) {
        console.warn('Catalog saved; history refresh failed:', refreshError);
        this.render();
        this.showStatusMessage(
          'Catalog saved, but the history could not refresh. Reload the page.',
          'error'
        );
        return;
      }

      this.render();
      this.showStatusMessage(
        isEditing
          ? 'Catalog updated.'
          : 'Catalog added.'
      );
    } catch (error) {
      console.error(
        'Error saving catalog:',
        error
      );

      // A successful database write must never lose its newly linked PDF
      // if a later optional cleanup/refresh fails.
      if (!catalogSaved && uploadedPdf?.path) {
        await window.AASupabaseClient
          .deleteCatalogPdf({
            path:
              uploadedPdf.path
          })
          .catch(() => {});
      }

      if (
        error?.code ===
        'AA_DUPLICATE_CATALOG_MONTH'
      ) {
        alert(
          'An active catalog already exists for this client and month. Edit the existing catalog instead.'
        );
      } else {
        alert(
          `Supabase request failed: ${
            error?.message ||
            'Unable to save catalog.'
          }`
        );
      }

      if (submitButton) {
        submitButton.disabled =
          false;
        submitButton.textContent =
          isEditing
            ? 'Save Changes'
            : 'Save Catalog';
      }
    }

    return;
  }

  const form =
    event.target.closest('[data-aa-client-edit-panel]');

  if (!form) return;

  event.preventDefault();

  const clientId = form.dataset.aaClientEditPanel;
  const client = this.clients.find(
    (item) => String(item.id) === String(clientId)
  );

  if (!client) return;

  const submitButton = form.querySelector('[data-aa-save-client-edit]');
  const updatedClient = { ...client };

 form.querySelectorAll('[data-aa-edit-client-field]').forEach((field) => {
  const key = field.dataset.aaEditClientField;

  if (
    key === 'services'
  ) {
    updatedClient[key] = field.value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  } else {
    updatedClient[key] = field.value.trim();
  }
});

const emailAccessField =
  form.querySelector('[data-aa-edit-client-email-access]');


const primaryTeamField =
  form.querySelector('[data-aa-edit-client-primary-team]');

updatedClient.primary_team_member_id =
  primaryTeamField?.value || '';

const preservedLegacyAccess =
  Array.isArray(client.access)
    ? client.access
    : [];

updatedClient.access = this.setEmailAccess(
  preservedLegacyAccess,
  emailAccessField?.value === 'on'
);

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Saving Client...';
  }

  try {
    const latestConfiguration =
      (await window.AASupabaseClient.getClientConfiguration({
        clientId
      })) || {};

    await window.AASupabaseClient.updateClient({
      clientId,
      updates: {
        business_name: updatedClient.business_name,
        client_code:
          this.clientCodeEnabled
            ? (
                updatedClient.client_code
                  ? updatedClient.client_code.toUpperCase()
                  : null
              )
            : undefined,
        primary_contact: updatedClient.primary_contact,
        email: updatedClient.email,
        phone: updatedClient.phone,
        active_status: updatedClient.active_status
      }
    });

    const mergedConfiguration = {
  ...latestConfiguration,
  primary_contact: updatedClient.primary_contact,
  email: updatedClient.email,
  phone: updatedClient.phone,
  mailing_address: updatedClient.mailing_address,
  current_package: updatedClient.current_package,
  client_type: updatedClient.client_type,
  contract_status: updatedClient.contract_status,
  invoice_status: updatedClient.invoice_status,
      services: updatedClient.services,
      brands:
        latestConfiguration.brands ||
        client.brands ||
        [],
      access: updatedClient.access,
      reminder_schedule: updatedClient.reminder_schedule,
      reminder_email_template: updatedClient.reminder_email_template,
      reminder_status: updatedClient.reminder_status,
      next_scheduled_reminder: updatedClient.next_scheduled_reminder,
      monthly_due_day: updatedClient.monthly_due_day,
      internal_notes: updatedClient.notes,
      assigned_templates:
        latestConfiguration.assigned_templates ||
        updatedClient.assigned_templates ||
        []
    };

    await window.AASupabaseClient.saveClientConfiguration({
      clientId,
      configuration: mergedConfiguration
    });

    if (
      this.clientAssignmentEnabled &&
      window.AASupabaseClient?.updateClientPrimaryTeamMember &&
      String(updatedClient.primary_team_member_id || '') !==
        String(client.primary_team_member_id || '')
    ) {
      await window.AASupabaseClient.updateClientPrimaryTeamMember({
        clientId,
        teamMemberId:
          updatedClient.primary_team_member_id || null
      });
    }

    this.activeClientId = clientId;
    this.editingClientId = null;

    // Update only the edited client; do not refetch the entire directory.
    const localIndex = this.clients.findIndex(item => String(item.id) === String(clientId));
    if (localIndex !== -1) {
      this.clients[localIndex] = this.normalizeClient({
        ...this.clients[localIndex],
        ...updatedClient,
        ...mergedConfiguration,
        id: clientId
      });
    }
    this.activeClientId = clientId;
    this.render();
    this.showStatusMessage('Client saved.');
  } catch (error) {
    console.error('Error saving client:', error);

    alert(
      `Supabase request failed: ${
        error?.message || 'Unable to save client.'
      }`
    );
  } finally {
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = 'Save Client';
    }
  }
});
  }
}

window.AAHeadquartersClients = AAHeadquartersClients;